export let addressJson = [
    {
        "value": "110000",
        "label": "北京",
        "children": [
            {
                "value": "110100",
                "label": "北京市",
                "parent": "110000",
                "children": [
                    {
                        "label": "东城区",
                        "value": "110101",
                        "parent": "110100"
                    },
                    {
                        "label": "西城区",
                        "value": "110102",
                        "parent": "110100"
                    },
                    {
                        "label": "朝阳区",
                        "value": "110105",
                        "parent": "110100"
                    },
                    {
                        "label": "丰台区",
                        "value": "110106",
                        "parent": "110100"
                    },
                    {
                        "label": "石景山区",
                        "value": "110107",
                        "parent": "110100"
                    },
                    {
                        "label": "海淀区",
                        "value": "110108",
                        "parent": "110100"
                    },
                    {
                        "label": "门头沟区",
                        "value": "110109",
                        "parent": "110100"
                    },
                    {
                        "label": "房山区",
                        "value": "110111",
                        "parent": "110100"
                    },
                    {
                        "label": "通州区",
                        "value": "110112",
                        "parent": "110100"
                    },
                    {
                        "label": "顺义区",
                        "value": "110113",
                        "parent": "110100"
                    },
                    {
                        "label": "昌平区",
                        "value": "110114",
                        "parent": "110100"
                    },
                    {
                        "label": "大兴区",
                        "value": "110115",
                        "parent": "110100"
                    },
                    {
                        "label": "怀柔区",
                        "value": "110116",
                        "parent": "110100"
                    },
                    {
                        "label": "平谷区",
                        "value": "110117",
                        "parent": "110100"
                    },
                    {
                        "label": "密云区",
                        "value": "110118",
                        "parent": "110100"
                    },
                    {
                        "label": "延庆区",
                        "value": "110119",
                        "parent": "110100"
                    }
                ]
            }
        ]
    },
    {
        "value": "120000",
        "label": "天津",
        "children": [
            {
                "value": "120100",
                "label": "天津市",
                "parent": "120000",
                "children": [
                    {
                        "label": "和平区",
                        "value": "120101",
                        "parent": "120100"
                    },
                    {
                        "label": "河东区",
                        "value": "120102",
                        "parent": "120100"
                    },
                    {
                        "label": "河西区",
                        "value": "120103",
                        "parent": "120100"
                    },
                    {
                        "label": "南开区",
                        "value": "120104",
                        "parent": "120100"
                    },
                    {
                        "label": "河北区",
                        "value": "120105",
                        "parent": "120100"
                    },
                    {
                        "label": "红桥区",
                        "value": "120106",
                        "parent": "120100"
                    },
                    {
                        "label": "东丽区",
                        "value": "120110",
                        "parent": "120100"
                    },
                    {
                        "label": "西青区",
                        "value": "120111",
                        "parent": "120100"
                    },
                    {
                        "label": "津南区",
                        "value": "120112",
                        "parent": "120100"
                    },
                    {
                        "label": "北辰区",
                        "value": "120113",
                        "parent": "120100"
                    },
                    {
                        "label": "武清区",
                        "value": "120114",
                        "parent": "120100"
                    },
                    {
                        "label": "宝坻区",
                        "value": "120115",
                        "parent": "120100"
                    },
                    {
                        "label": "滨海新区",
                        "value": "120116",
                        "parent": "120100"
                    },
                    {
                        "label": "宁河区",
                        "value": "120117",
                        "parent": "120100"
                    },
                    {
                        "label": "静海区",
                        "value": "120118",
                        "parent": "120100"
                    },
                    {
                        "label": "蓟州区",
                        "value": "120119",
                        "parent": "120100"
                    }
                ]
            }
        ]
    },
    {
        "value": "130000",
        "label": "河北省",
        "children": [
            {
                "value": "130100",
                "label": "石家庄市",
                "parent": "130000",
                "children": [
                    {
                        "label": "长安区",
                        "value": "130102",
                        "parent": "130100"
                    },
                    {
                        "label": "桥西区",
                        "value": "130104",
                        "parent": "130100"
                    },
                    {
                        "label": "新华区",
                        "value": "130105",
                        "parent": "130100"
                    },
                    {
                        "label": "井陉矿区",
                        "value": "130107",
                        "parent": "130100"
                    },
                    {
                        "label": "裕华区",
                        "value": "130108",
                        "parent": "130100"
                    },
                    {
                        "label": "藁城区",
                        "value": "130109",
                        "parent": "130100"
                    },
                    {
                        "label": "鹿泉区",
                        "value": "130110",
                        "parent": "130100"
                    },
                    {
                        "label": "栾城区",
                        "value": "130111",
                        "parent": "130100"
                    },
                    {
                        "label": "井陉县",
                        "value": "130121",
                        "parent": "130100"
                    },
                    {
                        "label": "正定县",
                        "value": "130123",
                        "parent": "130100"
                    },
                    {
                        "label": "行唐县",
                        "value": "130125",
                        "parent": "130100"
                    },
                    {
                        "label": "灵寿县",
                        "value": "130126",
                        "parent": "130100"
                    },
                    {
                        "label": "高邑县",
                        "value": "130127",
                        "parent": "130100"
                    },
                    {
                        "label": "深泽县",
                        "value": "130128",
                        "parent": "130100"
                    },
                    {
                        "label": "赞皇县",
                        "value": "130129",
                        "parent": "130100"
                    },
                    {
                        "label": "无极县",
                        "value": "130130",
                        "parent": "130100"
                    },
                    {
                        "label": "平山县",
                        "value": "130131",
                        "parent": "130100"
                    },
                    {
                        "label": "元氏县",
                        "value": "130132",
                        "parent": "130100"
                    },
                    {
                        "label": "赵县",
                        "value": "130133",
                        "parent": "130100"
                    },
                    {
                        "label": "石家庄高新技术产业开发区",
                        "value": "130171",
                        "parent": "130100"
                    },
                    {
                        "label": "石家庄循环化工园区",
                        "value": "130172",
                        "parent": "130100"
                    },
                    {
                        "label": "辛集市",
                        "value": "130181",
                        "parent": "130100"
                    },
                    {
                        "label": "晋州市",
                        "value": "130183",
                        "parent": "130100"
                    },
                    {
                        "label": "新乐市",
                        "value": "130184",
                        "parent": "130100"
                    }
                ]
            },
            {
                "value": "130200",
                "label": "唐山市",
                "parent": "130000",
                "children": [
                    {
                        "label": "路南区",
                        "value": "130202",
                        "parent": "130200"
                    },
                    {
                        "label": "路北区",
                        "value": "130203",
                        "parent": "130200"
                    },
                    {
                        "label": "古冶区",
                        "value": "130204",
                        "parent": "130200"
                    },
                    {
                        "label": "开平区",
                        "value": "130205",
                        "parent": "130200"
                    },
                    {
                        "label": "丰南区",
                        "value": "130207",
                        "parent": "130200"
                    },
                    {
                        "label": "丰润区",
                        "value": "130208",
                        "parent": "130200"
                    },
                    {
                        "label": "曹妃甸区",
                        "value": "130209",
                        "parent": "130200"
                    },
                    {
                        "label": "滦南县",
                        "value": "130224",
                        "parent": "130200"
                    },
                    {
                        "label": "乐亭县",
                        "value": "130225",
                        "parent": "130200"
                    },
                    {
                        "label": "迁西县",
                        "value": "130227",
                        "parent": "130200"
                    },
                    {
                        "label": "玉田县",
                        "value": "130229",
                        "parent": "130200"
                    },
                    {
                        "label": "唐山高新技术产业开发区",
                        "value": "130273",
                        "parent": "130200"
                    },
                    {
                        "label": "河北唐山海港经济开发区",
                        "value": "130274",
                        "parent": "130200"
                    },
                    {
                        "label": "遵化市",
                        "value": "130281",
                        "parent": "130200"
                    },
                    {
                        "label": "迁安市",
                        "value": "130283",
                        "parent": "130200"
                    },
                    {
                        "label": "滦州市",
                        "value": "130284",
                        "parent": "130200"
                    }
                ]
            },
            {
                "value": "130300",
                "label": "秦皇岛市",
                "parent": "130000",
                "children": [
                    {
                        "label": "海港区",
                        "value": "130302",
                        "parent": "130300"
                    },
                    {
                        "label": "山海关区",
                        "value": "130303",
                        "parent": "130300"
                    },
                    {
                        "label": "北戴河区",
                        "value": "130304",
                        "parent": "130300"
                    },
                    {
                        "label": "抚宁区",
                        "value": "130306",
                        "parent": "130300"
                    },
                    {
                        "label": "青龙满族自治县",
                        "value": "130321",
                        "parent": "130300"
                    },
                    {
                        "label": "昌黎县",
                        "value": "130322",
                        "parent": "130300"
                    },
                    {
                        "label": "卢龙县",
                        "value": "130324",
                        "parent": "130300"
                    },
                    {
                        "label": "秦皇岛市经济技术开发区",
                        "value": "130371",
                        "parent": "130300"
                    },
                    {
                        "label": "北戴河新区",
                        "value": "130372",
                        "parent": "130300"
                    },
                    {
                        "label": "经济技术开发区",
                        "value": "130390",
                        "parent": "130300"
                    }
                ]
            },
            {
                "value": "130400",
                "label": "邯郸市",
                "parent": "130000",
                "children": [
                    {
                        "label": "邯山区",
                        "value": "130402",
                        "parent": "130400"
                    },
                    {
                        "label": "丛台区",
                        "value": "130403",
                        "parent": "130400"
                    },
                    {
                        "label": "复兴区",
                        "value": "130404",
                        "parent": "130400"
                    },
                    {
                        "label": "峰峰矿区",
                        "value": "130406",
                        "parent": "130400"
                    },
                    {
                        "label": "肥乡区",
                        "value": "130407",
                        "parent": "130400"
                    },
                    {
                        "label": "永年区",
                        "value": "130408",
                        "parent": "130400"
                    },
                    {
                        "label": "临漳县",
                        "value": "130423",
                        "parent": "130400"
                    },
                    {
                        "label": "成安县",
                        "value": "130424",
                        "parent": "130400"
                    },
                    {
                        "label": "大名县",
                        "value": "130425",
                        "parent": "130400"
                    },
                    {
                        "label": "涉县",
                        "value": "130426",
                        "parent": "130400"
                    },
                    {
                        "label": "磁县",
                        "value": "130427",
                        "parent": "130400"
                    },
                    {
                        "label": "邱县",
                        "value": "130430",
                        "parent": "130400"
                    },
                    {
                        "label": "鸡泽县",
                        "value": "130431",
                        "parent": "130400"
                    },
                    {
                        "label": "广平县",
                        "value": "130432",
                        "parent": "130400"
                    },
                    {
                        "label": "馆陶县",
                        "value": "130433",
                        "parent": "130400"
                    },
                    {
                        "label": "魏县",
                        "value": "130434",
                        "parent": "130400"
                    },
                    {
                        "label": "曲周县",
                        "value": "130435",
                        "parent": "130400"
                    },
                    {
                        "label": "邯郸经济技术开发区",
                        "value": "130471",
                        "parent": "130400"
                    },
                    {
                        "label": "邯郸冀南新区",
                        "value": "130473",
                        "parent": "130400"
                    },
                    {
                        "label": "武安市",
                        "value": "130481",
                        "parent": "130400"
                    }
                ]
            },
            {
                "value": "130500",
                "label": "邢台市",
                "parent": "130000",
                "children": [
                    {
                        "label": "襄都区",
                        "value": "130502",
                        "parent": "130500"
                    },
                    {
                        "label": "信都区",
                        "value": "130503",
                        "parent": "130500"
                    },
                    {
                        "label": "任泽区",
                        "value": "130505",
                        "parent": "130500"
                    },
                    {
                        "label": "南和区",
                        "value": "130506",
                        "parent": "130500"
                    },
                    {
                        "label": "临城县",
                        "value": "130522",
                        "parent": "130500"
                    },
                    {
                        "label": "内丘县",
                        "value": "130523",
                        "parent": "130500"
                    },
                    {
                        "label": "柏乡县",
                        "value": "130524",
                        "parent": "130500"
                    },
                    {
                        "label": "隆尧县",
                        "value": "130525",
                        "parent": "130500"
                    },
                    {
                        "label": "宁晋县",
                        "value": "130528",
                        "parent": "130500"
                    },
                    {
                        "label": "巨鹿县",
                        "value": "130529",
                        "parent": "130500"
                    },
                    {
                        "label": "新河县",
                        "value": "130530",
                        "parent": "130500"
                    },
                    {
                        "label": "广宗县",
                        "value": "130531",
                        "parent": "130500"
                    },
                    {
                        "label": "平乡县",
                        "value": "130532",
                        "parent": "130500"
                    },
                    {
                        "label": "威县",
                        "value": "130533",
                        "parent": "130500"
                    },
                    {
                        "label": "清河县",
                        "value": "130534",
                        "parent": "130500"
                    },
                    {
                        "label": "临西县",
                        "value": "130535",
                        "parent": "130500"
                    },
                    {
                        "label": "河北邢台经济开发区",
                        "value": "130571",
                        "parent": "130500"
                    },
                    {
                        "label": "南宫市",
                        "value": "130581",
                        "parent": "130500"
                    },
                    {
                        "label": "沙河市",
                        "value": "130582",
                        "parent": "130500"
                    }
                ]
            },
            {
                "value": "130600",
                "label": "保定市",
                "parent": "130000",
                "children": [
                    {
                        "label": "竞秀区",
                        "value": "130602",
                        "parent": "130600"
                    },
                    {
                        "label": "莲池区",
                        "value": "130606",
                        "parent": "130600"
                    },
                    {
                        "label": "满城区",
                        "value": "130607",
                        "parent": "130600"
                    },
                    {
                        "label": "清苑区",
                        "value": "130608",
                        "parent": "130600"
                    },
                    {
                        "label": "徐水区",
                        "value": "130609",
                        "parent": "130600"
                    },
                    {
                        "label": "涞水县",
                        "value": "130623",
                        "parent": "130600"
                    },
                    {
                        "label": "阜平县",
                        "value": "130624",
                        "parent": "130600"
                    },
                    {
                        "label": "定兴县",
                        "value": "130626",
                        "parent": "130600"
                    },
                    {
                        "label": "唐县",
                        "value": "130627",
                        "parent": "130600"
                    },
                    {
                        "label": "高阳县",
                        "value": "130628",
                        "parent": "130600"
                    },
                    {
                        "label": "容城县",
                        "value": "130629",
                        "parent": "130600"
                    },
                    {
                        "label": "涞源县",
                        "value": "130630",
                        "parent": "130600"
                    },
                    {
                        "label": "望都县",
                        "value": "130631",
                        "parent": "130600"
                    },
                    {
                        "label": "安新县",
                        "value": "130632",
                        "parent": "130600"
                    },
                    {
                        "label": "易县",
                        "value": "130633",
                        "parent": "130600"
                    },
                    {
                        "label": "曲阳县",
                        "value": "130634",
                        "parent": "130600"
                    },
                    {
                        "label": "蠡县",
                        "value": "130635",
                        "parent": "130600"
                    },
                    {
                        "label": "顺平县",
                        "value": "130636",
                        "parent": "130600"
                    },
                    {
                        "label": "博野县",
                        "value": "130637",
                        "parent": "130600"
                    },
                    {
                        "label": "雄县",
                        "value": "130638",
                        "parent": "130600"
                    },
                    {
                        "label": "保定高新技术产业开发区",
                        "value": "130671",
                        "parent": "130600"
                    },
                    {
                        "label": "保定白沟新城",
                        "value": "130672",
                        "parent": "130600"
                    },
                    {
                        "label": "涿州市",
                        "value": "130681",
                        "parent": "130600"
                    },
                    {
                        "label": "定州市",
                        "value": "130682",
                        "parent": "130600"
                    },
                    {
                        "label": "安国市",
                        "value": "130683",
                        "parent": "130600"
                    },
                    {
                        "label": "高碑店市",
                        "value": "130684",
                        "parent": "130600"
                    }
                ]
            },
            {
                "value": "130700",
                "label": "张家口市",
                "parent": "130000",
                "children": [
                    {
                        "label": "桥东区",
                        "value": "130702",
                        "parent": "130700"
                    },
                    {
                        "label": "桥西区",
                        "value": "130703",
                        "parent": "130700"
                    },
                    {
                        "label": "宣化区",
                        "value": "130705",
                        "parent": "130700"
                    },
                    {
                        "label": "下花园区",
                        "value": "130706",
                        "parent": "130700"
                    },
                    {
                        "label": "万全区",
                        "value": "130708",
                        "parent": "130700"
                    },
                    {
                        "label": "崇礼区",
                        "value": "130709",
                        "parent": "130700"
                    },
                    {
                        "label": "张北县",
                        "value": "130722",
                        "parent": "130700"
                    },
                    {
                        "label": "康保县",
                        "value": "130723",
                        "parent": "130700"
                    },
                    {
                        "label": "沽源县",
                        "value": "130724",
                        "parent": "130700"
                    },
                    {
                        "label": "尚义县",
                        "value": "130725",
                        "parent": "130700"
                    },
                    {
                        "label": "蔚县",
                        "value": "130726",
                        "parent": "130700"
                    },
                    {
                        "label": "阳原县",
                        "value": "130727",
                        "parent": "130700"
                    },
                    {
                        "label": "怀安县",
                        "value": "130728",
                        "parent": "130700"
                    },
                    {
                        "label": "怀来县",
                        "value": "130730",
                        "parent": "130700"
                    },
                    {
                        "label": "涿鹿县",
                        "value": "130731",
                        "parent": "130700"
                    },
                    {
                        "label": "赤城县",
                        "value": "130732",
                        "parent": "130700"
                    },
                    {
                        "label": "张家口市察北管理区",
                        "value": "130772",
                        "parent": "130700"
                    }
                ]
            },
            {
                "value": "130800",
                "label": "承德市",
                "parent": "130000",
                "children": [
                    {
                        "label": "双桥区",
                        "value": "130802",
                        "parent": "130800"
                    },
                    {
                        "label": "双滦区",
                        "value": "130803",
                        "parent": "130800"
                    },
                    {
                        "label": "鹰手营子矿区",
                        "value": "130804",
                        "parent": "130800"
                    },
                    {
                        "label": "承德县",
                        "value": "130821",
                        "parent": "130800"
                    },
                    {
                        "label": "兴隆县",
                        "value": "130822",
                        "parent": "130800"
                    },
                    {
                        "label": "滦平县",
                        "value": "130824",
                        "parent": "130800"
                    },
                    {
                        "label": "隆化县",
                        "value": "130825",
                        "parent": "130800"
                    },
                    {
                        "label": "丰宁满族自治县",
                        "value": "130826",
                        "parent": "130800"
                    },
                    {
                        "label": "宽城满族自治县",
                        "value": "130827",
                        "parent": "130800"
                    },
                    {
                        "label": "围场满族蒙古族自治县",
                        "value": "130828",
                        "parent": "130800"
                    },
                    {
                        "label": "承德高新技术产业开发区",
                        "value": "130871",
                        "parent": "130800"
                    },
                    {
                        "label": "平泉市",
                        "value": "130881",
                        "parent": "130800"
                    }
                ]
            },
            {
                "value": "130900",
                "label": "沧州市",
                "parent": "130000",
                "children": [
                    {
                        "label": "新华区",
                        "value": "130902",
                        "parent": "130900"
                    },
                    {
                        "label": "运河区",
                        "value": "130903",
                        "parent": "130900"
                    },
                    {
                        "label": "沧县",
                        "value": "130921",
                        "parent": "130900"
                    },
                    {
                        "label": "青县",
                        "value": "130922",
                        "parent": "130900"
                    },
                    {
                        "label": "东光县",
                        "value": "130923",
                        "parent": "130900"
                    },
                    {
                        "label": "海兴县",
                        "value": "130924",
                        "parent": "130900"
                    },
                    {
                        "label": "盐山县",
                        "value": "130925",
                        "parent": "130900"
                    },
                    {
                        "label": "肃宁县",
                        "value": "130926",
                        "parent": "130900"
                    },
                    {
                        "label": "南皮县",
                        "value": "130927",
                        "parent": "130900"
                    },
                    {
                        "label": "吴桥县",
                        "value": "130928",
                        "parent": "130900"
                    },
                    {
                        "label": "献县",
                        "value": "130929",
                        "parent": "130900"
                    },
                    {
                        "label": "孟村回族自治县",
                        "value": "130930",
                        "parent": "130900"
                    },
                    {
                        "label": "河北沧州经济开发区",
                        "value": "130971",
                        "parent": "130900"
                    },
                    {
                        "label": "沧州高新技术产业开发区",
                        "value": "130972",
                        "parent": "130900"
                    },
                    {
                        "label": "沧州渤海新区",
                        "value": "130973",
                        "parent": "130900"
                    },
                    {
                        "label": "泊头市",
                        "value": "130981",
                        "parent": "130900"
                    },
                    {
                        "label": "任丘市",
                        "value": "130982",
                        "parent": "130900"
                    },
                    {
                        "label": "黄骅市",
                        "value": "130983",
                        "parent": "130900"
                    },
                    {
                        "label": "河间市",
                        "value": "130984",
                        "parent": "130900"
                    }
                ]
            },
            {
                "value": "131000",
                "label": "廊坊市",
                "parent": "130000",
                "children": [
                    {
                        "label": "安次区",
                        "value": "131002",
                        "parent": "131000"
                    },
                    {
                        "label": "广阳区",
                        "value": "131003",
                        "parent": "131000"
                    },
                    {
                        "label": "固安县",
                        "value": "131022",
                        "parent": "131000"
                    },
                    {
                        "label": "永清县",
                        "value": "131023",
                        "parent": "131000"
                    },
                    {
                        "label": "香河县",
                        "value": "131024",
                        "parent": "131000"
                    },
                    {
                        "label": "大城县",
                        "value": "131025",
                        "parent": "131000"
                    },
                    {
                        "label": "文安县",
                        "value": "131026",
                        "parent": "131000"
                    },
                    {
                        "label": "大厂回族自治县",
                        "value": "131028",
                        "parent": "131000"
                    },
                    {
                        "label": "廊坊经济技术开发区",
                        "value": "131071",
                        "parent": "131000"
                    },
                    {
                        "label": "霸州市",
                        "value": "131081",
                        "parent": "131000"
                    },
                    {
                        "label": "三河市",
                        "value": "131082",
                        "parent": "131000"
                    },
                    {
                        "label": "开发区",
                        "value": "131090",
                        "parent": "131000"
                    }
                ]
            },
            {
                "value": "131100",
                "label": "衡水市",
                "parent": "130000",
                "children": [
                    {
                        "label": "桃城区",
                        "value": "131102",
                        "parent": "131100"
                    },
                    {
                        "label": "冀州区",
                        "value": "131103",
                        "parent": "131100"
                    },
                    {
                        "label": "枣强县",
                        "value": "131121",
                        "parent": "131100"
                    },
                    {
                        "label": "武邑县",
                        "value": "131122",
                        "parent": "131100"
                    },
                    {
                        "label": "武强县",
                        "value": "131123",
                        "parent": "131100"
                    },
                    {
                        "label": "饶阳县",
                        "value": "131124",
                        "parent": "131100"
                    },
                    {
                        "label": "安平县",
                        "value": "131125",
                        "parent": "131100"
                    },
                    {
                        "label": "故城县",
                        "value": "131126",
                        "parent": "131100"
                    },
                    {
                        "label": "景县",
                        "value": "131127",
                        "parent": "131100"
                    },
                    {
                        "label": "阜城县",
                        "value": "131128",
                        "parent": "131100"
                    },
                    {
                        "label": "河北衡水经济开发区",
                        "value": "131171",
                        "parent": "131100"
                    },
                    {
                        "label": "衡水滨湖新区",
                        "value": "131172",
                        "parent": "131100"
                    },
                    {
                        "label": "深州市",
                        "value": "131182",
                        "parent": "131100"
                    }
                ]
            }
        ]
    },
    {
        "value": "140000",
        "label": "山西省",
        "children": [
            {
                "value": "140100",
                "label": "太原市",
                "parent": "140000",
                "children": [
                    {
                        "label": "小店区",
                        "value": "140105",
                        "parent": "140100"
                    },
                    {
                        "label": "迎泽区",
                        "value": "140106",
                        "parent": "140100"
                    },
                    {
                        "label": "杏花岭区",
                        "value": "140107",
                        "parent": "140100"
                    },
                    {
                        "label": "尖草坪区",
                        "value": "140108",
                        "parent": "140100"
                    },
                    {
                        "label": "万柏林区",
                        "value": "140109",
                        "parent": "140100"
                    },
                    {
                        "label": "晋源区",
                        "value": "140110",
                        "parent": "140100"
                    },
                    {
                        "label": "清徐县",
                        "value": "140121",
                        "parent": "140100"
                    },
                    {
                        "label": "阳曲县",
                        "value": "140122",
                        "parent": "140100"
                    },
                    {
                        "label": "娄烦县",
                        "value": "140123",
                        "parent": "140100"
                    },
                    {
                        "label": "古交市",
                        "value": "140181",
                        "parent": "140100"
                    }
                ]
            },
            {
                "value": "140200",
                "label": "大同市",
                "parent": "140000",
                "children": [
                    {
                        "label": "新荣区",
                        "value": "140212",
                        "parent": "140200"
                    },
                    {
                        "label": "平城区",
                        "value": "140213",
                        "parent": "140200"
                    },
                    {
                        "label": "云冈区",
                        "value": "140214",
                        "parent": "140200"
                    },
                    {
                        "label": "云州区",
                        "value": "140215",
                        "parent": "140200"
                    },
                    {
                        "label": "阳高县",
                        "value": "140221",
                        "parent": "140200"
                    },
                    {
                        "label": "天镇县",
                        "value": "140222",
                        "parent": "140200"
                    },
                    {
                        "label": "广灵县",
                        "value": "140223",
                        "parent": "140200"
                    },
                    {
                        "label": "灵丘县",
                        "value": "140224",
                        "parent": "140200"
                    },
                    {
                        "label": "浑源县",
                        "value": "140225",
                        "parent": "140200"
                    },
                    {
                        "label": "左云县",
                        "value": "140226",
                        "parent": "140200"
                    },
                    {
                        "label": "山西大同经济开发区",
                        "value": "140271",
                        "parent": "140200"
                    }
                ]
            },
            {
                "value": "140300",
                "label": "阳泉市",
                "parent": "140000",
                "children": [
                    {
                        "label": "城区",
                        "value": "140302",
                        "parent": "140300"
                    },
                    {
                        "label": "矿区",
                        "value": "140303",
                        "parent": "140300"
                    },
                    {
                        "label": "郊区",
                        "value": "140311",
                        "parent": "140300"
                    },
                    {
                        "label": "平定县",
                        "value": "140321",
                        "parent": "140300"
                    },
                    {
                        "label": "盂县",
                        "value": "140322",
                        "parent": "140300"
                    }
                ]
            },
            {
                "value": "140400",
                "label": "长治市",
                "parent": "140000",
                "children": [
                    {
                        "label": "潞州区",
                        "value": "140403",
                        "parent": "140400"
                    },
                    {
                        "label": "上党区",
                        "value": "140404",
                        "parent": "140400"
                    },
                    {
                        "label": "屯留区",
                        "value": "140405",
                        "parent": "140400"
                    },
                    {
                        "label": "潞城区",
                        "value": "140406",
                        "parent": "140400"
                    },
                    {
                        "label": "襄垣县",
                        "value": "140423",
                        "parent": "140400"
                    },
                    {
                        "label": "平顺县",
                        "value": "140425",
                        "parent": "140400"
                    },
                    {
                        "label": "黎城县",
                        "value": "140426",
                        "parent": "140400"
                    },
                    {
                        "label": "壶关县",
                        "value": "140427",
                        "parent": "140400"
                    },
                    {
                        "label": "长子县",
                        "value": "140428",
                        "parent": "140400"
                    },
                    {
                        "label": "武乡县",
                        "value": "140429",
                        "parent": "140400"
                    },
                    {
                        "label": "沁县",
                        "value": "140430",
                        "parent": "140400"
                    },
                    {
                        "label": "沁源县",
                        "value": "140431",
                        "parent": "140400"
                    },
                    {
                        "label": "山西长治高新技术产业园区",
                        "value": "140471",
                        "parent": "140400"
                    }
                ]
            },
            {
                "value": "140500",
                "label": "晋城市",
                "parent": "140000",
                "children": [
                    {
                        "label": "城区",
                        "value": "140502",
                        "parent": "140500"
                    },
                    {
                        "label": "沁水县",
                        "value": "140521",
                        "parent": "140500"
                    },
                    {
                        "label": "阳城县",
                        "value": "140522",
                        "parent": "140500"
                    },
                    {
                        "label": "陵川县",
                        "value": "140524",
                        "parent": "140500"
                    },
                    {
                        "label": "泽州县",
                        "value": "140525",
                        "parent": "140500"
                    },
                    {
                        "label": "高平市",
                        "value": "140581",
                        "parent": "140500"
                    }
                ]
            },
            {
                "value": "140600",
                "label": "朔州市",
                "parent": "140000",
                "children": [
                    {
                        "label": "朔城区",
                        "value": "140602",
                        "parent": "140600"
                    },
                    {
                        "label": "平鲁区",
                        "value": "140603",
                        "parent": "140600"
                    },
                    {
                        "label": "山阴县",
                        "value": "140621",
                        "parent": "140600"
                    },
                    {
                        "label": "应县",
                        "value": "140622",
                        "parent": "140600"
                    },
                    {
                        "label": "右玉县",
                        "value": "140623",
                        "parent": "140600"
                    },
                    {
                        "label": "山西朔州经济开发区",
                        "value": "140671",
                        "parent": "140600"
                    },
                    {
                        "label": "怀仁市",
                        "value": "140681",
                        "parent": "140600"
                    }
                ]
            },
            {
                "value": "140700",
                "label": "晋中市",
                "parent": "140000",
                "children": [
                    {
                        "label": "榆次区",
                        "value": "140702",
                        "parent": "140700"
                    },
                    {
                        "label": "太谷区",
                        "value": "140703",
                        "parent": "140700"
                    },
                    {
                        "label": "榆社县",
                        "value": "140721",
                        "parent": "140700"
                    },
                    {
                        "label": "左权县",
                        "value": "140722",
                        "parent": "140700"
                    },
                    {
                        "label": "和顺县",
                        "value": "140723",
                        "parent": "140700"
                    },
                    {
                        "label": "昔阳县",
                        "value": "140724",
                        "parent": "140700"
                    },
                    {
                        "label": "寿阳县",
                        "value": "140725",
                        "parent": "140700"
                    },
                    {
                        "label": "祁县",
                        "value": "140727",
                        "parent": "140700"
                    },
                    {
                        "label": "平遥县",
                        "value": "140728",
                        "parent": "140700"
                    },
                    {
                        "label": "灵石县",
                        "value": "140729",
                        "parent": "140700"
                    },
                    {
                        "label": "介休市",
                        "value": "140781",
                        "parent": "140700"
                    }
                ]
            },
            {
                "value": "140800",
                "label": "运城市",
                "parent": "140000",
                "children": [
                    {
                        "label": "盐湖区",
                        "value": "140802",
                        "parent": "140800"
                    },
                    {
                        "label": "临猗县",
                        "value": "140821",
                        "parent": "140800"
                    },
                    {
                        "label": "万荣县",
                        "value": "140822",
                        "parent": "140800"
                    },
                    {
                        "label": "闻喜县",
                        "value": "140823",
                        "parent": "140800"
                    },
                    {
                        "label": "稷山县",
                        "value": "140824",
                        "parent": "140800"
                    },
                    {
                        "label": "新绛县",
                        "value": "140825",
                        "parent": "140800"
                    },
                    {
                        "label": "绛县",
                        "value": "140826",
                        "parent": "140800"
                    },
                    {
                        "label": "垣曲县",
                        "value": "140827",
                        "parent": "140800"
                    },
                    {
                        "label": "夏县",
                        "value": "140828",
                        "parent": "140800"
                    },
                    {
                        "label": "平陆县",
                        "value": "140829",
                        "parent": "140800"
                    },
                    {
                        "label": "芮城县",
                        "value": "140830",
                        "parent": "140800"
                    },
                    {
                        "label": "永济市",
                        "value": "140881",
                        "parent": "140800"
                    },
                    {
                        "label": "河津市",
                        "value": "140882",
                        "parent": "140800"
                    }
                ]
            },
            {
                "value": "140900",
                "label": "忻州市",
                "parent": "140000",
                "children": [
                    {
                        "label": "忻府区",
                        "value": "140902",
                        "parent": "140900"
                    },
                    {
                        "label": "定襄县",
                        "value": "140921",
                        "parent": "140900"
                    },
                    {
                        "label": "五台县",
                        "value": "140922",
                        "parent": "140900"
                    },
                    {
                        "label": "代县",
                        "value": "140923",
                        "parent": "140900"
                    },
                    {
                        "label": "繁峙县",
                        "value": "140924",
                        "parent": "140900"
                    },
                    {
                        "label": "宁武县",
                        "value": "140925",
                        "parent": "140900"
                    },
                    {
                        "label": "静乐县",
                        "value": "140926",
                        "parent": "140900"
                    },
                    {
                        "label": "神池县",
                        "value": "140927",
                        "parent": "140900"
                    },
                    {
                        "label": "五寨县",
                        "value": "140928",
                        "parent": "140900"
                    },
                    {
                        "label": "岢岚县",
                        "value": "140929",
                        "parent": "140900"
                    },
                    {
                        "label": "河曲县",
                        "value": "140930",
                        "parent": "140900"
                    },
                    {
                        "label": "保德县",
                        "value": "140931",
                        "parent": "140900"
                    },
                    {
                        "label": "偏关县",
                        "value": "140932",
                        "parent": "140900"
                    },
                    {
                        "label": "五台山风景名胜区",
                        "value": "140971",
                        "parent": "140900"
                    },
                    {
                        "label": "原平市",
                        "value": "140981",
                        "parent": "140900"
                    }
                ]
            },
            {
                "value": "141000",
                "label": "临汾市",
                "parent": "140000",
                "children": [
                    {
                        "label": "尧都区",
                        "value": "141002",
                        "parent": "141000"
                    },
                    {
                        "label": "曲沃县",
                        "value": "141021",
                        "parent": "141000"
                    },
                    {
                        "label": "翼城县",
                        "value": "141022",
                        "parent": "141000"
                    },
                    {
                        "label": "襄汾县",
                        "value": "141023",
                        "parent": "141000"
                    },
                    {
                        "label": "洪洞县",
                        "value": "141024",
                        "parent": "141000"
                    },
                    {
                        "label": "古县",
                        "value": "141025",
                        "parent": "141000"
                    },
                    {
                        "label": "安泽县",
                        "value": "141026",
                        "parent": "141000"
                    },
                    {
                        "label": "浮山县",
                        "value": "141027",
                        "parent": "141000"
                    },
                    {
                        "label": "吉县",
                        "value": "141028",
                        "parent": "141000"
                    },
                    {
                        "label": "乡宁县",
                        "value": "141029",
                        "parent": "141000"
                    },
                    {
                        "label": "大宁县",
                        "value": "141030",
                        "parent": "141000"
                    },
                    {
                        "label": "隰县",
                        "value": "141031",
                        "parent": "141000"
                    },
                    {
                        "label": "永和县",
                        "value": "141032",
                        "parent": "141000"
                    },
                    {
                        "label": "蒲县",
                        "value": "141033",
                        "parent": "141000"
                    },
                    {
                        "label": "汾西县",
                        "value": "141034",
                        "parent": "141000"
                    },
                    {
                        "label": "侯马市",
                        "value": "141081",
                        "parent": "141000"
                    },
                    {
                        "label": "霍州市",
                        "value": "141082",
                        "parent": "141000"
                    }
                ]
            },
            {
                "value": "141100",
                "label": "吕梁市",
                "parent": "140000",
                "children": [
                    {
                        "label": "离石区",
                        "value": "141102",
                        "parent": "141100"
                    },
                    {
                        "label": "文水县",
                        "value": "141121",
                        "parent": "141100"
                    },
                    {
                        "label": "交城县",
                        "value": "141122",
                        "parent": "141100"
                    },
                    {
                        "label": "兴县",
                        "value": "141123",
                        "parent": "141100"
                    },
                    {
                        "label": "临县",
                        "value": "141124",
                        "parent": "141100"
                    },
                    {
                        "label": "柳林县",
                        "value": "141125",
                        "parent": "141100"
                    },
                    {
                        "label": "石楼县",
                        "value": "141126",
                        "parent": "141100"
                    },
                    {
                        "label": "岚县",
                        "value": "141127",
                        "parent": "141100"
                    },
                    {
                        "label": "方山县",
                        "value": "141128",
                        "parent": "141100"
                    },
                    {
                        "label": "中阳县",
                        "value": "141129",
                        "parent": "141100"
                    },
                    {
                        "label": "交口县",
                        "value": "141130",
                        "parent": "141100"
                    },
                    {
                        "label": "孝义市",
                        "value": "141181",
                        "parent": "141100"
                    },
                    {
                        "label": "汾阳市",
                        "value": "141182",
                        "parent": "141100"
                    }
                ]
            }
        ]
    },
    {
        "value": "150000",
        "label": "内蒙古自治区",
        "children": [
            {
                "value": "150100",
                "label": "呼和浩特市",
                "parent": "150000",
                "children": [
                    {
                        "label": "新城区",
                        "value": "150102",
                        "parent": "150100"
                    },
                    {
                        "label": "回民区",
                        "value": "150103",
                        "parent": "150100"
                    },
                    {
                        "label": "玉泉区",
                        "value": "150104",
                        "parent": "150100"
                    },
                    {
                        "label": "赛罕区",
                        "value": "150105",
                        "parent": "150100"
                    },
                    {
                        "label": "土默特左旗",
                        "value": "150121",
                        "parent": "150100"
                    },
                    {
                        "label": "托克托县",
                        "value": "150122",
                        "parent": "150100"
                    },
                    {
                        "label": "和林格尔县",
                        "value": "150123",
                        "parent": "150100"
                    },
                    {
                        "label": "清水河县",
                        "value": "150124",
                        "parent": "150100"
                    },
                    {
                        "label": "武川县",
                        "value": "150125",
                        "parent": "150100"
                    },
                    {
                        "label": "呼和浩特经济技术开发区",
                        "value": "150172",
                        "parent": "150100"
                    }
                ]
            },
            {
                "value": "150200",
                "label": "包头市",
                "parent": "150000",
                "children": [
                    {
                        "label": "东河区",
                        "value": "150202",
                        "parent": "150200"
                    },
                    {
                        "label": "昆都仑区",
                        "value": "150203",
                        "parent": "150200"
                    },
                    {
                        "label": "青山区",
                        "value": "150204",
                        "parent": "150200"
                    },
                    {
                        "label": "石拐区",
                        "value": "150205",
                        "parent": "150200"
                    },
                    {
                        "label": "白云鄂博矿区",
                        "value": "150206",
                        "parent": "150200"
                    },
                    {
                        "label": "九原区",
                        "value": "150207",
                        "parent": "150200"
                    },
                    {
                        "label": "土默特右旗",
                        "value": "150221",
                        "parent": "150200"
                    },
                    {
                        "label": "固阳县",
                        "value": "150222",
                        "parent": "150200"
                    },
                    {
                        "label": "达尔罕茂明安联合旗",
                        "value": "150223",
                        "parent": "150200"
                    },
                    {
                        "label": "包头稀土高新技术产业开发区",
                        "value": "150271",
                        "parent": "150200"
                    }
                ]
            },
            {
                "value": "150300",
                "label": "乌海市",
                "parent": "150000",
                "children": [
                    {
                        "label": "海勃湾区",
                        "value": "150302",
                        "parent": "150300"
                    },
                    {
                        "label": "海南区",
                        "value": "150303",
                        "parent": "150300"
                    },
                    {
                        "label": "乌达区",
                        "value": "150304",
                        "parent": "150300"
                    }
                ]
            },
            {
                "value": "150400",
                "label": "赤峰市",
                "parent": "150000",
                "children": [
                    {
                        "label": "红山区",
                        "value": "150402",
                        "parent": "150400"
                    },
                    {
                        "label": "元宝山区",
                        "value": "150403",
                        "parent": "150400"
                    },
                    {
                        "label": "松山区",
                        "value": "150404",
                        "parent": "150400"
                    },
                    {
                        "label": "阿鲁科尔沁旗",
                        "value": "150421",
                        "parent": "150400"
                    },
                    {
                        "label": "巴林左旗",
                        "value": "150422",
                        "parent": "150400"
                    },
                    {
                        "label": "巴林右旗",
                        "value": "150423",
                        "parent": "150400"
                    },
                    {
                        "label": "林西县",
                        "value": "150424",
                        "parent": "150400"
                    },
                    {
                        "label": "克什克腾旗",
                        "value": "150425",
                        "parent": "150400"
                    },
                    {
                        "label": "翁牛特旗",
                        "value": "150426",
                        "parent": "150400"
                    },
                    {
                        "label": "喀喇沁旗",
                        "value": "150428",
                        "parent": "150400"
                    },
                    {
                        "label": "宁城县",
                        "value": "150429",
                        "parent": "150400"
                    },
                    {
                        "label": "敖汉旗",
                        "value": "150430",
                        "parent": "150400"
                    }
                ]
            },
            {
                "value": "150500",
                "label": "通辽市",
                "parent": "150000",
                "children": [
                    {
                        "label": "科尔沁区",
                        "value": "150502",
                        "parent": "150500"
                    },
                    {
                        "label": "科尔沁左翼中旗",
                        "value": "150521",
                        "parent": "150500"
                    },
                    {
                        "label": "科尔沁左翼后旗",
                        "value": "150522",
                        "parent": "150500"
                    },
                    {
                        "label": "开鲁县",
                        "value": "150523",
                        "parent": "150500"
                    },
                    {
                        "label": "库伦旗",
                        "value": "150524",
                        "parent": "150500"
                    },
                    {
                        "label": "奈曼旗",
                        "value": "150525",
                        "parent": "150500"
                    },
                    {
                        "label": "扎鲁特旗",
                        "value": "150526",
                        "parent": "150500"
                    },
                    {
                        "label": "通辽经济技术开发区",
                        "value": "150571",
                        "parent": "150500"
                    },
                    {
                        "label": "霍林郭勒市",
                        "value": "150581",
                        "parent": "150500"
                    }
                ]
            },
            {
                "value": "150600",
                "label": "鄂尔多斯市",
                "parent": "150000",
                "children": [
                    {
                        "label": "东胜区",
                        "value": "150602",
                        "parent": "150600"
                    },
                    {
                        "label": "康巴什区",
                        "value": "150603",
                        "parent": "150600"
                    },
                    {
                        "label": "达拉特旗",
                        "value": "150621",
                        "parent": "150600"
                    },
                    {
                        "label": "准格尔旗",
                        "value": "150622",
                        "parent": "150600"
                    },
                    {
                        "label": "鄂托克前旗",
                        "value": "150623",
                        "parent": "150600"
                    },
                    {
                        "label": "鄂托克旗",
                        "value": "150624",
                        "parent": "150600"
                    },
                    {
                        "label": "杭锦旗",
                        "value": "150625",
                        "parent": "150600"
                    },
                    {
                        "label": "乌审旗",
                        "value": "150626",
                        "parent": "150600"
                    },
                    {
                        "label": "伊金霍洛旗",
                        "value": "150627",
                        "parent": "150600"
                    }
                ]
            },
            {
                "value": "150700",
                "label": "呼伦贝尔市",
                "parent": "150000",
                "children": [
                    {
                        "label": "海拉尔区",
                        "value": "150702",
                        "parent": "150700"
                    },
                    {
                        "label": "扎赉诺尔区",
                        "value": "150703",
                        "parent": "150700"
                    },
                    {
                        "label": "阿荣旗",
                        "value": "150721",
                        "parent": "150700"
                    },
                    {
                        "label": "莫力达瓦达斡尔族自治旗",
                        "value": "150722",
                        "parent": "150700"
                    },
                    {
                        "label": "鄂伦春自治旗",
                        "value": "150723",
                        "parent": "150700"
                    },
                    {
                        "label": "鄂温克族自治旗",
                        "value": "150724",
                        "parent": "150700"
                    },
                    {
                        "label": "陈巴尔虎旗",
                        "value": "150725",
                        "parent": "150700"
                    },
                    {
                        "label": "新巴尔虎左旗",
                        "value": "150726",
                        "parent": "150700"
                    },
                    {
                        "label": "新巴尔虎右旗",
                        "value": "150727",
                        "parent": "150700"
                    },
                    {
                        "label": "满洲里市",
                        "value": "150781",
                        "parent": "150700"
                    },
                    {
                        "label": "牙克石市",
                        "value": "150782",
                        "parent": "150700"
                    },
                    {
                        "label": "扎兰屯市",
                        "value": "150783",
                        "parent": "150700"
                    },
                    {
                        "label": "额尔古纳市",
                        "value": "150784",
                        "parent": "150700"
                    },
                    {
                        "label": "根河市",
                        "value": "150785",
                        "parent": "150700"
                    }
                ]
            },
            {
                "value": "150800",
                "label": "巴彦淖尔市",
                "parent": "150000",
                "children": [
                    {
                        "label": "临河区",
                        "value": "150802",
                        "parent": "150800"
                    },
                    {
                        "label": "五原县",
                        "value": "150821",
                        "parent": "150800"
                    },
                    {
                        "label": "磴口县",
                        "value": "150822",
                        "parent": "150800"
                    },
                    {
                        "label": "乌拉特前旗",
                        "value": "150823",
                        "parent": "150800"
                    },
                    {
                        "label": "乌拉特中旗",
                        "value": "150824",
                        "parent": "150800"
                    },
                    {
                        "label": "乌拉特后旗",
                        "value": "150825",
                        "parent": "150800"
                    },
                    {
                        "label": "杭锦后旗",
                        "value": "150826",
                        "parent": "150800"
                    }
                ]
            },
            {
                "value": "150900",
                "label": "乌兰察布市",
                "parent": "150000",
                "children": [
                    {
                        "label": "集宁区",
                        "value": "150902",
                        "parent": "150900"
                    },
                    {
                        "label": "卓资县",
                        "value": "150921",
                        "parent": "150900"
                    },
                    {
                        "label": "化德县",
                        "value": "150922",
                        "parent": "150900"
                    },
                    {
                        "label": "商都县",
                        "value": "150923",
                        "parent": "150900"
                    },
                    {
                        "label": "兴和县",
                        "value": "150924",
                        "parent": "150900"
                    },
                    {
                        "label": "凉城县",
                        "value": "150925",
                        "parent": "150900"
                    },
                    {
                        "label": "察哈尔右翼前旗",
                        "value": "150926",
                        "parent": "150900"
                    },
                    {
                        "label": "察哈尔右翼中旗",
                        "value": "150927",
                        "parent": "150900"
                    },
                    {
                        "label": "察哈尔右翼后旗",
                        "value": "150928",
                        "parent": "150900"
                    },
                    {
                        "label": "四子王旗",
                        "value": "150929",
                        "parent": "150900"
                    },
                    {
                        "label": "丰镇市",
                        "value": "150981",
                        "parent": "150900"
                    }
                ]
            },
            {
                "value": "152200",
                "label": "兴安盟",
                "parent": "150000",
                "children": [
                    {
                        "label": "乌兰浩特市",
                        "value": "152201",
                        "parent": "152200"
                    },
                    {
                        "label": "阿尔山市",
                        "value": "152202",
                        "parent": "152200"
                    },
                    {
                        "label": "科尔沁右翼前旗",
                        "value": "152221",
                        "parent": "152200"
                    },
                    {
                        "label": "科尔沁右翼中旗",
                        "value": "152222",
                        "parent": "152200"
                    },
                    {
                        "label": "扎赉特旗",
                        "value": "152223",
                        "parent": "152200"
                    },
                    {
                        "label": "突泉县",
                        "value": "152224",
                        "parent": "152200"
                    }
                ]
            },
            {
                "value": "152500",
                "label": "锡林郭勒盟",
                "parent": "150000",
                "children": [
                    {
                        "label": "二连浩特市",
                        "value": "152501",
                        "parent": "152500"
                    },
                    {
                        "label": "锡林浩特市",
                        "value": "152502",
                        "parent": "152500"
                    },
                    {
                        "label": "阿巴嘎旗",
                        "value": "152522",
                        "parent": "152500"
                    },
                    {
                        "label": "苏尼特左旗",
                        "value": "152523",
                        "parent": "152500"
                    },
                    {
                        "label": "苏尼特右旗",
                        "value": "152524",
                        "parent": "152500"
                    },
                    {
                        "label": "东乌珠穆沁旗",
                        "value": "152525",
                        "parent": "152500"
                    },
                    {
                        "label": "西乌珠穆沁旗",
                        "value": "152526",
                        "parent": "152500"
                    },
                    {
                        "label": "太仆寺旗",
                        "value": "152527",
                        "parent": "152500"
                    },
                    {
                        "label": "镶黄旗",
                        "value": "152528",
                        "parent": "152500"
                    },
                    {
                        "label": "正镶白旗",
                        "value": "152529",
                        "parent": "152500"
                    },
                    {
                        "label": "正蓝旗",
                        "value": "152530",
                        "parent": "152500"
                    },
                    {
                        "label": "多伦县",
                        "value": "152531",
                        "parent": "152500"
                    },
                    {
                        "label": "乌拉盖管委会",
                        "value": "152571",
                        "parent": "152500"
                    }
                ]
            },
            {
                "value": "152900",
                "label": "阿拉善盟",
                "parent": "150000",
                "children": [
                    {
                        "label": "阿拉善左旗",
                        "value": "152921",
                        "parent": "152900"
                    },
                    {
                        "label": "阿拉善右旗",
                        "value": "152922",
                        "parent": "152900"
                    },
                    {
                        "label": "额济纳旗",
                        "value": "152923",
                        "parent": "152900"
                    },
                    {
                        "label": "内蒙古阿拉善经济开发区",
                        "value": "152971",
                        "parent": "152900"
                    }
                ]
            }
        ]
    },
    {
        "value": "210000",
        "label": "辽宁省",
        "children": [
            {
                "value": "210100",
                "label": "沈阳市",
                "parent": "210000",
                "children": [
                    {
                        "label": "和平区",
                        "value": "210102",
                        "parent": "210100"
                    },
                    {
                        "label": "沈河区",
                        "value": "210103",
                        "parent": "210100"
                    },
                    {
                        "label": "大东区",
                        "value": "210104",
                        "parent": "210100"
                    },
                    {
                        "label": "皇姑区",
                        "value": "210105",
                        "parent": "210100"
                    },
                    {
                        "label": "铁西区",
                        "value": "210106",
                        "parent": "210100"
                    },
                    {
                        "label": "苏家屯区",
                        "value": "210111",
                        "parent": "210100"
                    },
                    {
                        "label": "浑南区",
                        "value": "210112",
                        "parent": "210100"
                    },
                    {
                        "label": "沈北新区",
                        "value": "210113",
                        "parent": "210100"
                    },
                    {
                        "label": "于洪区",
                        "value": "210114",
                        "parent": "210100"
                    },
                    {
                        "label": "辽中区",
                        "value": "210115",
                        "parent": "210100"
                    },
                    {
                        "label": "康平县",
                        "value": "210123",
                        "parent": "210100"
                    },
                    {
                        "label": "法库县",
                        "value": "210124",
                        "parent": "210100"
                    },
                    {
                        "label": "新民市",
                        "value": "210181",
                        "parent": "210100"
                    },
                    {
                        "label": "经济技术开发区",
                        "value": "210190",
                        "parent": "210100"
                    }
                ]
            },
            {
                "value": "210200",
                "label": "大连市",
                "parent": "210000",
                "children": [
                    {
                        "label": "中山区",
                        "value": "210202",
                        "parent": "210200"
                    },
                    {
                        "label": "西岗区",
                        "value": "210203",
                        "parent": "210200"
                    },
                    {
                        "label": "沙河口区",
                        "value": "210204",
                        "parent": "210200"
                    },
                    {
                        "label": "甘井子区",
                        "value": "210211",
                        "parent": "210200"
                    },
                    {
                        "label": "旅顺口区",
                        "value": "210212",
                        "parent": "210200"
                    },
                    {
                        "label": "金州区",
                        "value": "210213",
                        "parent": "210200"
                    },
                    {
                        "label": "普兰店区",
                        "value": "210214",
                        "parent": "210200"
                    },
                    {
                        "label": "长海县",
                        "value": "210224",
                        "parent": "210200"
                    },
                    {
                        "label": "瓦房店市",
                        "value": "210281",
                        "parent": "210200"
                    },
                    {
                        "label": "庄河市",
                        "value": "210283",
                        "parent": "210200"
                    }
                ]
            },
            {
                "value": "210300",
                "label": "鞍山市",
                "parent": "210000",
                "children": [
                    {
                        "label": "铁东区",
                        "value": "210302",
                        "parent": "210300"
                    },
                    {
                        "label": "铁西区",
                        "value": "210303",
                        "parent": "210300"
                    },
                    {
                        "label": "立山区",
                        "value": "210304",
                        "parent": "210300"
                    },
                    {
                        "label": "千山区",
                        "value": "210311",
                        "parent": "210300"
                    },
                    {
                        "label": "台安县",
                        "value": "210321",
                        "parent": "210300"
                    },
                    {
                        "label": "岫岩满族自治县",
                        "value": "210323",
                        "parent": "210300"
                    },
                    {
                        "label": "海城市",
                        "value": "210381",
                        "parent": "210300"
                    },
                    {
                        "label": "高新区",
                        "value": "210390",
                        "parent": "210300"
                    }
                ]
            },
            {
                "value": "210400",
                "label": "抚顺市",
                "parent": "210000",
                "children": [
                    {
                        "label": "新抚区",
                        "value": "210402",
                        "parent": "210400"
                    },
                    {
                        "label": "东洲区",
                        "value": "210403",
                        "parent": "210400"
                    },
                    {
                        "label": "望花区",
                        "value": "210404",
                        "parent": "210400"
                    },
                    {
                        "label": "顺城区",
                        "value": "210411",
                        "parent": "210400"
                    },
                    {
                        "label": "抚顺县",
                        "value": "210421",
                        "parent": "210400"
                    },
                    {
                        "label": "新宾满族自治县",
                        "value": "210422",
                        "parent": "210400"
                    },
                    {
                        "label": "清原满族自治县",
                        "value": "210423",
                        "parent": "210400"
                    }
                ]
            },
            {
                "value": "210500",
                "label": "本溪市",
                "parent": "210000",
                "children": [
                    {
                        "label": "平山区",
                        "value": "210502",
                        "parent": "210500"
                    },
                    {
                        "label": "溪湖区",
                        "value": "210503",
                        "parent": "210500"
                    },
                    {
                        "label": "明山区",
                        "value": "210504",
                        "parent": "210500"
                    },
                    {
                        "label": "南芬区",
                        "value": "210505",
                        "parent": "210500"
                    },
                    {
                        "label": "本溪满族自治县",
                        "value": "210521",
                        "parent": "210500"
                    },
                    {
                        "label": "桓仁满族自治县",
                        "value": "210522",
                        "parent": "210500"
                    }
                ]
            },
            {
                "value": "210600",
                "label": "丹东市",
                "parent": "210000",
                "children": [
                    {
                        "label": "元宝区",
                        "value": "210602",
                        "parent": "210600"
                    },
                    {
                        "label": "振兴区",
                        "value": "210603",
                        "parent": "210600"
                    },
                    {
                        "label": "振安区",
                        "value": "210604",
                        "parent": "210600"
                    },
                    {
                        "label": "宽甸满族自治县",
                        "value": "210624",
                        "parent": "210600"
                    },
                    {
                        "label": "东港市",
                        "value": "210681",
                        "parent": "210600"
                    },
                    {
                        "label": "凤城市",
                        "value": "210682",
                        "parent": "210600"
                    }
                ]
            },
            {
                "value": "210700",
                "label": "锦州市",
                "parent": "210000",
                "children": [
                    {
                        "label": "古塔区",
                        "value": "210702",
                        "parent": "210700"
                    },
                    {
                        "label": "凌河区",
                        "value": "210703",
                        "parent": "210700"
                    },
                    {
                        "label": "太和区",
                        "value": "210711",
                        "parent": "210700"
                    },
                    {
                        "label": "黑山县",
                        "value": "210726",
                        "parent": "210700"
                    },
                    {
                        "label": "义县",
                        "value": "210727",
                        "parent": "210700"
                    },
                    {
                        "label": "凌海市",
                        "value": "210781",
                        "parent": "210700"
                    },
                    {
                        "label": "北镇市",
                        "value": "210782",
                        "parent": "210700"
                    },
                    {
                        "label": "经济技术开发区",
                        "value": "210793",
                        "parent": "210700"
                    }
                ]
            },
            {
                "value": "210800",
                "label": "营口市",
                "parent": "210000",
                "children": [
                    {
                        "label": "站前区",
                        "value": "210802",
                        "parent": "210800"
                    },
                    {
                        "label": "西市区",
                        "value": "210803",
                        "parent": "210800"
                    },
                    {
                        "label": "鲅鱼圈区",
                        "value": "210804",
                        "parent": "210800"
                    },
                    {
                        "label": "老边区",
                        "value": "210811",
                        "parent": "210800"
                    },
                    {
                        "label": "盖州市",
                        "value": "210881",
                        "parent": "210800"
                    },
                    {
                        "label": "大石桥市",
                        "value": "210882",
                        "parent": "210800"
                    }
                ]
            },
            {
                "value": "210900",
                "label": "阜新市",
                "parent": "210000",
                "children": [
                    {
                        "label": "海州区",
                        "value": "210902",
                        "parent": "210900"
                    },
                    {
                        "label": "新邱区",
                        "value": "210903",
                        "parent": "210900"
                    },
                    {
                        "label": "太平区",
                        "value": "210904",
                        "parent": "210900"
                    },
                    {
                        "label": "清河门区",
                        "value": "210905",
                        "parent": "210900"
                    },
                    {
                        "label": "细河区",
                        "value": "210911",
                        "parent": "210900"
                    },
                    {
                        "label": "阜新蒙古族自治县",
                        "value": "210921",
                        "parent": "210900"
                    },
                    {
                        "label": "彰武县",
                        "value": "210922",
                        "parent": "210900"
                    }
                ]
            },
            {
                "value": "211000",
                "label": "辽阳市",
                "parent": "210000",
                "children": [
                    {
                        "label": "白塔区",
                        "value": "211002",
                        "parent": "211000"
                    },
                    {
                        "label": "文圣区",
                        "value": "211003",
                        "parent": "211000"
                    },
                    {
                        "label": "宏伟区",
                        "value": "211004",
                        "parent": "211000"
                    },
                    {
                        "label": "弓长岭区",
                        "value": "211005",
                        "parent": "211000"
                    },
                    {
                        "label": "太子河区",
                        "value": "211011",
                        "parent": "211000"
                    },
                    {
                        "label": "辽阳县",
                        "value": "211021",
                        "parent": "211000"
                    },
                    {
                        "label": "灯塔市",
                        "value": "211081",
                        "parent": "211000"
                    }
                ]
            },
            {
                "value": "211100",
                "label": "盘锦市",
                "parent": "210000",
                "children": [
                    {
                        "label": "双台子区",
                        "value": "211102",
                        "parent": "211100"
                    },
                    {
                        "label": "兴隆台区",
                        "value": "211103",
                        "parent": "211100"
                    },
                    {
                        "label": "大洼区",
                        "value": "211104",
                        "parent": "211100"
                    },
                    {
                        "label": "盘山�����",
                        "value": "211122",
                        "parent": "211100"
                    }
                ]
            },
            {
                "value": "211200",
                "label": "铁岭市",
                "parent": "210000",
                "children": [
                    {
                        "label": "银州区",
                        "value": "211202",
                        "parent": "211200"
                    },
                    {
                        "label": "清河区",
                        "value": "211204",
                        "parent": "211200"
                    },
                    {
                        "label": "铁岭县",
                        "value": "211221",
                        "parent": "211200"
                    },
                    {
                        "label": "西丰县",
                        "value": "211223",
                        "parent": "211200"
                    },
                    {
                        "label": "昌图县",
                        "value": "211224",
                        "parent": "211200"
                    },
                    {
                        "label": "调兵山市",
                        "value": "211281",
                        "parent": "211200"
                    },
                    {
                        "label": "开原市",
                        "value": "211282",
                        "parent": "211200"
                    }
                ]
            },
            {
                "value": "211300",
                "label": "朝阳市",
                "parent": "210000",
                "children": [
                    {
                        "label": "双塔区",
                        "value": "211302",
                        "parent": "211300"
                    },
                    {
                        "label": "龙城区",
                        "value": "211303",
                        "parent": "211300"
                    },
                    {
                        "label": "朝阳县",
                        "value": "211321",
                        "parent": "211300"
                    },
                    {
                        "label": "建平县",
                        "value": "211322",
                        "parent": "211300"
                    },
                    {
                        "label": "喀喇沁左翼蒙古族自治县",
                        "value": "211324",
                        "parent": "211300"
                    },
                    {
                        "label": "北票市",
                        "value": "211381",
                        "parent": "211300"
                    },
                    {
                        "label": "凌源市",
                        "value": "211382",
                        "parent": "211300"
                    }
                ]
            },
            {
                "value": "211400",
                "label": "葫芦岛市",
                "parent": "210000",
                "children": [
                    {
                        "label": "连山区",
                        "value": "211402",
                        "parent": "211400"
                    },
                    {
                        "label": "龙港区",
                        "value": "211403",
                        "parent": "211400"
                    },
                    {
                        "label": "南票区",
                        "value": "211404",
                        "parent": "211400"
                    },
                    {
                        "label": "绥中县",
                        "value": "211421",
                        "parent": "211400"
                    },
                    {
                        "label": "建昌县",
                        "value": "211422",
                        "parent": "211400"
                    },
                    {
                        "label": "兴城市",
                        "value": "211481",
                        "parent": "211400"
                    }
                ]
            }
        ]
    },
    {
        "value": "220000",
        "label": "吉林省",
        "children": [
            {
                "value": "220100",
                "label": "长春市",
                "parent": "220000",
                "children": [
                    {
                        "label": "南关区",
                        "value": "220102",
                        "parent": "220100"
                    },
                    {
                        "label": "宽城区",
                        "value": "220103",
                        "parent": "220100"
                    },
                    {
                        "label": "朝阳区",
                        "value": "220104",
                        "parent": "220100"
                    },
                    {
                        "label": "二道区",
                        "value": "220105",
                        "parent": "220100"
                    },
                    {
                        "label": "绿园区",
                        "value": "220106",
                        "parent": "220100"
                    },
                    {
                        "label": "双阳区",
                        "value": "220112",
                        "parent": "220100"
                    },
                    {
                        "label": "九台区",
                        "value": "220113",
                        "parent": "220100"
                    },
                    {
                        "label": "农安县",
                        "value": "220122",
                        "parent": "220100"
                    },
                    {
                        "label": "长春经济技术开发区",
                        "value": "220171",
                        "parent": "220100"
                    },
                    {
                        "label": "长春净月高新技术产业开发区",
                        "value": "220172",
                        "parent": "220100"
                    },
                    {
                        "label": "长春高新技术产业开发区",
                        "value": "220173",
                        "parent": "220100"
                    },
                    {
                        "label": "长春汽车经济技术开发区",
                        "value": "220174",
                        "parent": "220100"
                    },
                    {
                        "label": "榆树市",
                        "value": "220182",
                        "parent": "220100"
                    },
                    {
                        "label": "德惠市",
                        "value": "220183",
                        "parent": "220100"
                    },
                    {
                        "label": "经济技术开发区",
                        "value": "220192",
                        "parent": "220100"
                    }
                ]
            },
            {
                "value": "220200",
                "label": "吉林市",
                "parent": "220000",
                "children": [
                    {
                        "label": "昌邑区",
                        "value": "220202",
                        "parent": "220200"
                    },
                    {
                        "label": "龙潭区",
                        "value": "220203",
                        "parent": "220200"
                    },
                    {
                        "label": "船营区",
                        "value": "220204",
                        "parent": "220200"
                    },
                    {
                        "label": "丰满区",
                        "value": "220211",
                        "parent": "220200"
                    },
                    {
                        "label": "永吉县",
                        "value": "220221",
                        "parent": "220200"
                    },
                    {
                        "label": "吉林经济开发区",
                        "value": "220271",
                        "parent": "220200"
                    },
                    {
                        "label": "吉林高新技术产业开发区",
                        "value": "220272",
                        "parent": "220200"
                    },
                    {
                        "label": "蛟河市",
                        "value": "220281",
                        "parent": "220200"
                    },
                    {
                        "label": "桦甸市",
                        "value": "220282",
                        "parent": "220200"
                    },
                    {
                        "label": "舒兰市",
                        "value": "220283",
                        "parent": "220200"
                    },
                    {
                        "label": "磐石市",
                        "value": "220284",
                        "parent": "220200"
                    }
                ]
            },
            {
                "value": "220300",
                "label": "四平市",
                "parent": "220000",
                "children": [
                    {
                        "label": "铁西区",
                        "value": "220302",
                        "parent": "220300"
                    },
                    {
                        "label": "铁东区",
                        "value": "220303",
                        "parent": "220300"
                    },
                    {
                        "label": "梨树县",
                        "value": "220322",
                        "parent": "220300"
                    },
                    {
                        "label": "伊通满族自治县",
                        "value": "220323",
                        "parent": "220300"
                    },
                    {
                        "label": "公主岭市",
                        "value": "220381",
                        "parent": "220300"
                    },
                    {
                        "label": "双辽市",
                        "value": "220382",
                        "parent": "220300"
                    }
                ]
            },
            {
                "value": "220400",
                "label": "辽源市",
                "parent": "220000",
                "children": [
                    {
                        "label": "龙山区",
                        "value": "220402",
                        "parent": "220400"
                    },
                    {
                        "label": "西安区",
                        "value": "220403",
                        "parent": "220400"
                    },
                    {
                        "label": "东丰县",
                        "value": "220421",
                        "parent": "220400"
                    },
                    {
                        "label": "东辽县",
                        "value": "220422",
                        "parent": "220400"
                    }
                ]
            },
            {
                "value": "220500",
                "label": "通化市",
                "parent": "220000",
                "children": [
                    {
                        "label": "东昌区",
                        "value": "220502",
                        "parent": "220500"
                    },
                    {
                        "label": "二道江区",
                        "value": "220503",
                        "parent": "220500"
                    },
                    {
                        "label": "通化县",
                        "value": "220521",
                        "parent": "220500"
                    },
                    {
                        "label": "辉南县",
                        "value": "220523",
                        "parent": "220500"
                    },
                    {
                        "label": "柳河县",
                        "value": "220524",
                        "parent": "220500"
                    },
                    {
                        "label": "梅河口市",
                        "value": "220581",
                        "parent": "220500"
                    },
                    {
                        "label": "集安市",
                        "value": "220582",
                        "parent": "220500"
                    }
                ]
            },
            {
                "value": "220600",
                "label": "白山市",
                "parent": "220000",
                "children": [
                    {
                        "label": "浑江区",
                        "value": "220602",
                        "parent": "220600"
                    },
                    {
                        "label": "江源区",
                        "value": "220605",
                        "parent": "220600"
                    },
                    {
                        "label": "抚松县",
                        "value": "220621",
                        "parent": "220600"
                    },
                    {
                        "label": "靖宇县",
                        "value": "220622",
                        "parent": "220600"
                    },
                    {
                        "label": "长白朝鲜族自治县",
                        "value": "220623",
                        "parent": "220600"
                    },
                    {
                        "label": "临江市",
                        "value": "220681",
                        "parent": "220600"
                    }
                ]
            },
            {
                "value": "220700",
                "label": "松原市",
                "parent": "220000",
                "children": [
                    {
                        "label": "宁江区",
                        "value": "220702",
                        "parent": "220700"
                    },
                    {
                        "label": "前郭尔罗斯蒙古族自治县",
                        "value": "220721",
                        "parent": "220700"
                    },
                    {
                        "label": "长岭县",
                        "value": "220722",
                        "parent": "220700"
                    },
                    {
                        "label": "乾安县",
                        "value": "220723",
                        "parent": "220700"
                    },
                    {
                        "label": "吉林松原经济开发区",
                        "value": "220771",
                        "parent": "220700"
                    },
                    {
                        "label": "扶余市",
                        "value": "220781",
                        "parent": "220700"
                    }
                ]
            },
            {
                "value": "220800",
                "label": "白城市",
                "parent": "220000",
                "children": [
                    {
                        "label": "洮北区",
                        "value": "220802",
                        "parent": "220800"
                    },
                    {
                        "label": "镇赉县",
                        "value": "220821",
                        "parent": "220800"
                    },
                    {
                        "label": "通榆县",
                        "value": "220822",
                        "parent": "220800"
                    },
                    {
                        "label": "吉林白城经济开发区",
                        "value": "220871",
                        "parent": "220800"
                    },
                    {
                        "label": "洮南市",
                        "value": "220881",
                        "parent": "220800"
                    },
                    {
                        "label": "大安市",
                        "value": "220882",
                        "parent": "220800"
                    }
                ]
            },
            {
                "value": "222400",
                "label": "延边朝鲜族自治州",
                "parent": "220000",
                "children": [
                    {
                        "label": "延吉市",
                        "value": "222401",
                        "parent": "222400"
                    },
                    {
                        "label": "图们市",
                        "value": "222402",
                        "parent": "222400"
                    },
                    {
                        "label": "敦化市",
                        "value": "222403",
                        "parent": "222400"
                    },
                    {
                        "label": "珲春市",
                        "value": "222404",
                        "parent": "222400"
                    },
                    {
                        "label": "龙井市",
                        "value": "222405",
                        "parent": "222400"
                    },
                    {
                        "label": "和龙市",
                        "value": "222406",
                        "parent": "222400"
                    },
                    {
                        "label": "汪清县",
                        "value": "222424",
                        "parent": "222400"
                    },
                    {
                        "label": "安图县",
                        "value": "222426",
                        "parent": "222400"
                    }
                ]
            }
        ]
    },
    {
        "value": "230000",
        "label": "黑龙江省",
        "children": [
            {
                "value": "230100",
                "label": "哈尔滨市",
                "parent": "230000",
                "children": [
                    {
                        "label": "道里区",
                        "value": "230102",
                        "parent": "230100"
                    },
                    {
                        "label": "南岗区",
                        "value": "230103",
                        "parent": "230100"
                    },
                    {
                        "label": "道外区",
                        "value": "230104",
                        "parent": "230100"
                    },
                    {
                        "label": "平房区",
                        "value": "230108",
                        "parent": "230100"
                    },
                    {
                        "label": "松北区",
                        "value": "230109",
                        "parent": "230100"
                    },
                    {
                        "label": "香坊区",
                        "value": "230110",
                        "parent": "230100"
                    },
                    {
                        "label": "呼兰区",
                        "value": "230111",
                        "parent": "230100"
                    },
                    {
                        "label": "阿城区",
                        "value": "230112",
                        "parent": "230100"
                    },
                    {
                        "label": "双城区",
                        "value": "230113",
                        "parent": "230100"
                    },
                    {
                        "label": "依兰县",
                        "value": "230123",
                        "parent": "230100"
                    },
                    {
                        "label": "方正县",
                        "value": "230124",
                        "parent": "230100"
                    },
                    {
                        "label": "宾县",
                        "value": "230125",
                        "parent": "230100"
                    },
                    {
                        "label": "巴彦县",
                        "value": "230126",
                        "parent": "230100"
                    },
                    {
                        "label": "木兰县",
                        "value": "230127",
                        "parent": "230100"
                    },
                    {
                        "label": "通河县",
                        "value": "230128",
                        "parent": "230100"
                    },
                    {
                        "label": "延寿县",
                        "value": "230129",
                        "parent": "230100"
                    },
                    {
                        "label": "尚志市",
                        "value": "230183",
                        "parent": "230100"
                    },
                    {
                        "label": "五常市",
                        "value": "230184",
                        "parent": "230100"
                    }
                ]
            },
            {
                "value": "230200",
                "label": "齐齐哈尔市",
                "parent": "230000",
                "children": [
                    {
                        "label": "龙沙区",
                        "value": "230202",
                        "parent": "230200"
                    },
                    {
                        "label": "建华区",
                        "value": "230203",
                        "parent": "230200"
                    },
                    {
                        "label": "铁锋区",
                        "value": "230204",
                        "parent": "230200"
                    },
                    {
                        "label": "昂昂溪区",
                        "value": "230205",
                        "parent": "230200"
                    },
                    {
                        "label": "富拉尔基区",
                        "value": "230206",
                        "parent": "230200"
                    },
                    {
                        "label": "碾子山区",
                        "value": "230207",
                        "parent": "230200"
                    },
                    {
                        "label": "梅里斯达斡尔族区",
                        "value": "230208",
                        "parent": "230200"
                    },
                    {
                        "label": "龙江县",
                        "value": "230221",
                        "parent": "230200"
                    },
                    {
                        "label": "依安县",
                        "value": "230223",
                        "parent": "230200"
                    },
                    {
                        "label": "泰来县",
                        "value": "230224",
                        "parent": "230200"
                    },
                    {
                        "label": "甘南县",
                        "value": "230225",
                        "parent": "230200"
                    },
                    {
                        "label": "富裕县",
                        "value": "230227",
                        "parent": "230200"
                    },
                    {
                        "label": "克山县",
                        "value": "230229",
                        "parent": "230200"
                    },
                    {
                        "label": "克东县",
                        "value": "230230",
                        "parent": "230200"
                    },
                    {
                        "label": "拜泉县",
                        "value": "230231",
                        "parent": "230200"
                    },
                    {
                        "label": "讷河市",
                        "value": "230281",
                        "parent": "230200"
                    }
                ]
            },
            {
                "value": "230300",
                "label": "鸡西市",
                "parent": "230000",
                "children": [
                    {
                        "label": "鸡冠区",
                        "value": "230302",
                        "parent": "230300"
                    },
                    {
                        "label": "恒山区",
                        "value": "230303",
                        "parent": "230300"
                    },
                    {
                        "label": "滴道区",
                        "value": "230304",
                        "parent": "230300"
                    },
                    {
                        "label": "梨树区",
                        "value": "230305",
                        "parent": "230300"
                    },
                    {
                        "label": "城子河区",
                        "value": "230306",
                        "parent": "230300"
                    },
                    {
                        "label": "麻山区",
                        "value": "230307",
                        "parent": "230300"
                    },
                    {
                        "label": "鸡东县",
                        "value": "230321",
                        "parent": "230300"
                    },
                    {
                        "label": "虎林市",
                        "value": "230381",
                        "parent": "230300"
                    },
                    {
                        "label": "密山市",
                        "value": "230382",
                        "parent": "230300"
                    }
                ]
            },
            {
                "value": "230400",
                "label": "鹤岗市",
                "parent": "230000",
                "children": [
                    {
                        "label": "向阳区",
                        "value": "230402",
                        "parent": "230400"
                    },
                    {
                        "label": "工农区",
                        "value": "230403",
                        "parent": "230400"
                    },
                    {
                        "label": "南山区",
                        "value": "230404",
                        "parent": "230400"
                    },
                    {
                        "label": "兴安区",
                        "value": "230405",
                        "parent": "230400"
                    },
                    {
                        "label": "东山区",
                        "value": "230406",
                        "parent": "230400"
                    },
                    {
                        "label": "兴山区",
                        "value": "230407",
                        "parent": "230400"
                    },
                    {
                        "label": "萝北县",
                        "value": "230421",
                        "parent": "230400"
                    },
                    {
                        "label": "绥滨县",
                        "value": "230422",
                        "parent": "230400"
                    }
                ]
            },
            {
                "value": "230500",
                "label": "双鸭山市",
                "parent": "230000",
                "children": [
                    {
                        "label": "尖山区",
                        "value": "230502",
                        "parent": "230500"
                    },
                    {
                        "label": "岭东区",
                        "value": "230503",
                        "parent": "230500"
                    },
                    {
                        "label": "四方台区",
                        "value": "230505",
                        "parent": "230500"
                    },
                    {
                        "label": "宝山区",
                        "value": "230506",
                        "parent": "230500"
                    },
                    {
                        "label": "集贤县",
                        "value": "230521",
                        "parent": "230500"
                    },
                    {
                        "label": "友谊县",
                        "value": "230522",
                        "parent": "230500"
                    },
                    {
                        "label": "宝清县",
                        "value": "230523",
                        "parent": "230500"
                    },
                    {
                        "label": "饶河县",
                        "value": "230524",
                        "parent": "230500"
                    }
                ]
            },
            {
                "value": "230600",
                "label": "大庆市",
                "parent": "230000",
                "children": [
                    {
                        "label": "萨尔图区",
                        "value": "230602",
                        "parent": "230600"
                    },
                    {
                        "label": "龙凤区",
                        "value": "230603",
                        "parent": "230600"
                    },
                    {
                        "label": "让胡路区",
                        "value": "230604",
                        "parent": "230600"
                    },
                    {
                        "label": "红岗区",
                        "value": "230605",
                        "parent": "230600"
                    },
                    {
                        "label": "大同区",
                        "value": "230606",
                        "parent": "230600"
                    },
                    {
                        "label": "肇州县",
                        "value": "230621",
                        "parent": "230600"
                    },
                    {
                        "label": "肇源县",
                        "value": "230622",
                        "parent": "230600"
                    },
                    {
                        "label": "林甸县",
                        "value": "230623",
                        "parent": "230600"
                    },
                    {
                        "label": "杜尔伯特蒙古族自治县",
                        "value": "230624",
                        "parent": "230600"
                    },
                    {
                        "label": "大庆高新技术产业开发区",
                        "value": "230671",
                        "parent": "230600"
                    }
                ]
            },
            {
                "value": "230700",
                "label": "伊春市",
                "parent": "230000",
                "children": [
                    {
                        "label": "伊美区",
                        "value": "230717",
                        "parent": "230700"
                    },
                    {
                        "label": "乌翠区",
                        "value": "230718",
                        "parent": "230700"
                    },
                    {
                        "label": "友好区",
                        "value": "230719",
                        "parent": "230700"
                    },
                    {
                        "label": "嘉荫县",
                        "value": "230722",
                        "parent": "230700"
                    },
                    {
                        "label": "汤旺县",
                        "value": "230723",
                        "parent": "230700"
                    },
                    {
                        "label": "丰林县",
                        "value": "230724",
                        "parent": "230700"
                    },
                    {
                        "label": "大箐山县",
                        "value": "230725",
                        "parent": "230700"
                    },
                    {
                        "label": "南岔县",
                        "value": "230726",
                        "parent": "230700"
                    },
                    {
                        "label": "金林区",
                        "value": "230751",
                        "parent": "230700"
                    },
                    {
                        "label": "铁力市",
                        "value": "230781",
                        "parent": "230700"
                    }
                ]
            },
            {
                "value": "230800",
                "label": "佳木斯市",
                "parent": "230000",
                "children": [
                    {
                        "label": "向阳区",
                        "value": "230803",
                        "parent": "230800"
                    },
                    {
                        "label": "前进区",
                        "value": "230804",
                        "parent": "230800"
                    },
                    {
                        "label": "东风区",
                        "value": "230805",
                        "parent": "230800"
                    },
                    {
                        "label": "郊区",
                        "value": "230811",
                        "parent": "230800"
                    },
                    {
                        "label": "桦南县",
                        "value": "230822",
                        "parent": "230800"
                    },
                    {
                        "label": "桦川县",
                        "value": "230826",
                        "parent": "230800"
                    },
                    {
                        "label": "汤原县",
                        "value": "230828",
                        "parent": "230800"
                    },
                    {
                        "label": "同江市",
                        "value": "230881",
                        "parent": "230800"
                    },
                    {
                        "label": "富锦市",
                        "value": "230882",
                        "parent": "230800"
                    },
                    {
                        "label": "抚远市",
                        "value": "230883",
                        "parent": "230800"
                    }
                ]
            },
            {
                "value": "230900",
                "label": "七台河市",
                "parent": "230000",
                "children": [
                    {
                        "label": "新兴区",
                        "value": "230902",
                        "parent": "230900"
                    },
                    {
                        "label": "桃山区",
                        "value": "230903",
                        "parent": "230900"
                    },
                    {
                        "label": "茄子河区",
                        "value": "230904",
                        "parent": "230900"
                    },
                    {
                        "label": "勃利县",
                        "value": "230921",
                        "parent": "230900"
                    }
                ]
            },
            {
                "value": "231000",
                "label": "牡丹江市",
                "parent": "230000",
                "children": [
                    {
                        "label": "东安区",
                        "value": "231002",
                        "parent": "231000"
                    },
                    {
                        "label": "阳明区",
                        "value": "231003",
                        "parent": "231000"
                    },
                    {
                        "label": "爱民区",
                        "value": "231004",
                        "parent": "231000"
                    },
                    {
                        "label": "西安区",
                        "value": "231005",
                        "parent": "231000"
                    },
                    {
                        "label": "林口县",
                        "value": "231025",
                        "parent": "231000"
                    },
                    {
                        "label": "绥芬河市",
                        "value": "231081",
                        "parent": "231000"
                    },
                    {
                        "label": "海林市",
                        "value": "231083",
                        "parent": "231000"
                    },
                    {
                        "label": "宁安市",
                        "value": "231084",
                        "parent": "231000"
                    },
                    {
                        "label": "穆棱市",
                        "value": "231085",
                        "parent": "231000"
                    },
                    {
                        "label": "东宁市",
                        "value": "231086",
                        "parent": "231000"
                    }
                ]
            },
            {
                "value": "231100",
                "label": "黑河市",
                "parent": "230000",
                "children": [
                    {
                        "label": "爱辉区",
                        "value": "231102",
                        "parent": "231100"
                    },
                    {
                        "label": "逊克县",
                        "value": "231123",
                        "parent": "231100"
                    },
                    {
                        "label": "孙吴县",
                        "value": "231124",
                        "parent": "231100"
                    },
                    {
                        "label": "北安市",
                        "value": "231181",
                        "parent": "231100"
                    },
                    {
                        "label": "五大连池市",
                        "value": "231182",
                        "parent": "231100"
                    },
                    {
                        "label": "嫩江市",
                        "value": "231183",
                        "parent": "231100"
                    }
                ]
            },
            {
                "value": "231200",
                "label": "绥化市",
                "parent": "230000",
                "children": [
                    {
                        "label": "北林区",
                        "value": "231202",
                        "parent": "231200"
                    },
                    {
                        "label": "望奎县",
                        "value": "231221",
                        "parent": "231200"
                    },
                    {
                        "label": "兰西县",
                        "value": "231222",
                        "parent": "231200"
                    },
                    {
                        "label": "青冈县",
                        "value": "231223",
                        "parent": "231200"
                    },
                    {
                        "label": "庆安县",
                        "value": "231224",
                        "parent": "231200"
                    },
                    {
                        "label": "明水县",
                        "value": "231225",
                        "parent": "231200"
                    },
                    {
                        "label": "绥棱县",
                        "value": "231226",
                        "parent": "231200"
                    },
                    {
                        "label": "安达市",
                        "value": "231281",
                        "parent": "231200"
                    },
                    {
                        "label": "肇东市",
                        "value": "231282",
                        "parent": "231200"
                    },
                    {
                        "label": "海伦市",
                        "value": "231283",
                        "parent": "231200"
                    }
                ]
            },
            {
                "value": "232700",
                "label": "大兴安岭地区",
                "parent": "230000",
                "children": [
                    {
                        "label": "漠河市",
                        "value": "232701",
                        "parent": "232700"
                    },
                    {
                        "label": "呼玛县",
                        "value": "232721",
                        "parent": "232700"
                    },
                    {
                        "label": "塔河县",
                        "value": "232722",
                        "parent": "232700"
                    },
                    {
                        "label": "松岭区",
                        "value": "232790",
                        "parent": "232700"
                    },
                    {
                        "label": "呼中区",
                        "value": "232791",
                        "parent": "232700"
                    },
                    {
                        "label": "加格达奇区",
                        "value": "232792",
                        "parent": "232700"
                    },
                    {
                        "label": "新林区",
                        "value": "232793",
                        "parent": "232700"
                    }
                ]
            }
        ]
    },
    {
        "value": "310000",
        "label": "上海",
        "children": [
            {
                "value": "310100",
                "label": "上海市",
                "parent": "310000",
                "children": [
                    {
                        "label": "黄浦区",
                        "value": "310101",
                        "parent": "310100"
                    },
                    {
                        "label": "徐汇区",
                        "value": "310104",
                        "parent": "310100"
                    },
                    {
                        "label": "长宁区",
                        "value": "310105",
                        "parent": "310100"
                    },
                    {
                        "label": "静安区",
                        "value": "310106",
                        "parent": "310100"
                    },
                    {
                        "label": "普陀区",
                        "value": "310107",
                        "parent": "310100"
                    },
                    {
                        "label": "虹口区",
                        "value": "310109",
                        "parent": "310100"
                    },
                    {
                        "label": "杨浦区",
                        "value": "310110",
                        "parent": "310100"
                    },
                    {
                        "label": "闵行区",
                        "value": "310112",
                        "parent": "310100"
                    },
                    {
                        "label": "宝山区",
                        "value": "310113",
                        "parent": "310100"
                    },
                    {
                        "label": "嘉定区",
                        "value": "310114",
                        "parent": "310100"
                    },
                    {
                        "label": "浦东新区",
                        "value": "310115",
                        "parent": "310100"
                    },
                    {
                        "label": "金山区",
                        "value": "310116",
                        "parent": "310100"
                    },
                    {
                        "label": "松江区",
                        "value": "310117",
                        "parent": "310100"
                    },
                    {
                        "label": "青浦区",
                        "value": "310118",
                        "parent": "310100"
                    },
                    {
                        "label": "奉贤区",
                        "value": "310120",
                        "parent": "310100"
                    },
                    {
                        "label": "崇明区",
                        "value": "310151",
                        "parent": "310100"
                    }
                ]
            }
        ]
    },
    {
        "value": "320000",
        "label": "江苏省",
        "children": [
            {
                "value": "320100",
                "label": "南京市",
                "parent": "320000",
                "children": [
                    {
                        "label": "玄武区",
                        "value": "320102",
                        "parent": "320100"
                    },
                    {
                        "label": "秦淮区",
                        "value": "320104",
                        "parent": "320100"
                    },
                    {
                        "label": "建邺区",
                        "value": "320105",
                        "parent": "320100"
                    },
                    {
                        "label": "鼓楼区",
                        "value": "320106",
                        "parent": "320100"
                    },
                    {
                        "label": "浦口区",
                        "value": "320111",
                        "parent": "320100"
                    },
                    {
                        "label": "江北新区",
                        "value": "320112",
                        "parent": "320100"
                    },
                    {
                        "label": "栖霞区",
                        "value": "320113",
                        "parent": "320100"
                    },
                    {
                        "label": "雨花台区",
                        "value": "320114",
                        "parent": "320100"
                    },
                    {
                        "label": "江宁区",
                        "value": "320115",
                        "parent": "320100"
                    },
                    {
                        "label": "六合区",
                        "value": "320116",
                        "parent": "320100"
                    },
                    {
                        "label": "溧水区",
                        "value": "320117",
                        "parent": "320100"
                    },
                    {
                        "label": "高淳区",
                        "value": "320118",
                        "parent": "320100"
                    }
                ]
            },
            {
                "value": "320200",
                "label": "无锡市",
                "parent": "320000",
                "children": [
                    {
                        "label": "锡山区",
                        "value": "320205",
                        "parent": "320200"
                    },
                    {
                        "label": "惠山区",
                        "value": "320206",
                        "parent": "320200"
                    },
                    {
                        "label": "滨湖区",
                        "value": "320211",
                        "parent": "320200"
                    },
                    {
                        "label": "梁溪区",
                        "value": "320213",
                        "parent": "320200"
                    },
                    {
                        "label": "新吴区",
                        "value": "320214",
                        "parent": "320200"
                    },
                    {
                        "label": "江阴市",
                        "value": "320281",
                        "parent": "320200"
                    },
                    {
                        "label": "宜兴市",
                        "value": "320282",
                        "parent": "320200"
                    }
                ]
            },
            {
                "value": "320300",
                "label": "徐州市",
                "parent": "320000",
                "children": [
                    {
                        "label": "鼓楼区",
                        "value": "320302",
                        "parent": "320300"
                    },
                    {
                        "label": "云龙区",
                        "value": "320303",
                        "parent": "320300"
                    },
                    {
                        "label": "贾汪区",
                        "value": "320305",
                        "parent": "320300"
                    },
                    {
                        "label": "泉山区",
                        "value": "320311",
                        "parent": "320300"
                    },
                    {
                        "label": "铜山区",
                        "value": "320312",
                        "parent": "320300"
                    },
                    {
                        "label": "丰县",
                        "value": "320321",
                        "parent": "320300"
                    },
                    {
                        "label": "沛县",
                        "value": "320322",
                        "parent": "320300"
                    },
                    {
                        "label": "睢宁县",
                        "value": "320324",
                        "parent": "320300"
                    },
                    {
                        "label": "徐州经济技术开发区",
                        "value": "320371",
                        "parent": "320300"
                    },
                    {
                        "label": "新沂市",
                        "value": "320381",
                        "parent": "320300"
                    },
                    {
                        "label": "邳州市",
                        "value": "320382",
                        "parent": "320300"
                    },
                    {
                        "label": "工业园区",
                        "value": "320391",
                        "parent": "320300"
                    }
                ]
            },
            {
                "value": "320400",
                "label": "常州市",
                "parent": "320000",
                "children": [
                    {
                        "label": "天宁区",
                        "value": "320402",
                        "parent": "320400"
                    },
                    {
                        "label": "钟楼区",
                        "value": "320404",
                        "parent": "320400"
                    },
                    {
                        "label": "新北区",
                        "value": "320411",
                        "parent": "320400"
                    },
                    {
                        "label": "武进区",
                        "value": "320412",
                        "parent": "320400"
                    },
                    {
                        "label": "金坛区",
                        "value": "320413",
                        "parent": "320400"
                    },
                    {
                        "label": "溧阳市",
                        "value": "320481",
                        "parent": "320400"
                    }
                ]
            },
            {
                "value": "320500",
                "label": "苏州市",
                "parent": "320000",
                "children": [
                    {
                        "label": "虎丘区",
                        "value": "320505",
                        "parent": "320500"
                    },
                    {
                        "label": "吴中区",
                        "value": "320506",
                        "parent": "320500"
                    },
                    {
                        "label": "相城区",
                        "value": "320507",
                        "parent": "320500"
                    },
                    {
                        "label": "姑苏区",
                        "value": "320508",
                        "parent": "320500"
                    },
                    {
                        "label": "吴江区",
                        "value": "320509",
                        "parent": "320500"
                    },
                    {
                        "label": "苏州工业园区",
                        "value": "320571",
                        "parent": "320500"
                    },
                    {
                        "label": "常熟市",
                        "value": "320581",
                        "parent": "320500"
                    },
                    {
                        "label": "张家港市",
                        "value": "320582",
                        "parent": "320500"
                    },
                    {
                        "label": "昆山市",
                        "value": "320583",
                        "parent": "320500"
                    },
                    {
                        "label": "太仓市",
                        "value": "320585",
                        "parent": "320500"
                    },
                    {
                        "label": "工业园区",
                        "value": "320590",
                        "parent": "320500"
                    },
                    {
                        "label": "高新区",
                        "value": "320591",
                        "parent": "320500"
                    }
                ]
            },
            {
                "value": "320600",
                "label": "南通市",
                "parent": "320000",
                "children": [
                    {
                        "label": "崇川区",
                        "value": "320602",
                        "parent": "320600"
                    },
                    {
                        "label": "港闸区",
                        "value": "320611",
                        "parent": "320600"
                    },
                    {
                        "label": "通州区",
                        "value": "320612",
                        "parent": "320600"
                    },
                    {
                        "label": "如东县",
                        "value": "320623",
                        "parent": "320600"
                    },
                    {
                        "label": "启东市",
                        "value": "320681",
                        "parent": "320600"
                    },
                    {
                        "label": "如皋市",
                        "value": "320682",
                        "parent": "320600"
                    },
                    {
                        "label": "海门市",
                        "value": "320684",
                        "parent": "320600"
                    },
                    {
                        "label": "海安市",
                        "value": "320685",
                        "parent": "320600"
                    },
                    {
                        "label": "高新区",
                        "value": "320691",
                        "parent": "320600"
                    }
                ]
            },
            {
                "value": "320700",
                "label": "连云港市",
                "parent": "320000",
                "children": [
                    {
                        "label": "连云区",
                        "value": "320703",
                        "parent": "320700"
                    },
                    {
                        "label": "海州区",
                        "value": "320706",
                        "parent": "320700"
                    },
                    {
                        "label": "赣榆区",
                        "value": "320707",
                        "parent": "320700"
                    },
                    {
                        "label": "东海县",
                        "value": "320722",
                        "parent": "320700"
                    },
                    {
                        "label": "灌云县",
                        "value": "320723",
                        "parent": "320700"
                    },
                    {
                        "label": "灌南县",
                        "value": "320724",
                        "parent": "320700"
                    },
                    {
                        "label": "连云港经济技术开发区",
                        "value": "320771",
                        "parent": "320700"
                    }
                ]
            },
            {
                "value": "320800",
                "label": "淮安市",
                "parent": "320000",
                "children": [
                    {
                        "label": "淮安区",
                        "value": "320803",
                        "parent": "320800"
                    },
                    {
                        "label": "淮阴区",
                        "value": "320804",
                        "parent": "320800"
                    },
                    {
                        "label": "清江浦区",
                        "value": "320812",
                        "parent": "320800"
                    },
                    {
                        "label": "洪泽区",
                        "value": "320813",
                        "parent": "320800"
                    },
                    {
                        "label": "涟水县",
                        "value": "320826",
                        "parent": "320800"
                    },
                    {
                        "label": "盱眙县",
                        "value": "320830",
                        "parent": "320800"
                    },
                    {
                        "label": "金湖县",
                        "value": "320831",
                        "parent": "320800"
                    },
                    {
                        "label": "淮安经济技术开发区",
                        "value": "320871",
                        "parent": "320800"
                    },
                    {
                        "label": "经济开发区",
                        "value": "320890",
                        "parent": "320800"
                    }
                ]
            },
            {
                "value": "320900",
                "label": "盐城市",
                "parent": "320000",
                "children": [
                    {
                        "label": "亭湖区",
                        "value": "320902",
                        "parent": "320900"
                    },
                    {
                        "label": "盐都区",
                        "value": "320903",
                        "parent": "320900"
                    },
                    {
                        "label": "大丰区",
                        "value": "320904",
                        "parent": "320900"
                    },
                    {
                        "label": "响水县",
                        "value": "320921",
                        "parent": "320900"
                    },
                    {
                        "label": "滨海县",
                        "value": "320922",
                        "parent": "320900"
                    },
                    {
                        "label": "阜宁县",
                        "value": "320923",
                        "parent": "320900"
                    },
                    {
                        "label": "射阳县",
                        "value": "320924",
                        "parent": "320900"
                    },
                    {
                        "label": "建湖县",
                        "value": "320925",
                        "parent": "320900"
                    },
                    {
                        "label": "盐城经济技术开发区",
                        "value": "320971",
                        "parent": "320900"
                    },
                    {
                        "label": "东台市",
                        "value": "320981",
                        "parent": "320900"
                    }
                ]
            },
            {
                "value": "321000",
                "label": "扬州市",
                "parent": "320000",
                "children": [
                    {
                        "label": "广陵区",
                        "value": "321002",
                        "parent": "321000"
                    },
                    {
                        "label": "邗江区",
                        "value": "321003",
                        "parent": "321000"
                    },
                    {
                        "label": "江都区",
                        "value": "321012",
                        "parent": "321000"
                    },
                    {
                        "label": "宝应县",
                        "value": "321023",
                        "parent": "321000"
                    },
                    {
                        "label": "扬州经济技术开发区",
                        "value": "321071",
                        "parent": "321000"
                    },
                    {
                        "label": "仪征市",
                        "value": "321081",
                        "parent": "321000"
                    },
                    {
                        "label": "高邮市",
                        "value": "321084",
                        "parent": "321000"
                    },
                    {
                        "label": "经济开发区",
                        "value": "321090",
                        "parent": "321000"
                    }
                ]
            },
            {
                "value": "321100",
                "label": "镇江市",
                "parent": "320000",
                "children": [
                    {
                        "label": "京口区",
                        "value": "321102",
                        "parent": "321100"
                    },
                    {
                        "label": "润州区",
                        "value": "321111",
                        "parent": "321100"
                    },
                    {
                        "label": "丹徒区",
                        "value": "321112",
                        "parent": "321100"
                    },
                    {
                        "label": "镇江新区",
                        "value": "321150",
                        "parent": "321100"
                    },
                    {
                        "label": "丹阳市",
                        "value": "321181",
                        "parent": "321100"
                    },
                    {
                        "label": "扬中市",
                        "value": "321182",
                        "parent": "321100"
                    },
                    {
                        "label": "句容市",
                        "value": "321183",
                        "parent": "321100"
                    }
                ]
            },
            {
                "value": "321200",
                "label": "泰州市",
                "parent": "320000",
                "children": [
                    {
                        "label": "海陵区",
                        "value": "321202",
                        "parent": "321200"
                    },
                    {
                        "label": "高港区",
                        "value": "321203",
                        "parent": "321200"
                    },
                    {
                        "label": "姜堰区",
                        "value": "321204",
                        "parent": "321200"
                    },
                    {
                        "label": "泰州医药高新技术产业开发区",
                        "value": "321271",
                        "parent": "321200"
                    },
                    {
                        "label": "兴化市",
                        "value": "321281",
                        "parent": "321200"
                    },
                    {
                        "label": "靖江市",
                        "value": "321282",
                        "parent": "321200"
                    },
                    {
                        "label": "泰兴市",
                        "value": "321283",
                        "parent": "321200"
                    }
                ]
            },
            {
                "value": "321300",
                "label": "宿迁市",
                "parent": "320000",
                "children": [
                    {
                        "label": "宿城区",
                        "value": "321302",
                        "parent": "321300"
                    },
                    {
                        "label": "宿豫区",
                        "value": "321311",
                        "parent": "321300"
                    },
                    {
                        "label": "沭阳县",
                        "value": "321322",
                        "parent": "321300"
                    },
                    {
                        "label": "泗阳县",
                        "value": "321323",
                        "parent": "321300"
                    },
                    {
                        "label": "泗洪县",
                        "value": "321324",
                        "parent": "321300"
                    },
                    {
                        "label": "宿迁经济技术开发区",
                        "value": "321371",
                        "parent": "321300"
                    }
                ]
            }
        ]
    },
    {
        "value": "330000",
        "label": "浙江省",
        "children": [
            {
                "value": "330100",
                "label": "杭州市",
                "parent": "330000",
                "children": [
                    {
                        "label": "上城区",
                        "value": "330102",
                        "parent": "330100"
                    },
                    {
                        "label": "拱墅区",
                        "value": "330105",
                        "parent": "330100"
                    },
                    {
                        "label": "西湖区",
                        "value": "330106",
                        "parent": "330100"
                    },
                    {
                        "label": "滨江区",
                        "value": "330108",
                        "parent": "330100"
                    },
                    {
                        "label": "萧山区",
                        "value": "330109",
                        "parent": "330100"
                    },
                    {
                        "label": "余杭区",
                        "value": "330110",
                        "parent": "330100"
                    },
                    {
                        "label": "富阳区",
                        "value": "330111",
                        "parent": "330100"
                    },
                    {
                        "label": "临安区",
                        "value": "330112",
                        "parent": "330100"
                    },
                    {
                        "label": "临平区",
                        "value": "330113",
                        "parent": "330100"
                    },
                    {
                        "label": "钱塘区",
                        "value": "330114",
                        "parent": "330100"
                    },
                    {
                        "label": "桐庐县",
                        "value": "330122",
                        "parent": "330100"
                    },
                    {
                        "label": "淳安县",
                        "value": "330127",
                        "parent": "330100"
                    },
                    {
                        "label": "建德市",
                        "value": "330182",
                        "parent": "330100"
                    }
                ]
            },
            {
                "value": "330200",
                "label": "宁波市",
                "parent": "330000",
                "children": [
                    {
                        "label": "海曙区",
                        "value": "330203",
                        "parent": "330200"
                    },
                    {
                        "label": "江北区",
                        "value": "330205",
                        "parent": "330200"
                    },
                    {
                        "label": "北仑区",
                        "value": "330206",
                        "parent": "330200"
                    },
                    {
                        "label": "镇海区",
                        "value": "330211",
                        "parent": "330200"
                    },
                    {
                        "label": "鄞州区",
                        "value": "330212",
                        "parent": "330200"
                    },
                    {
                        "label": "奉化区",
                        "value": "330213",
                        "parent": "330200"
                    },
                    {
                        "label": "象山县",
                        "value": "330225",
                        "parent": "330200"
                    },
                    {
                        "label": "宁海县",
                        "value": "330226",
                        "parent": "330200"
                    },
                    {
                        "label": "余姚市",
                        "value": "330281",
                        "parent": "330200"
                    },
                    {
                        "label": "慈溪市",
                        "value": "330282",
                        "parent": "330200"
                    }
                ]
            },
            {
                "value": "330300",
                "label": "温州市",
                "parent": "330000",
                "children": [
                    {
                        "label": "鹿城区",
                        "value": "330302",
                        "parent": "330300"
                    },
                    {
                        "label": "龙湾区",
                        "value": "330303",
                        "parent": "330300"
                    },
                    {
                        "label": "瓯海区",
                        "value": "330304",
                        "parent": "330300"
                    },
                    {
                        "label": "洞头区",
                        "value": "330305",
                        "parent": "330300"
                    },
                    {
                        "label": "永嘉县",
                        "value": "330324",
                        "parent": "330300"
                    },
                    {
                        "label": "平阳县",
                        "value": "330326",
                        "parent": "330300"
                    },
                    {
                        "label": "苍南县",
                        "value": "330327",
                        "parent": "330300"
                    },
                    {
                        "label": "文成县",
                        "value": "330328",
                        "parent": "330300"
                    },
                    {
                        "label": "泰顺县",
                        "value": "330329",
                        "parent": "330300"
                    },
                    {
                        "label": "瑞安市",
                        "value": "330381",
                        "parent": "330300"
                    },
                    {
                        "label": "乐清市",
                        "value": "330382",
                        "parent": "330300"
                    },
                    {
                        "label": "龙港市",
                        "value": "330383",
                        "parent": "330300"
                    }
                ]
            },
            {
                "value": "330400",
                "label": "嘉兴市",
                "parent": "330000",
                "children": [
                    {
                        "label": "南湖区",
                        "value": "330402",
                        "parent": "330400"
                    },
                    {
                        "label": "秀洲区",
                        "value": "330411",
                        "parent": "330400"
                    },
                    {
                        "label": "嘉善县",
                        "value": "330421",
                        "parent": "330400"
                    },
                    {
                        "label": "海盐县",
                        "value": "330424",
                        "parent": "330400"
                    },
                    {
                        "label": "海宁市",
                        "value": "330481",
                        "parent": "330400"
                    },
                    {
                        "label": "平湖市",
                        "value": "330482",
                        "parent": "330400"
                    },
                    {
                        "label": "桐乡市",
                        "value": "330483",
                        "parent": "330400"
                    }
                ]
            },
            {
                "value": "330500",
                "label": "湖州市",
                "parent": "330000",
                "children": [
                    {
                        "label": "吴兴区",
                        "value": "330502",
                        "parent": "330500"
                    },
                    {
                        "label": "南浔区",
                        "value": "330503",
                        "parent": "330500"
                    },
                    {
                        "label": "德清县",
                        "value": "330521",
                        "parent": "330500"
                    },
                    {
                        "label": "长兴县",
                        "value": "330522",
                        "parent": "330500"
                    },
                    {
                        "label": "安吉县",
                        "value": "330523",
                        "parent": "330500"
                    }
                ]
            },
            {
                "value": "330600",
                "label": "绍兴市",
                "parent": "330000",
                "children": [
                    {
                        "label": "越城区",
                        "value": "330602",
                        "parent": "330600"
                    },
                    {
                        "label": "柯桥区",
                        "value": "330603",
                        "parent": "330600"
                    },
                    {
                        "label": "上虞区",
                        "value": "330604",
                        "parent": "330600"
                    },
                    {
                        "label": "新昌县",
                        "value": "330624",
                        "parent": "330600"
                    },
                    {
                        "label": "诸暨市",
                        "value": "330681",
                        "parent": "330600"
                    },
                    {
                        "label": "嵊州市",
                        "value": "330683",
                        "parent": "330600"
                    }
                ]
            },
            {
                "value": "330700",
                "label": "金华市",
                "parent": "330000",
                "children": [
                    {
                        "label": "婺城区",
                        "value": "330702",
                        "parent": "330700"
                    },
                    {
                        "label": "金东区",
                        "value": "330703",
                        "parent": "330700"
                    },
                    {
                        "label": "武义县",
                        "value": "330723",
                        "parent": "330700"
                    },
                    {
                        "label": "浦江县",
                        "value": "330726",
                        "parent": "330700"
                    },
                    {
                        "label": "磐安县",
                        "value": "330727",
                        "parent": "330700"
                    },
                    {
                        "label": "兰溪市",
                        "value": "330781",
                        "parent": "330700"
                    },
                    {
                        "label": "义乌市",
                        "value": "330782",
                        "parent": "330700"
                    },
                    {
                        "label": "东阳市",
                        "value": "330783",
                        "parent": "330700"
                    },
                    {
                        "label": "永康市",
                        "value": "330784",
                        "parent": "330700"
                    }
                ]
            },
            {
                "value": "330800",
                "label": "衢州市",
                "parent": "330000",
                "children": [
                    {
                        "label": "柯城区",
                        "value": "330802",
                        "parent": "330800"
                    },
                    {
                        "label": "衢江区",
                        "value": "330803",
                        "parent": "330800"
                    },
                    {
                        "label": "常山县",
                        "value": "330822",
                        "parent": "330800"
                    },
                    {
                        "label": "开化县",
                        "value": "330824",
                        "parent": "330800"
                    },
                    {
                        "label": "龙游县",
                        "value": "330825",
                        "parent": "330800"
                    },
                    {
                        "label": "江山市",
                        "value": "330881",
                        "parent": "330800"
                    }
                ]
            },
            {
                "value": "330900",
                "label": "舟山市",
                "parent": "330000",
                "children": [
                    {
                        "label": "定海区",
                        "value": "330902",
                        "parent": "330900"
                    },
                    {
                        "label": "普陀区",
                        "value": "330903",
                        "parent": "330900"
                    },
                    {
                        "label": "岱山县",
                        "value": "330921",
                        "parent": "330900"
                    },
                    {
                        "label": "嵊泗县",
                        "value": "330922",
                        "parent": "330900"
                    }
                ]
            },
            {
                "value": "331000",
                "label": "台州市",
                "parent": "330000",
                "children": [
                    {
                        "label": "椒江区",
                        "value": "331002",
                        "parent": "331000"
                    },
                    {
                        "label": "黄岩区",
                        "value": "331003",
                        "parent": "331000"
                    },
                    {
                        "label": "路桥区",
                        "value": "331004",
                        "parent": "331000"
                    },
                    {
                        "label": "三门县",
                        "value": "331022",
                        "parent": "331000"
                    },
                    {
                        "label": "天台县",
                        "value": "331023",
                        "parent": "331000"
                    },
                    {
                        "label": "仙居县",
                        "value": "331024",
                        "parent": "331000"
                    },
                    {
                        "label": "温岭市",
                        "value": "331081",
                        "parent": "331000"
                    },
                    {
                        "label": "临海市",
                        "value": "331082",
                        "parent": "331000"
                    },
                    {
                        "label": "玉环市",
                        "value": "331083",
                        "parent": "331000"
                    }
                ]
            },
            {
                "value": "331100",
                "label": "丽水市",
                "parent": "330000",
                "children": [
                    {
                        "label": "莲都区",
                        "value": "331102",
                        "parent": "331100"
                    },
                    {
                        "label": "青田县",
                        "value": "331121",
                        "parent": "331100"
                    },
                    {
                        "label": "缙云县",
                        "value": "331122",
                        "parent": "331100"
                    },
                    {
                        "label": "遂昌县",
                        "value": "331123",
                        "parent": "331100"
                    },
                    {
                        "label": "松阳县",
                        "value": "331124",
                        "parent": "331100"
                    },
                    {
                        "label": "云和县",
                        "value": "331125",
                        "parent": "331100"
                    },
                    {
                        "label": "庆元县",
                        "value": "331126",
                        "parent": "331100"
                    },
                    {
                        "label": "景宁畲族自治县",
                        "value": "331127",
                        "parent": "331100"
                    },
                    {
                        "label": "龙泉市",
                        "value": "331181",
                        "parent": "331100"
                    }
                ]
            }
        ]
    },
    {
        "value": "340000",
        "label": "安徽省",
        "children": [
            {
                "value": "340100",
                "label": "合肥市",
                "parent": "340000",
                "children": [
                    {
                        "label": "瑶海区",
                        "value": "340102",
                        "parent": "340100"
                    },
                    {
                        "label": "庐阳区",
                        "value": "340103",
                        "parent": "340100"
                    },
                    {
                        "label": "蜀山区",
                        "value": "340104",
                        "parent": "340100"
                    },
                    {
                        "label": "包河区",
                        "value": "340111",
                        "parent": "340100"
                    },
                    {
                        "label": "长丰县",
                        "value": "340121",
                        "parent": "340100"
                    },
                    {
                        "label": "肥东县",
                        "value": "340122",
                        "parent": "340100"
                    },
                    {
                        "label": "肥西县",
                        "value": "340123",
                        "parent": "340100"
                    },
                    {
                        "label": "庐江县",
                        "value": "340124",
                        "parent": "340100"
                    },
                    {
                        "label": "合肥高新技术产业开发区",
                        "value": "340171",
                        "parent": "340100"
                    },
                    {
                        "label": "合肥经济技术开发区",
                        "value": "340172",
                        "parent": "340100"
                    },
                    {
                        "label": "合肥新站高新技术产业开发区",
                        "value": "340173",
                        "parent": "340100"
                    },
                    {
                        "label": "巢湖市",
                        "value": "340181",
                        "parent": "340100"
                    },
                    {
                        "label": "高新技术开发区",
                        "value": "340190",
                        "parent": "340100"
                    },
                    {
                        "label": "经济技术开发区",
                        "value": "340191",
                        "parent": "340100"
                    }
                ]
            },
            {
                "value": "340200",
                "label": "芜湖市",
                "parent": "340000",
                "children": [
                    {
                        "label": "镜湖区",
                        "value": "340202",
                        "parent": "340200"
                    },
                    {
                        "label": "弋江区",
                        "value": "340203",
                        "parent": "340200"
                    },
                    {
                        "label": "鸠江区",
                        "value": "340207",
                        "parent": "340200"
                    },
                    {
                        "label": "三山区",
                        "value": "340208",
                        "parent": "340200"
                    },
                    {
                        "label": "芜湖县",
                        "value": "340221",
                        "parent": "340200"
                    },
                    {
                        "label": "繁昌县",
                        "value": "340222",
                        "parent": "340200"
                    },
                    {
                        "label": "南陵县",
                        "value": "340223",
                        "parent": "340200"
                    },
                    {
                        "label": "无为市",
                        "value": "340281",
                        "parent": "340200"
                    }
                ]
            },
            {
                "value": "340300",
                "label": "蚌埠市",
                "parent": "340000",
                "children": [
                    {
                        "label": "龙子湖区",
                        "value": "340302",
                        "parent": "340300"
                    },
                    {
                        "label": "蚌山区",
                        "value": "340303",
                        "parent": "340300"
                    },
                    {
                        "label": "禹会区",
                        "value": "340304",
                        "parent": "340300"
                    },
                    {
                        "label": "淮上区",
                        "value": "340311",
                        "parent": "340300"
                    },
                    {
                        "label": "怀远县",
                        "value": "340321",
                        "parent": "340300"
                    },
                    {
                        "label": "五河县",
                        "value": "340322",
                        "parent": "340300"
                    },
                    {
                        "label": "固镇县",
                        "value": "340323",
                        "parent": "340300"
                    },
                    {
                        "label": "蚌埠市高新技术开发区",
                        "value": "340371",
                        "parent": "340300"
                    },
                    {
                        "label": "蚌埠市经济开发区",
                        "value": "340372",
                        "parent": "340300"
                    }
                ]
            },
            {
                "value": "340400",
                "label": "淮南市",
                "parent": "340000",
                "children": [
                    {
                        "label": "大通区",
                        "value": "340402",
                        "parent": "340400"
                    },
                    {
                        "label": "田家庵区",
                        "value": "340403",
                        "parent": "340400"
                    },
                    {
                        "label": "谢家集区",
                        "value": "340404",
                        "parent": "340400"
                    },
                    {
                        "label": "八公山区",
                        "value": "340405",
                        "parent": "340400"
                    },
                    {
                        "label": "潘集区",
                        "value": "340406",
                        "parent": "340400"
                    },
                    {
                        "label": "凤台县",
                        "value": "340421",
                        "parent": "340400"
                    },
                    {
                        "label": "寿县",
                        "value": "340422",
                        "parent": "340400"
                    }
                ]
            },
            {
                "value": "340500",
                "label": "马鞍山市",
                "parent": "340000",
                "children": [
                    {
                        "label": "花山区",
                        "value": "340503",
                        "parent": "340500"
                    },
                    {
                        "label": "雨山区",
                        "value": "340504",
                        "parent": "340500"
                    },
                    {
                        "label": "博望区",
                        "value": "340506",
                        "parent": "340500"
                    },
                    {
                        "label": "当涂县",
                        "value": "340521",
                        "parent": "340500"
                    },
                    {
                        "label": "含山县",
                        "value": "340522",
                        "parent": "340500"
                    },
                    {
                        "label": "和县",
                        "value": "340523",
                        "parent": "340500"
                    }
                ]
            },
            {
                "value": "340600",
                "label": "淮北市",
                "parent": "340000",
                "children": [
                    {
                        "label": "杜集区",
                        "value": "340602",
                        "parent": "340600"
                    },
                    {
                        "label": "相山区",
                        "value": "340603",
                        "parent": "340600"
                    },
                    {
                        "label": "烈山区",
                        "value": "340604",
                        "parent": "340600"
                    },
                    {
                        "label": "濉溪县",
                        "value": "340621",
                        "parent": "340600"
                    }
                ]
            },
            {
                "value": "340700",
                "label": "铜陵市",
                "parent": "340000",
                "children": [
                    {
                        "label": "铜官区",
                        "value": "340705",
                        "parent": "340700"
                    },
                    {
                        "label": "义安区",
                        "value": "340706",
                        "parent": "340700"
                    },
                    {
                        "label": "郊区",
                        "value": "340711",
                        "parent": "340700"
                    },
                    {
                        "label": "枞阳县",
                        "value": "340722",
                        "parent": "340700"
                    }
                ]
            },
            {
                "value": "340800",
                "label": "安庆市",
                "parent": "340000",
                "children": [
                    {
                        "label": "迎江区",
                        "value": "340802",
                        "parent": "340800"
                    },
                    {
                        "label": "大观区",
                        "value": "340803",
                        "parent": "340800"
                    },
                    {
                        "label": "宜秀区",
                        "value": "340811",
                        "parent": "340800"
                    },
                    {
                        "label": "怀宁县",
                        "value": "340822",
                        "parent": "340800"
                    },
                    {
                        "label": "太湖县",
                        "value": "340825",
                        "parent": "340800"
                    },
                    {
                        "label": "宿松县",
                        "value": "340826",
                        "parent": "340800"
                    },
                    {
                        "label": "望江县",
                        "value": "340827",
                        "parent": "340800"
                    },
                    {
                        "label": "岳西县",
                        "value": "340828",
                        "parent": "340800"
                    },
                    {
                        "label": "桐城市",
                        "value": "340881",
                        "parent": "340800"
                    },
                    {
                        "label": "潜山市",
                        "value": "340882",
                        "parent": "340800"
                    }
                ]
            },
            {
                "value": "341000",
                "label": "黄山市",
                "parent": "340000",
                "children": [
                    {
                        "label": "屯溪区",
                        "value": "341002",
                        "parent": "341000"
                    },
                    {
                        "label": "黄山区",
                        "value": "341003",
                        "parent": "341000"
                    },
                    {
                        "label": "徽州区",
                        "value": "341004",
                        "parent": "341000"
                    },
                    {
                        "label": "歙县",
                        "value": "341021",
                        "parent": "341000"
                    },
                    {
                        "label": "休宁县",
                        "value": "341022",
                        "parent": "341000"
                    },
                    {
                        "label": "黟县",
                        "value": "341023",
                        "parent": "341000"
                    },
                    {
                        "label": "祁门县",
                        "value": "341024",
                        "parent": "341000"
                    }
                ]
            },
            {
                "value": "341100",
                "label": "滁州市",
                "parent": "340000",
                "children": [
                    {
                        "label": "琅琊区",
                        "value": "341102",
                        "parent": "341100"
                    },
                    {
                        "label": "南谯区",
                        "value": "341103",
                        "parent": "341100"
                    },
                    {
                        "label": "来安县",
                        "value": "341122",
                        "parent": "341100"
                    },
                    {
                        "label": "全椒县",
                        "value": "341124",
                        "parent": "341100"
                    },
                    {
                        "label": "定远县",
                        "value": "341125",
                        "parent": "341100"
                    },
                    {
                        "label": "凤阳县",
                        "value": "341126",
                        "parent": "341100"
                    },
                    {
                        "label": "天长市",
                        "value": "341181",
                        "parent": "341100"
                    },
                    {
                        "label": "明光市",
                        "value": "341182",
                        "parent": "341100"
                    }
                ]
            },
            {
                "value": "341200",
                "label": "阜阳市",
                "parent": "340000",
                "children": [
                    {
                        "label": "颍州区",
                        "value": "341202",
                        "parent": "341200"
                    },
                    {
                        "label": "颍东区",
                        "value": "341203",
                        "parent": "341200"
                    },
                    {
                        "label": "颍泉区",
                        "value": "341204",
                        "parent": "341200"
                    },
                    {
                        "label": "临泉县",
                        "value": "341221",
                        "parent": "341200"
                    },
                    {
                        "label": "太和县",
                        "value": "341222",
                        "parent": "341200"
                    },
                    {
                        "label": "阜南县",
                        "value": "341225",
                        "parent": "341200"
                    },
                    {
                        "label": "颍上县",
                        "value": "341226",
                        "parent": "341200"
                    },
                    {
                        "label": "阜阳合肥现代产业园区",
                        "value": "341271",
                        "parent": "341200"
                    },
                    {
                        "label": "界首市",
                        "value": "341282",
                        "parent": "341200"
                    }
                ]
            },
            {
                "value": "341300",
                "label": "宿州市",
                "parent": "340000",
                "children": [
                    {
                        "label": "埇桥区",
                        "value": "341302",
                        "parent": "341300"
                    },
                    {
                        "label": "砀山县",
                        "value": "341321",
                        "parent": "341300"
                    },
                    {
                        "label": "萧县",
                        "value": "341322",
                        "parent": "341300"
                    },
                    {
                        "label": "灵璧县",
                        "value": "341323",
                        "parent": "341300"
                    },
                    {
                        "label": "泗县",
                        "value": "341324",
                        "parent": "341300"
                    },
                    {
                        "label": "宿州马鞍山现代产业园区",
                        "value": "341371",
                        "parent": "341300"
                    },
                    {
                        "label": "宿州经济技术开发区",
                        "value": "341372",
                        "parent": "341300"
                    },
                    {
                        "label": "经济开发区",
                        "value": "341390",
                        "parent": "341300"
                    }
                ]
            },
            {
                "value": "341500",
                "label": "六安市",
                "parent": "340000",
                "children": [
                    {
                        "label": "金安区",
                        "value": "341502",
                        "parent": "341500"
                    },
                    {
                        "label": "裕安区",
                        "value": "341503",
                        "parent": "341500"
                    },
                    {
                        "label": "叶集区",
                        "value": "341504",
                        "parent": "341500"
                    },
                    {
                        "label": "霍邱县",
                        "value": "341522",
                        "parent": "341500"
                    },
                    {
                        "label": "舒城县",
                        "value": "341523",
                        "parent": "341500"
                    },
                    {
                        "label": "金寨县",
                        "value": "341524",
                        "parent": "341500"
                    },
                    {
                        "label": "霍山县",
                        "value": "341525",
                        "parent": "341500"
                    }
                ]
            },
            {
                "value": "341600",
                "label": "亳州市",
                "parent": "340000",
                "children": [
                    {
                        "label": "谯城区",
                        "value": "341602",
                        "parent": "341600"
                    },
                    {
                        "label": "涡阳县",
                        "value": "341621",
                        "parent": "341600"
                    },
                    {
                        "label": "蒙城县",
                        "value": "341622",
                        "parent": "341600"
                    },
                    {
                        "label": "利辛县",
                        "value": "341623",
                        "parent": "341600"
                    }
                ]
            },
            {
                "value": "341700",
                "label": "池州市",
                "parent": "340000",
                "children": [
                    {
                        "label": "贵池区",
                        "value": "341702",
                        "parent": "341700"
                    },
                    {
                        "label": "东至县",
                        "value": "341721",
                        "parent": "341700"
                    },
                    {
                        "label": "石台县",
                        "value": "341722",
                        "parent": "341700"
                    },
                    {
                        "label": "青阳县",
                        "value": "341723",
                        "parent": "341700"
                    }
                ]
            },
            {
                "value": "341800",
                "label": "宣城市",
                "parent": "340000",
                "children": [
                    {
                        "label": "宣州区",
                        "value": "341802",
                        "parent": "341800"
                    },
                    {
                        "label": "郎溪县",
                        "value": "341821",
                        "parent": "341800"
                    },
                    {
                        "label": "泾县",
                        "value": "341823",
                        "parent": "341800"
                    },
                    {
                        "label": "绩溪县",
                        "value": "341824",
                        "parent": "341800"
                    },
                    {
                        "label": "旌德县",
                        "value": "341825",
                        "parent": "341800"
                    },
                    {
                        "label": "宣城市经济开发区",
                        "value": "341871",
                        "parent": "341800"
                    },
                    {
                        "label": "宁国市",
                        "value": "341881",
                        "parent": "341800"
                    },
                    {
                        "label": "广德市",
                        "value": "341882",
                        "parent": "341800"
                    }
                ]
            }
        ]
    },
    {
        "value": "350000",
        "label": "福建省",
        "children": [
            {
                "value": "350100",
                "label": "福州市",
                "parent": "350000",
                "children": [
                    {
                        "label": "鼓楼区",
                        "value": "350102",
                        "parent": "350100"
                    },
                    {
                        "label": "台江区",
                        "value": "350103",
                        "parent": "350100"
                    },
                    {
                        "label": "仓山区",
                        "value": "350104",
                        "parent": "350100"
                    },
                    {
                        "label": "马尾区",
                        "value": "350105",
                        "parent": "350100"
                    },
                    {
                        "label": "晋安区",
                        "value": "350111",
                        "parent": "350100"
                    },
                    {
                        "label": "长乐区",
                        "value": "350112",
                        "parent": "350100"
                    },
                    {
                        "label": "闽侯县",
                        "value": "350121",
                        "parent": "350100"
                    },
                    {
                        "label": "连江县",
                        "value": "350122",
                        "parent": "350100"
                    },
                    {
                        "label": "罗源县",
                        "value": "350123",
                        "parent": "350100"
                    },
                    {
                        "label": "闽清县",
                        "value": "350124",
                        "parent": "350100"
                    },
                    {
                        "label": "永泰县",
                        "value": "350125",
                        "parent": "350100"
                    },
                    {
                        "label": "平潭县",
                        "value": "350128",
                        "parent": "350100"
                    },
                    {
                        "label": "福清市",
                        "value": "350181",
                        "parent": "350100"
                    }
                ]
            },
            {
                "value": "350200",
                "label": "厦门市",
                "parent": "350000",
                "children": [
                    {
                        "label": "思明区",
                        "value": "350203",
                        "parent": "350200"
                    },
                    {
                        "label": "海沧区",
                        "value": "350205",
                        "parent": "350200"
                    },
                    {
                        "label": "湖里区",
                        "value": "350206",
                        "parent": "350200"
                    },
                    {
                        "label": "集美区",
                        "value": "350211",
                        "parent": "350200"
                    },
                    {
                        "label": "同安区",
                        "value": "350212",
                        "parent": "350200"
                    },
                    {
                        "label": "翔安区",
                        "value": "350213",
                        "parent": "350200"
                    }
                ]
            },
            {
                "value": "350300",
                "label": "莆田市",
                "parent": "350000",
                "children": [
                    {
                        "label": "城厢区",
                        "value": "350302",
                        "parent": "350300"
                    },
                    {
                        "label": "涵江区",
                        "value": "350303",
                        "parent": "350300"
                    },
                    {
                        "label": "荔城区",
                        "value": "350304",
                        "parent": "350300"
                    },
                    {
                        "label": "秀屿区",
                        "value": "350305",
                        "parent": "350300"
                    },
                    {
                        "label": "仙游县",
                        "value": "350322",
                        "parent": "350300"
                    }
                ]
            },
            {
                "value": "350400",
                "label": "三明市",
                "parent": "350000",
                "children": [
                    {
                        "label": "梅列区",
                        "value": "350402",
                        "parent": "350400"
                    },
                    {
                        "label": "三元区",
                        "value": "350403",
                        "parent": "350400"
                    },
                    {
                        "label": "明溪县",
                        "value": "350421",
                        "parent": "350400"
                    },
                    {
                        "label": "清流县",
                        "value": "350423",
                        "parent": "350400"
                    },
                    {
                        "label": "宁化县",
                        "value": "350424",
                        "parent": "350400"
                    },
                    {
                        "label": "大田县",
                        "value": "350425",
                        "parent": "350400"
                    },
                    {
                        "label": "尤溪县",
                        "value": "350426",
                        "parent": "350400"
                    },
                    {
                        "label": "沙县",
                        "value": "350427",
                        "parent": "350400"
                    },
                    {
                        "label": "将乐县",
                        "value": "350428",
                        "parent": "350400"
                    },
                    {
                        "label": "泰宁县",
                        "value": "350429",
                        "parent": "350400"
                    },
                    {
                        "label": "建宁县",
                        "value": "350430",
                        "parent": "350400"
                    },
                    {
                        "label": "永安市",
                        "value": "350481",
                        "parent": "350400"
                    }
                ]
            },
            {
                "value": "350500",
                "label": "泉州市",
                "parent": "350000",
                "children": [
                    {
                        "label": "鲤城区",
                        "value": "350502",
                        "parent": "350500"
                    },
                    {
                        "label": "丰泽区",
                        "value": "350503",
                        "parent": "350500"
                    },
                    {
                        "label": "洛江区",
                        "value": "350504",
                        "parent": "350500"
                    },
                    {
                        "label": "泉港区",
                        "value": "350505",
                        "parent": "350500"
                    },
                    {
                        "label": "惠安县",
                        "value": "350521",
                        "parent": "350500"
                    },
                    {
                        "label": "安溪县",
                        "value": "350524",
                        "parent": "350500"
                    },
                    {
                        "label": "永春县",
                        "value": "350525",
                        "parent": "350500"
                    },
                    {
                        "label": "德化县",
                        "value": "350526",
                        "parent": "350500"
                    },
                    {
                        "label": "金门县",
                        "value": "350527",
                        "parent": "350500"
                    },
                    {
                        "label": "石狮市",
                        "value": "350581",
                        "parent": "350500"
                    },
                    {
                        "label": "晋江市",
                        "value": "350582",
                        "parent": "350500"
                    },
                    {
                        "label": "南安市",
                        "value": "350583",
                        "parent": "350500"
                    }
                ]
            },
            {
                "value": "350600",
                "label": "漳州市",
                "parent": "350000",
                "children": [
                    {
                        "label": "芗城区",
                        "value": "350602",
                        "parent": "350600"
                    },
                    {
                        "label": "龙文区",
                        "value": "350603",
                        "parent": "350600"
                    },
                    {
                        "label": "云霄县",
                        "value": "350622",
                        "parent": "350600"
                    },
                    {
                        "label": "漳浦县",
                        "value": "350623",
                        "parent": "350600"
                    },
                    {
                        "label": "诏安县",
                        "value": "350624",
                        "parent": "350600"
                    },
                    {
                        "label": "长泰县",
                        "value": "350625",
                        "parent": "350600"
                    },
                    {
                        "label": "东山县",
                        "value": "350626",
                        "parent": "350600"
                    },
                    {
                        "label": "南靖县",
                        "value": "350627",
                        "parent": "350600"
                    },
                    {
                        "label": "平和县",
                        "value": "350628",
                        "parent": "350600"
                    },
                    {
                        "label": "华安县",
                        "value": "350629",
                        "parent": "350600"
                    },
                    {
                        "label": "龙海市",
                        "value": "350681",
                        "parent": "350600"
                    }
                ]
            },
            {
                "value": "350700",
                "label": "南平市",
                "parent": "350000",
                "children": [
                    {
                        "label": "延平区",
                        "value": "350702",
                        "parent": "350700"
                    },
                    {
                        "label": "建阳区",
                        "value": "350703",
                        "parent": "350700"
                    },
                    {
                        "label": "顺昌县",
                        "value": "350721",
                        "parent": "350700"
                    },
                    {
                        "label": "浦城县",
                        "value": "350722",
                        "parent": "350700"
                    },
                    {
                        "label": "光泽县",
                        "value": "350723",
                        "parent": "350700"
                    },
                    {
                        "label": "松溪县",
                        "value": "350724",
                        "parent": "350700"
                    },
                    {
                        "label": "政和县",
                        "value": "350725",
                        "parent": "350700"
                    },
                    {
                        "label": "邵武市",
                        "value": "350781",
                        "parent": "350700"
                    },
                    {
                        "label": "武夷山市",
                        "value": "350782",
                        "parent": "350700"
                    },
                    {
                        "label": "建瓯市",
                        "value": "350783",
                        "parent": "350700"
                    }
                ]
            },
            {
                "value": "350800",
                "label": "龙岩市",
                "parent": "350000",
                "children": [
                    {
                        "label": "新罗区",
                        "value": "350802",
                        "parent": "350800"
                    },
                    {
                        "label": "永定区",
                        "value": "350803",
                        "parent": "350800"
                    },
                    {
                        "label": "长汀县",
                        "value": "350821",
                        "parent": "350800"
                    },
                    {
                        "label": "上杭县",
                        "value": "350823",
                        "parent": "350800"
                    },
                    {
                        "label": "武平县",
                        "value": "350824",
                        "parent": "350800"
                    },
                    {
                        "label": "连城县",
                        "value": "350825",
                        "parent": "350800"
                    },
                    {
                        "label": "漳平市",
                        "value": "350881",
                        "parent": "350800"
                    }
                ]
            },
            {
                "value": "350900",
                "label": "宁德市",
                "parent": "350000",
                "children": [
                    {
                        "label": "蕉城区",
                        "value": "350902",
                        "parent": "350900"
                    },
                    {
                        "label": "霞浦县",
                        "value": "350921",
                        "parent": "350900"
                    },
                    {
                        "label": "古田县",
                        "value": "350922",
                        "parent": "350900"
                    },
                    {
                        "label": "屏南县",
                        "value": "350923",
                        "parent": "350900"
                    },
                    {
                        "label": "寿宁县",
                        "value": "350924",
                        "parent": "350900"
                    },
                    {
                        "label": "周宁县",
                        "value": "350925",
                        "parent": "350900"
                    },
                    {
                        "label": "柘荣县",
                        "value": "350926",
                        "parent": "350900"
                    },
                    {
                        "label": "福安市",
                        "value": "350981",
                        "parent": "350900"
                    },
                    {
                        "label": "福鼎市",
                        "value": "350982",
                        "parent": "350900"
                    }
                ]
            }
        ]
    },
    {
        "value": "360000",
        "label": "江西省",
        "children": [
            {
                "value": "360100",
                "label": "南昌市",
                "parent": "360000",
                "children": [
                    {
                        "label": "东湖区",
                        "value": "360102",
                        "parent": "360100"
                    },
                    {
                        "label": "西湖区",
                        "value": "360103",
                        "parent": "360100"
                    },
                    {
                        "label": "青云谱区",
                        "value": "360104",
                        "parent": "360100"
                    },
                    {
                        "label": "青山湖区",
                        "value": "360111",
                        "parent": "360100"
                    },
                    {
                        "label": "新建区",
                        "value": "360112",
                        "parent": "360100"
                    },
                    {
                        "label": "红谷滩区",
                        "value": "360113",
                        "parent": "360100"
                    },
                    {
                        "label": "南昌县",
                        "value": "360121",
                        "parent": "360100"
                    },
                    {
                        "label": "安义县",
                        "value": "360123",
                        "parent": "360100"
                    },
                    {
                        "label": "进贤县",
                        "value": "360124",
                        "parent": "360100"
                    },
                    {
                        "label": "经济技术开发区",
                        "value": "360190",
                        "parent": "360100"
                    },
                    {
                        "label": "高新区",
                        "value": "360192",
                        "parent": "360100"
                    }
                ]
            },
            {
                "value": "360200",
                "label": "景德镇市",
                "parent": "360000",
                "children": [
                    {
                        "label": "昌江区",
                        "value": "360202",
                        "parent": "360200"
                    },
                    {
                        "label": "珠山区",
                        "value": "360203",
                        "parent": "360200"
                    },
                    {
                        "label": "浮梁县",
                        "value": "360222",
                        "parent": "360200"
                    },
                    {
                        "label": "乐平市",
                        "value": "360281",
                        "parent": "360200"
                    }
                ]
            },
            {
                "value": "360300",
                "label": "萍乡市",
                "parent": "360000",
                "children": [
                    {
                        "label": "安源区",
                        "value": "360302",
                        "parent": "360300"
                    },
                    {
                        "label": "湘东区",
                        "value": "360313",
                        "parent": "360300"
                    },
                    {
                        "label": "莲花县",
                        "value": "360321",
                        "parent": "360300"
                    },
                    {
                        "label": "上栗县",
                        "value": "360322",
                        "parent": "360300"
                    },
                    {
                        "label": "芦溪县",
                        "value": "360323",
                        "parent": "360300"
                    }
                ]
            },
            {
                "value": "360400",
                "label": "九江市",
                "parent": "360000",
                "children": [
                    {
                        "label": "濂溪区",
                        "value": "360402",
                        "parent": "360400"
                    },
                    {
                        "label": "浔阳区",
                        "value": "360403",
                        "parent": "360400"
                    },
                    {
                        "label": "柴桑区",
                        "value": "360404",
                        "parent": "360400"
                    },
                    {
                        "label": "武宁县",
                        "value": "360423",
                        "parent": "360400"
                    },
                    {
                        "label": "修水县",
                        "value": "360424",
                        "parent": "360400"
                    },
                    {
                        "label": "永修县",
                        "value": "360425",
                        "parent": "360400"
                    },
                    {
                        "label": "德安县",
                        "value": "360426",
                        "parent": "360400"
                    },
                    {
                        "label": "都昌县",
                        "value": "360428",
                        "parent": "360400"
                    },
                    {
                        "label": "湖口县",
                        "value": "360429",
                        "parent": "360400"
                    },
                    {
                        "label": "彭泽县",
                        "value": "360430",
                        "parent": "360400"
                    },
                    {
                        "label": "瑞昌市",
                        "value": "360481",
                        "parent": "360400"
                    },
                    {
                        "label": "共青城市",
                        "value": "360482",
                        "parent": "360400"
                    },
                    {
                        "label": "庐山市",
                        "value": "360483",
                        "parent": "360400"
                    },
                    {
                        "label": "经济技术开发区",
                        "value": "360490",
                        "parent": "360400"
                    }
                ]
            },
            {
                "value": "360500",
                "label": "新余市",
                "parent": "360000",
                "children": [
                    {
                        "label": "渝水区",
                        "value": "360502",
                        "parent": "360500"
                    },
                    {
                        "label": "分宜县",
                        "value": "360521",
                        "parent": "360500"
                    }
                ]
            },
            {
                "value": "360600",
                "label": "鹰潭市",
                "parent": "360000",
                "children": [
                    {
                        "label": "月湖区",
                        "value": "360602",
                        "parent": "360600"
                    },
                    {
                        "label": "余江区",
                        "value": "360603",
                        "parent": "360600"
                    },
                    {
                        "label": "贵溪市",
                        "value": "360681",
                        "parent": "360600"
                    }
                ]
            },
            {
                "value": "360700",
                "label": "赣州市",
                "parent": "360000",
                "children": [
                    {
                        "label": "章贡区",
                        "value": "360702",
                        "parent": "360700"
                    },
                    {
                        "label": "南康区",
                        "value": "360703",
                        "parent": "360700"
                    },
                    {
                        "label": "赣县区",
                        "value": "360704",
                        "parent": "360700"
                    },
                    {
                        "label": "信丰县",
                        "value": "360722",
                        "parent": "360700"
                    },
                    {
                        "label": "大余县",
                        "value": "360723",
                        "parent": "360700"
                    },
                    {
                        "label": "上犹县",
                        "value": "360724",
                        "parent": "360700"
                    },
                    {
                        "label": "崇义县",
                        "value": "360725",
                        "parent": "360700"
                    },
                    {
                        "label": "安远县",
                        "value": "360726",
                        "parent": "360700"
                    },
                    {
                        "label": "龙南县",
                        "value": "360727",
                        "parent": "360700"
                    },
                    {
                        "label": "定南县",
                        "value": "360728",
                        "parent": "360700"
                    },
                    {
                        "label": "全南县",
                        "value": "360729",
                        "parent": "360700"
                    },
                    {
                        "label": "宁都县",
                        "value": "360730",
                        "parent": "360700"
                    },
                    {
                        "label": "于都县",
                        "value": "360731",
                        "parent": "360700"
                    },
                    {
                        "label": "兴国县",
                        "value": "360732",
                        "parent": "360700"
                    },
                    {
                        "label": "会昌县",
                        "value": "360733",
                        "parent": "360700"
                    },
                    {
                        "label": "寻乌县",
                        "value": "360734",
                        "parent": "360700"
                    },
                    {
                        "label": "石城县",
                        "value": "360735",
                        "parent": "360700"
                    },
                    {
                        "label": "瑞金市",
                        "value": "360781",
                        "parent": "360700"
                    }
                ]
            },
            {
                "value": "360800",
                "label": "吉安市",
                "parent": "360000",
                "children": [
                    {
                        "label": "吉州区",
                        "value": "360802",
                        "parent": "360800"
                    },
                    {
                        "label": "青原区",
                        "value": "360803",
                        "parent": "360800"
                    },
                    {
                        "label": "吉安县",
                        "value": "360821",
                        "parent": "360800"
                    },
                    {
                        "label": "吉水县",
                        "value": "360822",
                        "parent": "360800"
                    },
                    {
                        "label": "峡江县",
                        "value": "360823",
                        "parent": "360800"
                    },
                    {
                        "label": "新干县",
                        "value": "360824",
                        "parent": "360800"
                    },
                    {
                        "label": "永丰县",
                        "value": "360825",
                        "parent": "360800"
                    },
                    {
                        "label": "泰和县",
                        "value": "360826",
                        "parent": "360800"
                    },
                    {
                        "label": "遂川县",
                        "value": "360827",
                        "parent": "360800"
                    },
                    {
                        "label": "万安县",
                        "value": "360828",
                        "parent": "360800"
                    },
                    {
                        "label": "安福县",
                        "value": "360829",
                        "parent": "360800"
                    },
                    {
                        "label": "永新县",
                        "value": "360830",
                        "parent": "360800"
                    },
                    {
                        "label": "井冈山市",
                        "value": "360881",
                        "parent": "360800"
                    }
                ]
            },
            {
                "value": "360900",
                "label": "宜春市",
                "parent": "360000",
                "children": [
                    {
                        "label": "袁州区",
                        "value": "360902",
                        "parent": "360900"
                    },
                    {
                        "label": "奉新县",
                        "value": "360921",
                        "parent": "360900"
                    },
                    {
                        "label": "万载县",
                        "value": "360922",
                        "parent": "360900"
                    },
                    {
                        "label": "上高县",
                        "value": "360923",
                        "parent": "360900"
                    },
                    {
                        "label": "宜丰县",
                        "value": "360924",
                        "parent": "360900"
                    },
                    {
                        "label": "靖安县",
                        "value": "360925",
                        "parent": "360900"
                    },
                    {
                        "label": "铜鼓县",
                        "value": "360926",
                        "parent": "360900"
                    },
                    {
                        "label": "丰城市",
                        "value": "360981",
                        "parent": "360900"
                    },
                    {
                        "label": "樟树市",
                        "value": "360982",
                        "parent": "360900"
                    },
                    {
                        "label": "高安市",
                        "value": "360983",
                        "parent": "360900"
                    }
                ]
            },
            {
                "value": "361000",
                "label": "抚州市",
                "parent": "360000",
                "children": [
                    {
                        "label": "临川区",
                        "value": "361002",
                        "parent": "361000"
                    },
                    {
                        "label": "东乡区",
                        "value": "361003",
                        "parent": "361000"
                    },
                    {
                        "label": "南城县",
                        "value": "361021",
                        "parent": "361000"
                    },
                    {
                        "label": "黎川县",
                        "value": "361022",
                        "parent": "361000"
                    },
                    {
                        "label": "南丰县",
                        "value": "361023",
                        "parent": "361000"
                    },
                    {
                        "label": "崇仁县",
                        "value": "361024",
                        "parent": "361000"
                    },
                    {
                        "label": "乐安县",
                        "value": "361025",
                        "parent": "361000"
                    },
                    {
                        "label": "宜黄县",
                        "value": "361026",
                        "parent": "361000"
                    },
                    {
                        "label": "金溪县",
                        "value": "361027",
                        "parent": "361000"
                    },
                    {
                        "label": "资溪县",
                        "value": "361028",
                        "parent": "361000"
                    },
                    {
                        "label": "广昌县",
                        "value": "361030",
                        "parent": "361000"
                    }
                ]
            },
            {
                "value": "361100",
                "label": "上饶市",
                "parent": "360000",
                "children": [
                    {
                        "label": "信州区",
                        "value": "361102",
                        "parent": "361100"
                    },
                    {
                        "label": "广丰区",
                        "value": "361103",
                        "parent": "361100"
                    },
                    {
                        "label": "广信区",
                        "value": "361104",
                        "parent": "361100"
                    },
                    {
                        "label": "玉山县",
                        "value": "361123",
                        "parent": "361100"
                    },
                    {
                        "label": "铅山县",
                        "value": "361124",
                        "parent": "361100"
                    },
                    {
                        "label": "横峰县",
                        "value": "361125",
                        "parent": "361100"
                    },
                    {
                        "label": "弋阳县",
                        "value": "361126",
                        "parent": "361100"
                    },
                    {
                        "label": "余干县",
                        "value": "361127",
                        "parent": "361100"
                    },
                    {
                        "label": "鄱阳县",
                        "value": "361128",
                        "parent": "361100"
                    },
                    {
                        "label": "万年县",
                        "value": "361129",
                        "parent": "361100"
                    },
                    {
                        "label": "婺源县",
                        "value": "361130",
                        "parent": "361100"
                    },
                    {
                        "label": "德兴市",
                        "value": "361181",
                        "parent": "361100"
                    }
                ]
            }
        ]
    },
    {
        "value": "370000",
        "label": "山东省",
        "children": [
            {
                "value": "370100",
                "label": "济南市",
                "parent": "370000",
                "children": [
                    {
                        "label": "历下区",
                        "value": "370102",
                        "parent": "370100"
                    },
                    {
                        "label": "市中区",
                        "value": "370103",
                        "parent": "370100"
                    },
                    {
                        "label": "槐荫区",
                        "value": "370104",
                        "parent": "370100"
                    },
                    {
                        "label": "天桥区",
                        "value": "370105",
                        "parent": "370100"
                    },
                    {
                        "label": "历城区",
                        "value": "370112",
                        "parent": "370100"
                    },
                    {
                        "label": "长清区",
                        "value": "370113",
                        "parent": "370100"
                    },
                    {
                        "label": "章丘区",
                        "value": "370114",
                        "parent": "370100"
                    },
                    {
                        "label": "济阳区",
                        "value": "370115",
                        "parent": "370100"
                    },
                    {
                        "label": "莱芜区",
                        "value": "370116",
                        "parent": "370100"
                    },
                    {
                        "label": "钢城区",
                        "value": "370117",
                        "parent": "370100"
                    },
                    {
                        "label": "平阴县",
                        "value": "370124",
                        "parent": "370100"
                    },
                    {
                        "label": "商河县",
                        "value": "370126",
                        "parent": "370100"
                    },
                    {
                        "label": "济南高新技术产业开发区",
                        "value": "370171",
                        "parent": "370100"
                    },
                    {
                        "label": "高新区",
                        "value": "370190",
                        "parent": "370100"
                    }
                ]
            },
            {
                "value": "370200",
                "label": "青岛市",
                "parent": "370000",
                "children": [
                    {
                        "label": "市南区",
                        "value": "370202",
                        "parent": "370200"
                    },
                    {
                        "label": "市北区",
                        "value": "370203",
                        "parent": "370200"
                    },
                    {
                        "label": "黄岛区",
                        "value": "370211",
                        "parent": "370200"
                    },
                    {
                        "label": "崂山区",
                        "value": "370212",
                        "parent": "370200"
                    },
                    {
                        "label": "李沧区",
                        "value": "370213",
                        "parent": "370200"
                    },
                    {
                        "label": "城阳区",
                        "value": "370214",
                        "parent": "370200"
                    },
                    {
                        "label": "即墨区",
                        "value": "370215",
                        "parent": "370200"
                    },
                    {
                        "label": "青岛高新技术产业开发区",
                        "value": "370271",
                        "parent": "370200"
                    },
                    {
                        "label": "胶州市",
                        "value": "370281",
                        "parent": "370200"
                    },
                    {
                        "label": "平度市",
                        "value": "370283",
                        "parent": "370200"
                    },
                    {
                        "label": "莱西市",
                        "value": "370285",
                        "parent": "370200"
                    },
                    {
                        "label": "开发区",
                        "value": "370290",
                        "parent": "370200"
                    }
                ]
            },
            {
                "value": "370300",
                "label": "淄博市",
                "parent": "370000",
                "children": [
                    {
                        "label": "淄川区",
                        "value": "370302",
                        "parent": "370300"
                    },
                    {
                        "label": "张店区",
                        "value": "370303",
                        "parent": "370300"
                    },
                    {
                        "label": "博山区",
                        "value": "370304",
                        "parent": "370300"
                    },
                    {
                        "label": "临淄区",
                        "value": "370305",
                        "parent": "370300"
                    },
                    {
                        "label": "周村区",
                        "value": "370306",
                        "parent": "370300"
                    },
                    {
                        "label": "桓台县",
                        "value": "370321",
                        "parent": "370300"
                    },
                    {
                        "label": "高青县",
                        "value": "370322",
                        "parent": "370300"
                    },
                    {
                        "label": "沂源县",
                        "value": "370323",
                        "parent": "370300"
                    }
                ]
            },
            {
                "value": "370400",
                "label": "枣庄市",
                "parent": "370000",
                "children": [
                    {
                        "label": "市中区",
                        "value": "370402",
                        "parent": "370400"
                    },
                    {
                        "label": "薛城区",
                        "value": "370403",
                        "parent": "370400"
                    },
                    {
                        "label": "峄城区",
                        "value": "370404",
                        "parent": "370400"
                    },
                    {
                        "label": "台儿庄区",
                        "value": "370405",
                        "parent": "370400"
                    },
                    {
                        "label": "山亭区",
                        "value": "370406",
                        "parent": "370400"
                    },
                    {
                        "label": "滕州市",
                        "value": "370481",
                        "parent": "370400"
                    }
                ]
            },
            {
                "value": "370500",
                "label": "东营市",
                "parent": "370000",
                "children": [
                    {
                        "label": "东营区",
                        "value": "370502",
                        "parent": "370500"
                    },
                    {
                        "label": "河口区",
                        "value": "370503",
                        "parent": "370500"
                    },
                    {
                        "label": "垦利区",
                        "value": "370505",
                        "parent": "370500"
                    },
                    {
                        "label": "利津县",
                        "value": "370522",
                        "parent": "370500"
                    },
                    {
                        "label": "广饶县",
                        "value": "370523",
                        "parent": "370500"
                    },
                    {
                        "label": "东营经济技术开发区",
                        "value": "370571",
                        "parent": "370500"
                    },
                    {
                        "label": "东营港经济开发区",
                        "value": "370572",
                        "parent": "370500"
                    }
                ]
            },
            {
                "value": "370600",
                "label": "烟台市",
                "parent": "370000",
                "children": [
                    {
                        "label": "芝罘区",
                        "value": "370602",
                        "parent": "370600"
                    },
                    {
                        "label": "福山区",
                        "value": "370611",
                        "parent": "370600"
                    },
                    {
                        "label": "牟平区",
                        "value": "370612",
                        "parent": "370600"
                    },
                    {
                        "label": "莱山区",
                        "value": "370613",
                        "parent": "370600"
                    },
                    {
                        "label": "长岛县",
                        "value": "370634",
                        "parent": "370600"
                    },
                    {
                        "label": "烟台高新技术产业开发区",
                        "value": "370671",
                        "parent": "370600"
                    },
                    {
                        "label": "烟台经济技术开发区",
                        "value": "370672",
                        "parent": "370600"
                    },
                    {
                        "label": "龙口市",
                        "value": "370681",
                        "parent": "370600"
                    },
                    {
                        "label": "莱阳市",
                        "value": "370682",
                        "parent": "370600"
                    },
                    {
                        "label": "莱州市",
                        "value": "370683",
                        "parent": "370600"
                    },
                    {
                        "label": "蓬莱市",
                        "value": "370684",
                        "parent": "370600"
                    },
                    {
                        "label": "招远市",
                        "value": "370685",
                        "parent": "370600"
                    },
                    {
                        "label": "栖霞市",
                        "value": "370686",
                        "parent": "370600"
                    },
                    {
                        "label": "海阳市",
                        "value": "370687",
                        "parent": "370600"
                    },
                    {
                        "label": "开发区",
                        "value": "370690",
                        "parent": "370600"
                    }
                ]
            },
            {
                "value": "370700",
                "label": "潍坊市",
                "parent": "370000",
                "children": [
                    {
                        "label": "潍城区",
                        "value": "370702",
                        "parent": "370700"
                    },
                    {
                        "label": "寒亭区",
                        "value": "370703",
                        "parent": "370700"
                    },
                    {
                        "label": "坊子区",
                        "value": "370704",
                        "parent": "370700"
                    },
                    {
                        "label": "奎文区",
                        "value": "370705",
                        "parent": "370700"
                    },
                    {
                        "label": "临朐县",
                        "value": "370724",
                        "parent": "370700"
                    },
                    {
                        "label": "昌乐县",
                        "value": "370725",
                        "parent": "370700"
                    },
                    {
                        "label": "潍坊滨海经济技术开发区",
                        "value": "370772",
                        "parent": "370700"
                    },
                    {
                        "label": "青州市",
                        "value": "370781",
                        "parent": "370700"
                    },
                    {
                        "label": "诸城市",
                        "value": "370782",
                        "parent": "370700"
                    },
                    {
                        "label": "寿光市",
                        "value": "370783",
                        "parent": "370700"
                    },
                    {
                        "label": "安丘市",
                        "value": "370784",
                        "parent": "370700"
                    },
                    {
                        "label": "高密市",
                        "value": "370785",
                        "parent": "370700"
                    },
                    {
                        "label": "昌邑市",
                        "value": "370786",
                        "parent": "370700"
                    },
                    {
                        "label": "开发区",
                        "value": "370790",
                        "parent": "370700"
                    },
                    {
                        "label": "高新区",
                        "value": "370791",
                        "parent": "370700"
                    }
                ]
            },
            {
                "value": "370800",
                "label": "济宁市",
                "parent": "370000",
                "children": [
                    {
                        "label": "任城区",
                        "value": "370811",
                        "parent": "370800"
                    },
                    {
                        "label": "兖州区",
                        "value": "370812",
                        "parent": "370800"
                    },
                    {
                        "label": "微山县",
                        "value": "370826",
                        "parent": "370800"
                    },
                    {
                        "label": "鱼台县",
                        "value": "370827",
                        "parent": "370800"
                    },
                    {
                        "label": "金乡县",
                        "value": "370828",
                        "parent": "370800"
                    },
                    {
                        "label": "嘉祥县",
                        "value": "370829",
                        "parent": "370800"
                    },
                    {
                        "label": "汶上县",
                        "value": "370830",
                        "parent": "370800"
                    },
                    {
                        "label": "泗水县",
                        "value": "370831",
                        "parent": "370800"
                    },
                    {
                        "label": "梁山县",
                        "value": "370832",
                        "parent": "370800"
                    },
                    {
                        "label": "济宁高新技术产业开发区",
                        "value": "370871",
                        "parent": "370800"
                    },
                    {
                        "label": "曲阜市",
                        "value": "370881",
                        "parent": "370800"
                    },
                    {
                        "label": "邹城市",
                        "value": "370883",
                        "parent": "370800"
                    },
                    {
                        "label": "高新区",
                        "value": "370890",
                        "parent": "370800"
                    }
                ]
            },
            {
                "value": "370900",
                "label": "泰安市",
                "parent": "370000",
                "children": [
                    {
                        "label": "泰山区",
                        "value": "370902",
                        "parent": "370900"
                    },
                    {
                        "label": "岱岳区",
                        "value": "370911",
                        "parent": "370900"
                    },
                    {
                        "label": "宁阳县",
                        "value": "370921",
                        "parent": "370900"
                    },
                    {
                        "label": "东平县",
                        "value": "370923",
                        "parent": "370900"
                    },
                    {
                        "label": "新泰市",
                        "value": "370982",
                        "parent": "370900"
                    },
                    {
                        "label": "肥城市",
                        "value": "370983",
                        "parent": "370900"
                    }
                ]
            },
            {
                "value": "371000",
                "label": "威海市",
                "parent": "370000",
                "children": [
                    {
                        "label": "环翠区",
                        "value": "371002",
                        "parent": "371000"
                    },
                    {
                        "label": "文登区",
                        "value": "371003",
                        "parent": "371000"
                    },
                    {
                        "label": "威海火炬高技术产业开发区",
                        "value": "371071",
                        "parent": "371000"
                    },
                    {
                        "label": "威海经济技术开发区",
                        "value": "371072",
                        "parent": "371000"
                    },
                    {
                        "label": "荣成市",
                        "value": "371082",
                        "parent": "371000"
                    },
                    {
                        "label": "乳山市",
                        "value": "371083",
                        "parent": "371000"
                    },
                    {
                        "label": "经济技术开发区",
                        "value": "371091",
                        "parent": "371000"
                    }
                ]
            },
            {
                "value": "371100",
                "label": "日照市",
                "parent": "370000",
                "children": [
                    {
                        "label": "东港区",
                        "value": "371102",
                        "parent": "371100"
                    },
                    {
                        "label": "岚山区",
                        "value": "371103",
                        "parent": "371100"
                    },
                    {
                        "label": "五莲县",
                        "value": "371121",
                        "parent": "371100"
                    },
                    {
                        "label": "莒县",
                        "value": "371122",
                        "parent": "371100"
                    },
                    {
                        "label": "日照经济技术开发区",
                        "value": "371171",
                        "parent": "371100"
                    }
                ]
            },
            {
                "value": "371200",
                "label": "莱芜市",
                "parent": "370000",
                "children": []
            },
            {
                "value": "371300",
                "label": "临沂市",
                "parent": "370000",
                "children": [
                    {
                        "label": "兰山区",
                        "value": "371302",
                        "parent": "371300"
                    },
                    {
                        "label": "罗庄区",
                        "value": "371311",
                        "parent": "371300"
                    },
                    {
                        "label": "河东区",
                        "value": "371312",
                        "parent": "371300"
                    },
                    {
                        "label": "沂南县",
                        "value": "371321",
                        "parent": "371300"
                    },
                    {
                        "label": "郯城县",
                        "value": "371322",
                        "parent": "371300"
                    },
                    {
                        "label": "沂水县",
                        "value": "371323",
                        "parent": "371300"
                    },
                    {
                        "label": "兰陵县",
                        "value": "371324",
                        "parent": "371300"
                    },
                    {
                        "label": "费县",
                        "value": "371325",
                        "parent": "371300"
                    },
                    {
                        "label": "平邑县",
                        "value": "371326",
                        "parent": "371300"
                    },
                    {
                        "label": "莒南县",
                        "value": "371327",
                        "parent": "371300"
                    },
                    {
                        "label": "蒙阴县",
                        "value": "371328",
                        "parent": "371300"
                    },
                    {
                        "label": "临沭县",
                        "value": "371329",
                        "parent": "371300"
                    },
                    {
                        "label": "临沂高新技术产业开发区",
                        "value": "371371",
                        "parent": "371300"
                    }
                ]
            },
            {
                "value": "371400",
                "label": "德州市",
                "parent": "370000",
                "children": [
                    {
                        "label": "德城区",
                        "value": "371402",
                        "parent": "371400"
                    },
                    {
                        "label": "陵城区",
                        "value": "371403",
                        "parent": "371400"
                    },
                    {
                        "label": "宁津县",
                        "value": "371422",
                        "parent": "371400"
                    },
                    {
                        "label": "庆云县",
                        "value": "371423",
                        "parent": "371400"
                    },
                    {
                        "label": "临邑县",
                        "value": "371424",
                        "parent": "371400"
                    },
                    {
                        "label": "齐河县",
                        "value": "371425",
                        "parent": "371400"
                    },
                    {
                        "label": "平原县",
                        "value": "371426",
                        "parent": "371400"
                    },
                    {
                        "label": "夏津县",
                        "value": "371427",
                        "parent": "371400"
                    },
                    {
                        "label": "武城县",
                        "value": "371428",
                        "parent": "371400"
                    },
                    {
                        "label": "德州运河经济开发区",
                        "value": "371472",
                        "parent": "371400"
                    },
                    {
                        "label": "乐陵市",
                        "value": "371481",
                        "parent": "371400"
                    },
                    {
                        "label": "禹城市",
                        "value": "371482",
                        "parent": "371400"
                    }
                ]
            },
            {
                "value": "371500",
                "label": "聊城市",
                "parent": "370000",
                "children": [
                    {
                        "label": "东昌府区",
                        "value": "371502",
                        "parent": "371500"
                    },
                    {
                        "label": "茌平区",
                        "value": "371503",
                        "parent": "371500"
                    },
                    {
                        "label": "阳谷县",
                        "value": "371521",
                        "parent": "371500"
                    },
                    {
                        "label": "莘县",
                        "value": "371522",
                        "parent": "371500"
                    },
                    {
                        "label": "东阿县",
                        "value": "371524",
                        "parent": "371500"
                    },
                    {
                        "label": "冠县",
                        "value": "371525",
                        "parent": "371500"
                    },
                    {
                        "label": "高唐县",
                        "value": "371526",
                        "parent": "371500"
                    },
                    {
                        "label": "临清市",
                        "value": "371581",
                        "parent": "371500"
                    }
                ]
            },
            {
                "value": "371600",
                "label": "滨州市",
                "parent": "370000",
                "children": [
                    {
                        "label": "滨城区",
                        "value": "371602",
                        "parent": "371600"
                    },
                    {
                        "label": "沾化区",
                        "value": "371603",
                        "parent": "371600"
                    },
                    {
                        "label": "惠民县",
                        "value": "371621",
                        "parent": "371600"
                    },
                    {
                        "label": "阳信县",
                        "value": "371622",
                        "parent": "371600"
                    },
                    {
                        "label": "无棣县",
                        "value": "371623",
                        "parent": "371600"
                    },
                    {
                        "label": "博兴县",
                        "value": "371625",
                        "parent": "371600"
                    },
                    {
                        "label": "邹平市",
                        "value": "371681",
                        "parent": "371600"
                    }
                ]
            },
            {
                "value": "371700",
                "label": "菏泽市",
                "parent": "370000",
                "children": [
                    {
                        "label": "牡丹区",
                        "value": "371702",
                        "parent": "371700"
                    },
                    {
                        "label": "定陶区",
                        "value": "371703",
                        "parent": "371700"
                    },
                    {
                        "label": "曹县",
                        "value": "371721",
                        "parent": "371700"
                    },
                    {
                        "label": "单县",
                        "value": "371722",
                        "parent": "371700"
                    },
                    {
                        "label": "成武县",
                        "value": "371723",
                        "parent": "371700"
                    },
                    {
                        "label": "巨野县",
                        "value": "371724",
                        "parent": "371700"
                    },
                    {
                        "label": "郓城县",
                        "value": "371725",
                        "parent": "371700"
                    },
                    {
                        "label": "鄄城县",
                        "value": "371726",
                        "parent": "371700"
                    },
                    {
                        "label": "东明县",
                        "value": "371728",
                        "parent": "371700"
                    },
                    {
                        "label": "菏泽经济技术开发区",
                        "value": "371771",
                        "parent": "371700"
                    },
                    {
                        "label": "菏泽高新技术开发区",
                        "value": "371772",
                        "parent": "371700"
                    }
                ]
            }
        ]
    },
    {
        "value": "410000",
        "label": "河南省",
        "children": [
            {
                "value": "410100",
                "label": "郑州市",
                "parent": "410000",
                "children": [
                    {
                        "label": "中原区",
                        "value": "410102",
                        "parent": "410100"
                    },
                    {
                        "label": "二七区",
                        "value": "410103",
                        "parent": "410100"
                    },
                    {
                        "label": "管城回族区",
                        "value": "410104",
                        "parent": "410100"
                    },
                    {
                        "label": "金水区",
                        "value": "410105",
                        "parent": "410100"
                    },
                    {
                        "label": "上街区",
                        "value": "410106",
                        "parent": "410100"
                    },
                    {
                        "label": "惠济区",
                        "value": "410108",
                        "parent": "410100"
                    },
                    {
                        "label": "中牟县",
                        "value": "410122",
                        "parent": "410100"
                    },
                    {
                        "label": "郑州经济技术开发区",
                        "value": "410171",
                        "parent": "410100"
                    },
                    {
                        "label": "郑州高新技术产业开发区",
                        "value": "410172",
                        "parent": "410100"
                    },
                    {
                        "label": "郑州航空港经济综合实验区",
                        "value": "410173",
                        "parent": "410100"
                    },
                    {
                        "label": "巩义市",
                        "value": "410181",
                        "parent": "410100"
                    },
                    {
                        "label": "荥阳市",
                        "value": "410182",
                        "parent": "410100"
                    },
                    {
                        "label": "新密市",
                        "value": "410183",
                        "parent": "410100"
                    },
                    {
                        "label": "新郑市",
                        "value": "410184",
                        "parent": "410100"
                    },
                    {
                        "label": "登封市",
                        "value": "410185",
                        "parent": "410100"
                    },
                    {
                        "label": "高新技术开发区",
                        "value": "410190",
                        "parent": "410100"
                    },
                    {
                        "label": "经济技术开发区",
                        "value": "410191",
                        "parent": "410100"
                    }
                ]
            },
            {
                "value": "410200",
                "label": "开封市",
                "parent": "410000",
                "children": [
                    {
                        "label": "龙亭区",
                        "value": "410202",
                        "parent": "410200"
                    },
                    {
                        "label": "顺河回族区",
                        "value": "410203",
                        "parent": "410200"
                    },
                    {
                        "label": "鼓楼区",
                        "value": "410204",
                        "parent": "410200"
                    },
                    {
                        "label": "禹王台区",
                        "value": "410205",
                        "parent": "410200"
                    },
                    {
                        "label": "祥符区",
                        "value": "410212",
                        "parent": "410200"
                    },
                    {
                        "label": "杞县",
                        "value": "410221",
                        "parent": "410200"
                    },
                    {
                        "label": "通许县",
                        "value": "410222",
                        "parent": "410200"
                    },
                    {
                        "label": "尉氏县",
                        "value": "410223",
                        "parent": "410200"
                    },
                    {
                        "label": "兰考县",
                        "value": "410225",
                        "parent": "410200"
                    }
                ]
            },
            {
                "value": "410300",
                "label": "洛阳市",
                "parent": "410000",
                "children": [
                    {
                        "label": "老城区",
                        "value": "410302",
                        "parent": "410300"
                    },
                    {
                        "label": "西工区",
                        "value": "410303",
                        "parent": "410300"
                    },
                    {
                        "label": "瀍河回族区",
                        "value": "410304",
                        "parent": "410300"
                    },
                    {
                        "label": "涧西区",
                        "value": "410305",
                        "parent": "410300"
                    },
                    {
                        "label": "吉利区",
                        "value": "410306",
                        "parent": "410300"
                    },
                    {
                        "label": "洛龙区",
                        "value": "410311",
                        "parent": "410300"
                    },
                    {
                        "label": "孟津县",
                        "value": "410322",
                        "parent": "410300"
                    },
                    {
                        "label": "新安县",
                        "value": "410323",
                        "parent": "410300"
                    },
                    {
                        "label": "栾���县",
                        "value": "410324",
                        "parent": "410300"
                    },
                    {
                        "label": "嵩县",
                        "value": "410325",
                        "parent": "410300"
                    },
                    {
                        "label": "汝阳县",
                        "value": "410326",
                        "parent": "410300"
                    },
                    {
                        "label": "宜阳县",
                        "value": "410327",
                        "parent": "410300"
                    },
                    {
                        "label": "洛宁县",
                        "value": "410328",
                        "parent": "410300"
                    },
                    {
                        "label": "伊川县",
                        "value": "410329",
                        "parent": "410300"
                    },
                    {
                        "label": "偃师市",
                        "value": "410381",
                        "parent": "410300"
                    }
                ]
            },
            {
                "value": "410400",
                "label": "平顶山市",
                "parent": "410000",
                "children": [
                    {
                        "label": "新华区",
                        "value": "410402",
                        "parent": "410400"
                    },
                    {
                        "label": "卫东区",
                        "value": "410403",
                        "parent": "410400"
                    },
                    {
                        "label": "石龙区",
                        "value": "410404",
                        "parent": "410400"
                    },
                    {
                        "label": "湛河区",
                        "value": "410411",
                        "parent": "410400"
                    },
                    {
                        "label": "宝丰县",
                        "value": "410421",
                        "parent": "410400"
                    },
                    {
                        "label": "叶县",
                        "value": "410422",
                        "parent": "410400"
                    },
                    {
                        "label": "鲁山县",
                        "value": "410423",
                        "parent": "410400"
                    },
                    {
                        "label": "郏县",
                        "value": "410425",
                        "parent": "410400"
                    },
                    {
                        "label": "平顶山高新技术产业开发区",
                        "value": "410471",
                        "parent": "410400"
                    },
                    {
                        "label": "舞钢市",
                        "value": "410481",
                        "parent": "410400"
                    },
                    {
                        "label": "汝州市",
                        "value": "410482",
                        "parent": "410400"
                    }
                ]
            },
            {
                "value": "410500",
                "label": "安阳市",
                "parent": "410000",
                "children": [
                    {
                        "label": "文峰区",
                        "value": "410502",
                        "parent": "410500"
                    },
                    {
                        "label": "北关区",
                        "value": "410503",
                        "parent": "410500"
                    },
                    {
                        "label": "殷都区",
                        "value": "410505",
                        "parent": "410500"
                    },
                    {
                        "label": "龙安区",
                        "value": "410506",
                        "parent": "410500"
                    },
                    {
                        "label": "安阳县",
                        "value": "410522",
                        "parent": "410500"
                    },
                    {
                        "label": "汤阴县",
                        "value": "410523",
                        "parent": "410500"
                    },
                    {
                        "label": "滑县",
                        "value": "410526",
                        "parent": "410500"
                    },
                    {
                        "label": "内黄县",
                        "value": "410527",
                        "parent": "410500"
                    },
                    {
                        "label": "林州市",
                        "value": "410581",
                        "parent": "410500"
                    },
                    {
                        "label": "开发区",
                        "value": "410590",
                        "parent": "410500"
                    }
                ]
            },
            {
                "value": "410600",
                "label": "鹤壁市",
                "parent": "410000",
                "children": [
                    {
                        "label": "鹤山区",
                        "value": "410602",
                        "parent": "410600"
                    },
                    {
                        "label": "山城区",
                        "value": "410603",
                        "parent": "410600"
                    },
                    {
                        "label": "淇滨区",
                        "value": "410611",
                        "parent": "410600"
                    },
                    {
                        "label": "浚县",
                        "value": "410621",
                        "parent": "410600"
                    },
                    {
                        "label": "淇县",
                        "value": "410622",
                        "parent": "410600"
                    }
                ]
            },
            {
                "value": "410700",
                "label": "新乡市",
                "parent": "410000",
                "children": [
                    {
                        "label": "红旗区",
                        "value": "410702",
                        "parent": "410700"
                    },
                    {
                        "label": "卫滨区",
                        "value": "410703",
                        "parent": "410700"
                    },
                    {
                        "label": "凤泉区",
                        "value": "410704",
                        "parent": "410700"
                    },
                    {
                        "label": "牧野区",
                        "value": "410711",
                        "parent": "410700"
                    },
                    {
                        "label": "新乡县",
                        "value": "410721",
                        "parent": "410700"
                    },
                    {
                        "label": "获嘉县",
                        "value": "410724",
                        "parent": "410700"
                    },
                    {
                        "label": "原阳县",
                        "value": "410725",
                        "parent": "410700"
                    },
                    {
                        "label": "延津县",
                        "value": "410726",
                        "parent": "410700"
                    },
                    {
                        "label": "封丘县",
                        "value": "410727",
                        "parent": "410700"
                    },
                    {
                        "label": "新乡高新技术产业开发区",
                        "value": "410771",
                        "parent": "410700"
                    },
                    {
                        "label": "新乡经济技术开发区",
                        "value": "410772",
                        "parent": "410700"
                    },
                    {
                        "label": "卫辉市",
                        "value": "410781",
                        "parent": "410700"
                    },
                    {
                        "label": "辉县市",
                        "value": "410782",
                        "parent": "410700"
                    },
                    {
                        "label": "长垣市",
                        "value": "410783",
                        "parent": "410700"
                    }
                ]
            },
            {
                "value": "410800",
                "label": "焦作市",
                "parent": "410000",
                "children": [
                    {
                        "label": "解放区",
                        "value": "410802",
                        "parent": "410800"
                    },
                    {
                        "label": "中站区",
                        "value": "410803",
                        "parent": "410800"
                    },
                    {
                        "label": "马村区",
                        "value": "410804",
                        "parent": "410800"
                    },
                    {
                        "label": "山阳区",
                        "value": "410811",
                        "parent": "410800"
                    },
                    {
                        "label": "修武县",
                        "value": "410821",
                        "parent": "410800"
                    },
                    {
                        "label": "博爱县",
                        "value": "410822",
                        "parent": "410800"
                    },
                    {
                        "label": "武陟县",
                        "value": "410823",
                        "parent": "410800"
                    },
                    {
                        "label": "温县",
                        "value": "410825",
                        "parent": "410800"
                    },
                    {
                        "label": "焦作城乡一体化示范区",
                        "value": "410871",
                        "parent": "410800"
                    },
                    {
                        "label": "沁阳市",
                        "value": "410882",
                        "parent": "410800"
                    },
                    {
                        "label": "孟州市",
                        "value": "410883",
                        "parent": "410800"
                    }
                ]
            },
            {
                "value": "410900",
                "label": "濮阳市",
                "parent": "410000",
                "children": [
                    {
                        "label": "华龙区",
                        "value": "410902",
                        "parent": "410900"
                    },
                    {
                        "label": "清丰县",
                        "value": "410922",
                        "parent": "410900"
                    },
                    {
                        "label": "南乐县",
                        "value": "410923",
                        "parent": "410900"
                    },
                    {
                        "label": "范县",
                        "value": "410926",
                        "parent": "410900"
                    },
                    {
                        "label": "台前县",
                        "value": "410927",
                        "parent": "410900"
                    },
                    {
                        "label": "濮阳县",
                        "value": "410928",
                        "parent": "410900"
                    },
                    {
                        "label": "河南濮阳工业园区",
                        "value": "410971",
                        "parent": "410900"
                    }
                ]
            },
            {
                "value": "411000",
                "label": "许昌市",
                "parent": "410000",
                "children": [
                    {
                        "label": "魏都区",
                        "value": "411002",
                        "parent": "411000"
                    },
                    {
                        "label": "建安区",
                        "value": "411003",
                        "parent": "411000"
                    },
                    {
                        "label": "鄢陵县",
                        "value": "411024",
                        "parent": "411000"
                    },
                    {
                        "label": "襄城县",
                        "value": "411025",
                        "parent": "411000"
                    },
                    {
                        "label": "许昌经济技术开发区",
                        "value": "411071",
                        "parent": "411000"
                    },
                    {
                        "label": "禹州市",
                        "value": "411081",
                        "parent": "411000"
                    },
                    {
                        "label": "长葛市",
                        "value": "411082",
                        "parent": "411000"
                    }
                ]
            },
            {
                "value": "411100",
                "label": "漯河市",
                "parent": "410000",
                "children": [
                    {
                        "label": "源汇区",
                        "value": "411102",
                        "parent": "411100"
                    },
                    {
                        "label": "郾城区",
                        "value": "411103",
                        "parent": "411100"
                    },
                    {
                        "label": "召陵区",
                        "value": "411104",
                        "parent": "411100"
                    },
                    {
                        "label": "舞阳县",
                        "value": "411121",
                        "parent": "411100"
                    },
                    {
                        "label": "临颍县",
                        "value": "411122",
                        "parent": "411100"
                    },
                    {
                        "label": "漯河经济技术开发区",
                        "value": "411171",
                        "parent": "411100"
                    }
                ]
            },
            {
                "value": "411200",
                "label": "三门峡市",
                "parent": "410000",
                "children": [
                    {
                        "label": "湖滨区",
                        "value": "411202",
                        "parent": "411200"
                    },
                    {
                        "label": "陕州区",
                        "value": "411203",
                        "parent": "411200"
                    },
                    {
                        "label": "渑池县",
                        "value": "411221",
                        "parent": "411200"
                    },
                    {
                        "label": "卢氏县",
                        "value": "411224",
                        "parent": "411200"
                    },
                    {
                        "label": "河南三门峡经济开发区",
                        "value": "411271",
                        "parent": "411200"
                    },
                    {
                        "label": "义马市",
                        "value": "411281",
                        "parent": "411200"
                    },
                    {
                        "label": "灵宝市",
                        "value": "411282",
                        "parent": "411200"
                    }
                ]
            },
            {
                "value": "411300",
                "label": "南阳市",
                "parent": "410000",
                "children": [
                    {
                        "label": "宛城区",
                        "value": "411302",
                        "parent": "411300"
                    },
                    {
                        "label": "卧龙区",
                        "value": "411303",
                        "parent": "411300"
                    },
                    {
                        "label": "南召县",
                        "value": "411321",
                        "parent": "411300"
                    },
                    {
                        "label": "方城县",
                        "value": "411322",
                        "parent": "411300"
                    },
                    {
                        "label": "西峡县",
                        "value": "411323",
                        "parent": "411300"
                    },
                    {
                        "label": "镇平县",
                        "value": "411324",
                        "parent": "411300"
                    },
                    {
                        "label": "内乡县",
                        "value": "411325",
                        "parent": "411300"
                    },
                    {
                        "label": "淅川县",
                        "value": "411326",
                        "parent": "411300"
                    },
                    {
                        "label": "社旗县",
                        "value": "411327",
                        "parent": "411300"
                    },
                    {
                        "label": "唐河县",
                        "value": "411328",
                        "parent": "411300"
                    },
                    {
                        "label": "新野县",
                        "value": "411329",
                        "parent": "411300"
                    },
                    {
                        "label": "桐柏县",
                        "value": "411330",
                        "parent": "411300"
                    },
                    {
                        "label": "南阳市城乡一体化示范区",
                        "value": "411372",
                        "parent": "411300"
                    },
                    {
                        "label": "邓州市",
                        "value": "411381",
                        "parent": "411300"
                    }
                ]
            },
            {
                "value": "411400",
                "label": "商丘市",
                "parent": "410000",
                "children": [
                    {
                        "label": "梁园区",
                        "value": "411402",
                        "parent": "411400"
                    },
                    {
                        "label": "睢阳区",
                        "value": "411403",
                        "parent": "411400"
                    },
                    {
                        "label": "民权县",
                        "value": "411421",
                        "parent": "411400"
                    },
                    {
                        "label": "睢县",
                        "value": "411422",
                        "parent": "411400"
                    },
                    {
                        "label": "宁陵县",
                        "value": "411423",
                        "parent": "411400"
                    },
                    {
                        "label": "柘城县",
                        "value": "411424",
                        "parent": "411400"
                    },
                    {
                        "label": "虞城县",
                        "value": "411425",
                        "parent": "411400"
                    },
                    {
                        "label": "夏邑县",
                        "value": "411426",
                        "parent": "411400"
                    },
                    {
                        "label": "永城市",
                        "value": "411481",
                        "parent": "411400"
                    }
                ]
            },
            {
                "value": "411500",
                "label": "信阳市",
                "parent": "410000",
                "children": [
                    {
                        "label": "浉河区",
                        "value": "411502",
                        "parent": "411500"
                    },
                    {
                        "label": "平桥区",
                        "value": "411503",
                        "parent": "411500"
                    },
                    {
                        "label": "罗山县",
                        "value": "411521",
                        "parent": "411500"
                    },
                    {
                        "label": "光山县",
                        "value": "411522",
                        "parent": "411500"
                    },
                    {
                        "label": "新县",
                        "value": "411523",
                        "parent": "411500"
                    },
                    {
                        "label": "商城县",
                        "value": "411524",
                        "parent": "411500"
                    },
                    {
                        "label": "固始县",
                        "value": "411525",
                        "parent": "411500"
                    },
                    {
                        "label": "潢川县",
                        "value": "411526",
                        "parent": "411500"
                    },
                    {
                        "label": "淮滨县",
                        "value": "411527",
                        "parent": "411500"
                    },
                    {
                        "label": "息县",
                        "value": "411528",
                        "parent": "411500"
                    }
                ]
            },
            {
                "value": "411600",
                "label": "周口市",
                "parent": "410000",
                "children": [
                    {
                        "label": "川汇区",
                        "value": "411602",
                        "parent": "411600"
                    },
                    {
                        "label": "淮阳区",
                        "value": "411603",
                        "parent": "411600"
                    },
                    {
                        "label": "扶沟县",
                        "value": "411621",
                        "parent": "411600"
                    },
                    {
                        "label": "西华县",
                        "value": "411622",
                        "parent": "411600"
                    },
                    {
                        "label": "商水县",
                        "value": "411623",
                        "parent": "411600"
                    },
                    {
                        "label": "沈丘县",
                        "value": "411624",
                        "parent": "411600"
                    },
                    {
                        "label": "郸城县",
                        "value": "411625",
                        "parent": "411600"
                    },
                    {
                        "label": "太康县",
                        "value": "411627",
                        "parent": "411600"
                    },
                    {
                        "label": "鹿邑县",
                        "value": "411628",
                        "parent": "411600"
                    },
                    {
                        "label": "河南周口经济开发区",
                        "value": "411671",
                        "parent": "411600"
                    },
                    {
                        "label": "项城市",
                        "value": "411681",
                        "parent": "411600"
                    },
                    {
                        "label": "经济开发区",
                        "value": "411690",
                        "parent": "411600"
                    }
                ]
            },
            {
                "value": "411700",
                "label": "驻马店市",
                "parent": "410000",
                "children": [
                    {
                        "label": "驿城区",
                        "value": "411702",
                        "parent": "411700"
                    },
                    {
                        "label": "西平县",
                        "value": "411721",
                        "parent": "411700"
                    },
                    {
                        "label": "上蔡县",
                        "value": "411722",
                        "parent": "411700"
                    },
                    {
                        "label": "平舆县",
                        "value": "411723",
                        "parent": "411700"
                    },
                    {
                        "label": "正阳县",
                        "value": "411724",
                        "parent": "411700"
                    },
                    {
                        "label": "确山县",
                        "value": "411725",
                        "parent": "411700"
                    },
                    {
                        "label": "泌阳县",
                        "value": "411726",
                        "parent": "411700"
                    },
                    {
                        "label": "汝南县",
                        "value": "411727",
                        "parent": "411700"
                    },
                    {
                        "label": "遂平县",
                        "value": "411728",
                        "parent": "411700"
                    },
                    {
                        "label": "新蔡县",
                        "value": "411729",
                        "parent": "411700"
                    }
                ]
            }
        ]
    },
    {
        "value": "420000",
        "label": "湖北省",
        "children": [
            {
                "value": "420100",
                "label": "武汉市",
                "parent": "420000",
                "children": [
                    {
                        "label": "江岸区",
                        "value": "420102",
                        "parent": "420100"
                    },
                    {
                        "label": "江汉区",
                        "value": "420103",
                        "parent": "420100"
                    },
                    {
                        "label": "硚口区",
                        "value": "420104",
                        "parent": "420100"
                    },
                    {
                        "label": "汉阳区",
                        "value": "420105",
                        "parent": "420100"
                    },
                    {
                        "label": "武昌区",
                        "value": "420106",
                        "parent": "420100"
                    },
                    {
                        "label": "青山区",
                        "value": "420107",
                        "parent": "420100"
                    },
                    {
                        "label": "洪山区",
                        "value": "420111",
                        "parent": "420100"
                    },
                    {
                        "label": "东西湖区",
                        "value": "420112",
                        "parent": "420100"
                    },
                    {
                        "label": "汉南区",
                        "value": "420113",
                        "parent": "420100"
                    },
                    {
                        "label": "蔡甸区",
                        "value": "420114",
                        "parent": "420100"
                    },
                    {
                        "label": "江夏区",
                        "value": "420115",
                        "parent": "420100"
                    },
                    {
                        "label": "黄陂区",
                        "value": "420116",
                        "parent": "420100"
                    },
                    {
                        "label": "新洲区",
                        "value": "420117",
                        "parent": "420100"
                    }
                ]
            },
            {
                "value": "420200",
                "label": "黄石市",
                "parent": "420000",
                "children": [
                    {
                        "label": "黄石港区",
                        "value": "420202",
                        "parent": "420200"
                    },
                    {
                        "label": "西塞山区",
                        "value": "420203",
                        "parent": "420200"
                    },
                    {
                        "label": "下陆区",
                        "value": "420204",
                        "parent": "420200"
                    },
                    {
                        "label": "铁山区",
                        "value": "420205",
                        "parent": "420200"
                    },
                    {
                        "label": "阳新县",
                        "value": "420222",
                        "parent": "420200"
                    },
                    {
                        "label": "大冶市",
                        "value": "420281",
                        "parent": "420200"
                    }
                ]
            },
            {
                "value": "420300",
                "label": "十堰市",
                "parent": "420000",
                "children": [
                    {
                        "label": "茅箭区",
                        "value": "420302",
                        "parent": "420300"
                    },
                    {
                        "label": "张湾区",
                        "value": "420303",
                        "parent": "420300"
                    },
                    {
                        "label": "郧阳区",
                        "value": "420304",
                        "parent": "420300"
                    },
                    {
                        "label": "郧西县",
                        "value": "420322",
                        "parent": "420300"
                    },
                    {
                        "label": "竹山县",
                        "value": "420323",
                        "parent": "420300"
                    },
                    {
                        "label": "竹溪县",
                        "value": "420324",
                        "parent": "420300"
                    },
                    {
                        "label": "房县",
                        "value": "420325",
                        "parent": "420300"
                    },
                    {
                        "label": "丹江口市",
                        "value": "420381",
                        "parent": "420300"
                    }
                ]
            },
            {
                "value": "420500",
                "label": "宜昌市",
                "parent": "420000",
                "children": [
                    {
                        "label": "西陵区",
                        "value": "420502",
                        "parent": "420500"
                    },
                    {
                        "label": "伍家岗区",
                        "value": "420503",
                        "parent": "420500"
                    },
                    {
                        "label": "点军区",
                        "value": "420504",
                        "parent": "420500"
                    },
                    {
                        "label": "猇亭区",
                        "value": "420505",
                        "parent": "420500"
                    },
                    {
                        "label": "夷陵区",
                        "value": "420506",
                        "parent": "420500"
                    },
                    {
                        "label": "远安县",
                        "value": "420525",
                        "parent": "420500"
                    },
                    {
                        "label": "兴山县",
                        "value": "420526",
                        "parent": "420500"
                    },
                    {
                        "label": "秭归县",
                        "value": "420527",
                        "parent": "420500"
                    },
                    {
                        "label": "长阳土家族自治县",
                        "value": "420528",
                        "parent": "420500"
                    },
                    {
                        "label": "五峰土家族自治县",
                        "value": "420529",
                        "parent": "420500"
                    },
                    {
                        "label": "宜都市",
                        "value": "420581",
                        "parent": "420500"
                    },
                    {
                        "label": "当阳市",
                        "value": "420582",
                        "parent": "420500"
                    },
                    {
                        "label": "枝江市",
                        "value": "420583",
                        "parent": "420500"
                    },
                    {
                        "label": "经济开发区",
                        "value": "420590",
                        "parent": "420500"
                    }
                ]
            },
            {
                "value": "420600",
                "label": "襄阳市",
                "parent": "420000",
                "children": [
                    {
                        "label": "襄城区",
                        "value": "420602",
                        "parent": "420600"
                    },
                    {
                        "label": "樊城区",
                        "value": "420606",
                        "parent": "420600"
                    },
                    {
                        "label": "襄州区",
                        "value": "420607",
                        "parent": "420600"
                    },
                    {
                        "label": "南漳县",
                        "value": "420624",
                        "parent": "420600"
                    },
                    {
                        "label": "谷城县",
                        "value": "420625",
                        "parent": "420600"
                    },
                    {
                        "label": "保康县",
                        "value": "420626",
                        "parent": "420600"
                    },
                    {
                        "label": "老河口市",
                        "value": "420682",
                        "parent": "420600"
                    },
                    {
                        "label": "枣阳市",
                        "value": "420683",
                        "parent": "420600"
                    },
                    {
                        "label": "宜城市",
                        "value": "420684",
                        "parent": "420600"
                    }
                ]
            },
            {
                "value": "420700",
                "label": "鄂州市",
                "parent": "420000",
                "children": [
                    {
                        "label": "梁子湖区",
                        "value": "420702",
                        "parent": "420700"
                    },
                    {
                        "label": "华容区",
                        "value": "420703",
                        "parent": "420700"
                    },
                    {
                        "label": "鄂城区",
                        "value": "420704",
                        "parent": "420700"
                    }
                ]
            },
            {
                "value": "420800",
                "label": "荆门市",
                "parent": "420000",
                "children": [
                    {
                        "label": "东宝区",
                        "value": "420802",
                        "parent": "420800"
                    },
                    {
                        "label": "掇刀区",
                        "value": "420804",
                        "parent": "420800"
                    },
                    {
                        "label": "沙洋县",
                        "value": "420822",
                        "parent": "420800"
                    },
                    {
                        "label": "钟祥市",
                        "value": "420881",
                        "parent": "420800"
                    },
                    {
                        "label": "京山市",
                        "value": "420882",
                        "parent": "420800"
                    }
                ]
            },
            {
                "value": "420900",
                "label": "孝感市",
                "parent": "420000",
                "children": [
                    {
                        "label": "孝南区",
                        "value": "420902",
                        "parent": "420900"
                    },
                    {
                        "label": "孝昌县",
                        "value": "420921",
                        "parent": "420900"
                    },
                    {
                        "label": "大悟县",
                        "value": "420922",
                        "parent": "420900"
                    },
                    {
                        "label": "云梦县",
                        "value": "420923",
                        "parent": "420900"
                    },
                    {
                        "label": "应城市",
                        "value": "420981",
                        "parent": "420900"
                    },
                    {
                        "label": "安陆市",
                        "value": "420982",
                        "parent": "420900"
                    },
                    {
                        "label": "汉川市",
                        "value": "420984",
                        "parent": "420900"
                    }
                ]
            },
            {
                "value": "421000",
                "label": "荆州市",
                "parent": "420000",
                "children": [
                    {
                        "label": "沙市区",
                        "value": "421002",
                        "parent": "421000"
                    },
                    {
                        "label": "荆州区",
                        "value": "421003",
                        "parent": "421000"
                    },
                    {
                        "label": "公安县",
                        "value": "421022",
                        "parent": "421000"
                    },
                    {
                        "label": "监利县",
                        "value": "421023",
                        "parent": "421000"
                    },
                    {
                        "label": "江陵县",
                        "value": "421024",
                        "parent": "421000"
                    },
                    {
                        "label": "石首市",
                        "value": "421081",
                        "parent": "421000"
                    },
                    {
                        "label": "洪湖市",
                        "value": "421083",
                        "parent": "421000"
                    },
                    {
                        "label": "松滋市",
                        "value": "421087",
                        "parent": "421000"
                    }
                ]
            },
            {
                "value": "421100",
                "label": "黄冈市",
                "parent": "420000",
                "children": [
                    {
                        "label": "黄州区",
                        "value": "421102",
                        "parent": "421100"
                    },
                    {
                        "label": "团风县",
                        "value": "421121",
                        "parent": "421100"
                    },
                    {
                        "label": "红安县",
                        "value": "421122",
                        "parent": "421100"
                    },
                    {
                        "label": "罗田县",
                        "value": "421123",
                        "parent": "421100"
                    },
                    {
                        "label": "英山县",
                        "value": "421124",
                        "parent": "421100"
                    },
                    {
                        "label": "浠水县",
                        "value": "421125",
                        "parent": "421100"
                    },
                    {
                        "label": "蕲春县",
                        "value": "421126",
                        "parent": "421100"
                    },
                    {
                        "label": "黄梅县",
                        "value": "421127",
                        "parent": "421100"
                    },
                    {
                        "label": "龙感湖管理区",
                        "value": "421171",
                        "parent": "421100"
                    },
                    {
                        "label": "麻城市",
                        "value": "421181",
                        "parent": "421100"
                    },
                    {
                        "label": "武穴市",
                        "value": "421182",
                        "parent": "421100"
                    }
                ]
            },
            {
                "value": "421200",
                "label": "咸宁市",
                "parent": "420000",
                "children": [
                    {
                        "label": "咸安区",
                        "value": "421202",
                        "parent": "421200"
                    },
                    {
                        "label": "嘉鱼县",
                        "value": "421221",
                        "parent": "421200"
                    },
                    {
                        "label": "通城县",
                        "value": "421222",
                        "parent": "421200"
                    },
                    {
                        "label": "崇阳县",
                        "value": "421223",
                        "parent": "421200"
                    },
                    {
                        "label": "通山县",
                        "value": "421224",
                        "parent": "421200"
                    },
                    {
                        "label": "赤壁市",
                        "value": "421281",
                        "parent": "421200"
                    }
                ]
            },
            {
                "value": "421300",
                "label": "随州市",
                "parent": "420000",
                "children": [
                    {
                        "label": "曾都区",
                        "value": "421303",
                        "parent": "421300"
                    },
                    {
                        "label": "随县",
                        "value": "421321",
                        "parent": "421300"
                    },
                    {
                        "label": "广水市",
                        "value": "421381",
                        "parent": "421300"
                    }
                ]
            },
            {
                "value": "422800",
                "label": "恩施土家族苗族自治州",
                "parent": "420000",
                "children": [
                    {
                        "label": "恩施市",
                        "value": "422801",
                        "parent": "422800"
                    },
                    {
                        "label": "利川市",
                        "value": "422802",
                        "parent": "422800"
                    },
                    {
                        "label": "建始县",
                        "value": "422822",
                        "parent": "422800"
                    },
                    {
                        "label": "巴东县",
                        "value": "422823",
                        "parent": "422800"
                    },
                    {
                        "label": "宣恩县",
                        "value": "422825",
                        "parent": "422800"
                    },
                    {
                        "label": "咸丰县",
                        "value": "422826",
                        "parent": "422800"
                    },
                    {
                        "label": "来凤县",
                        "value": "422827",
                        "parent": "422800"
                    },
                    {
                        "label": "鹤峰县",
                        "value": "422828",
                        "parent": "422800"
                    }
                ]
            }
        ]
    },
    {
        "value": "430000",
        "label": "湖南省",
        "children": [
            {
                "value": "430100",
                "label": "长沙市",
                "parent": "430000",
                "children": [
                    {
                        "label": "芙蓉区",
                        "value": "430102",
                        "parent": "430100"
                    },
                    {
                        "label": "天心区",
                        "value": "430103",
                        "parent": "430100"
                    },
                    {
                        "label": "岳麓区",
                        "value": "430104",
                        "parent": "430100"
                    },
                    {
                        "label": "开福区",
                        "value": "430105",
                        "parent": "430100"
                    },
                    {
                        "label": "雨花区",
                        "value": "430111",
                        "parent": "430100"
                    },
                    {
                        "label": "望城区",
                        "value": "430112",
                        "parent": "430100"
                    },
                    {
                        "label": "长沙县",
                        "value": "430121",
                        "parent": "430100"
                    },
                    {
                        "label": "浏阳市",
                        "value": "430181",
                        "parent": "430100"
                    },
                    {
                        "label": "宁乡市",
                        "value": "430182",
                        "parent": "430100"
                    }
                ]
            },
            {
                "value": "430200",
                "label": "株洲市",
                "parent": "430000",
                "children": [
                    {
                        "label": "荷塘区",
                        "value": "430202",
                        "parent": "430200"
                    },
                    {
                        "label": "芦淞区",
                        "value": "430203",
                        "parent": "430200"
                    },
                    {
                        "label": "石峰区",
                        "value": "430204",
                        "parent": "430200"
                    },
                    {
                        "label": "天元区",
                        "value": "430211",
                        "parent": "430200"
                    },
                    {
                        "label": "渌口区",
                        "value": "430212",
                        "parent": "430200"
                    },
                    {
                        "label": "攸县",
                        "value": "430223",
                        "parent": "430200"
                    },
                    {
                        "label": "茶陵县",
                        "value": "430224",
                        "parent": "430200"
                    },
                    {
                        "label": "炎陵县",
                        "value": "430225",
                        "parent": "430200"
                    },
                    {
                        "label": "云龙示范区",
                        "value": "430271",
                        "parent": "430200"
                    },
                    {
                        "label": "醴陵市",
                        "value": "430281",
                        "parent": "430200"
                    }
                ]
            },
            {
                "value": "430300",
                "label": "湘潭市",
                "parent": "430000",
                "children": [
                    {
                        "label": "雨湖区",
                        "value": "430302",
                        "parent": "430300"
                    },
                    {
                        "label": "岳塘区",
                        "value": "430304",
                        "parent": "430300"
                    },
                    {
                        "label": "湘潭县",
                        "value": "430321",
                        "parent": "430300"
                    },
                    {
                        "label": "湘潭九华示范区",
                        "value": "430373",
                        "parent": "430300"
                    },
                    {
                        "label": "湘乡市",
                        "value": "430381",
                        "parent": "430300"
                    },
                    {
                        "label": "韶山市",
                        "value": "430382",
                        "parent": "430300"
                    }
                ]
            },
            {
                "value": "430400",
                "label": "衡阳市",
                "parent": "430000",
                "children": [
                    {
                        "label": "珠晖区",
                        "value": "430405",
                        "parent": "430400"
                    },
                    {
                        "label": "雁峰区",
                        "value": "430406",
                        "parent": "430400"
                    },
                    {
                        "label": "石鼓区",
                        "value": "430407",
                        "parent": "430400"
                    },
                    {
                        "label": "蒸湘区",
                        "value": "430408",
                        "parent": "430400"
                    },
                    {
                        "label": "南岳区",
                        "value": "430412",
                        "parent": "430400"
                    },
                    {
                        "label": "衡阳县",
                        "value": "430421",
                        "parent": "430400"
                    },
                    {
                        "label": "衡南县",
                        "value": "430422",
                        "parent": "430400"
                    },
                    {
                        "label": "衡山县",
                        "value": "430423",
                        "parent": "430400"
                    },
                    {
                        "label": "衡东县",
                        "value": "430424",
                        "parent": "430400"
                    },
                    {
                        "label": "祁东县",
                        "value": "430426",
                        "parent": "430400"
                    },
                    {
                        "label": "耒阳市",
                        "value": "430481",
                        "parent": "430400"
                    },
                    {
                        "label": "常宁市",
                        "value": "430482",
                        "parent": "430400"
                    }
                ]
            },
            {
                "value": "430500",
                "label": "邵阳市",
                "parent": "430000",
                "children": [
                    {
                        "label": "双清区",
                        "value": "430502",
                        "parent": "430500"
                    },
                    {
                        "label": "大祥区",
                        "value": "430503",
                        "parent": "430500"
                    },
                    {
                        "label": "北塔区",
                        "value": "430511",
                        "parent": "430500"
                    },
                    {
                        "label": "新邵县",
                        "value": "430522",
                        "parent": "430500"
                    },
                    {
                        "label": "邵阳县",
                        "value": "430523",
                        "parent": "430500"
                    },
                    {
                        "label": "隆回县",
                        "value": "430524",
                        "parent": "430500"
                    },
                    {
                        "label": "洞口县",
                        "value": "430525",
                        "parent": "430500"
                    },
                    {
                        "label": "绥宁县",
                        "value": "430527",
                        "parent": "430500"
                    },
                    {
                        "label": "新宁县",
                        "value": "430528",
                        "parent": "430500"
                    },
                    {
                        "label": "城步苗族自治县",
                        "value": "430529",
                        "parent": "430500"
                    },
                    {
                        "label": "武冈市",
                        "value": "430581",
                        "parent": "430500"
                    },
                    {
                        "label": "邵东市",
                        "value": "430582",
                        "parent": "430500"
                    }
                ]
            },
            {
                "value": "430600",
                "label": "岳阳市",
                "parent": "430000",
                "children": [
                    {
                        "label": "岳阳楼区",
                        "value": "430602",
                        "parent": "430600"
                    },
                    {
                        "label": "云溪区",
                        "value": "430603",
                        "parent": "430600"
                    },
                    {
                        "label": "君山区",
                        "value": "430611",
                        "parent": "430600"
                    },
                    {
                        "label": "岳阳县",
                        "value": "430621",
                        "parent": "430600"
                    },
                    {
                        "label": "华容县",
                        "value": "430623",
                        "parent": "430600"
                    },
                    {
                        "label": "湘阴县",
                        "value": "430624",
                        "parent": "430600"
                    },
                    {
                        "label": "平江县",
                        "value": "430626",
                        "parent": "430600"
                    },
                    {
                        "label": "汨罗市",
                        "value": "430681",
                        "parent": "430600"
                    },
                    {
                        "label": "临湘市",
                        "value": "430682",
                        "parent": "430600"
                    }
                ]
            },
            {
                "value": "430700",
                "label": "常德市",
                "parent": "430000",
                "children": [
                    {
                        "label": "武陵区",
                        "value": "430702",
                        "parent": "430700"
                    },
                    {
                        "label": "鼎城区",
                        "value": "430703",
                        "parent": "430700"
                    },
                    {
                        "label": "安乡县",
                        "value": "430721",
                        "parent": "430700"
                    },
                    {
                        "label": "汉寿县",
                        "value": "430722",
                        "parent": "430700"
                    },
                    {
                        "label": "澧县",
                        "value": "430723",
                        "parent": "430700"
                    },
                    {
                        "label": "临澧县",
                        "value": "430724",
                        "parent": "430700"
                    },
                    {
                        "label": "桃源县",
                        "value": "430725",
                        "parent": "430700"
                    },
                    {
                        "label": "石门县",
                        "value": "430726",
                        "parent": "430700"
                    },
                    {
                        "label": "津市市",
                        "value": "430781",
                        "parent": "430700"
                    }
                ]
            },
            {
                "value": "430800",
                "label": "张家界市",
                "parent": "430000",
                "children": [
                    {
                        "label": "永定区",
                        "value": "430802",
                        "parent": "430800"
                    },
                    {
                        "label": "武陵源区",
                        "value": "430811",
                        "parent": "430800"
                    },
                    {
                        "label": "慈利县",
                        "value": "430821",
                        "parent": "430800"
                    },
                    {
                        "label": "桑植县",
                        "value": "430822",
                        "parent": "430800"
                    }
                ]
            },
            {
                "value": "430900",
                "label": "益阳市",
                "parent": "430000",
                "children": [
                    {
                        "label": "资阳区",
                        "value": "430902",
                        "parent": "430900"
                    },
                    {
                        "label": "赫山区",
                        "value": "430903",
                        "parent": "430900"
                    },
                    {
                        "label": "南县",
                        "value": "430921",
                        "parent": "430900"
                    },
                    {
                        "label": "桃江县",
                        "value": "430922",
                        "parent": "430900"
                    },
                    {
                        "label": "安化县",
                        "value": "430923",
                        "parent": "430900"
                    },
                    {
                        "label": "益阳市大通湖管理区",
                        "value": "430971",
                        "parent": "430900"
                    },
                    {
                        "label": "沅江市",
                        "value": "430981",
                        "parent": "430900"
                    }
                ]
            },
            {
                "value": "431000",
                "label": "郴州市",
                "parent": "430000",
                "children": [
                    {
                        "label": "北湖区",
                        "value": "431002",
                        "parent": "431000"
                    },
                    {
                        "label": "苏仙区",
                        "value": "431003",
                        "parent": "431000"
                    },
                    {
                        "label": "桂阳县",
                        "value": "431021",
                        "parent": "431000"
                    },
                    {
                        "label": "宜章县",
                        "value": "431022",
                        "parent": "431000"
                    },
                    {
                        "label": "永兴县",
                        "value": "431023",
                        "parent": "431000"
                    },
                    {
                        "label": "嘉禾县",
                        "value": "431024",
                        "parent": "431000"
                    },
                    {
                        "label": "临武县",
                        "value": "431025",
                        "parent": "431000"
                    },
                    {
                        "label": "汝城县",
                        "value": "431026",
                        "parent": "431000"
                    },
                    {
                        "label": "桂东县",
                        "value": "431027",
                        "parent": "431000"
                    },
                    {
                        "label": "安仁县",
                        "value": "431028",
                        "parent": "431000"
                    },
                    {
                        "label": "资兴市",
                        "value": "431081",
                        "parent": "431000"
                    }
                ]
            },
            {
                "value": "431100",
                "label": "永州市",
                "parent": "430000",
                "children": [
                    {
                        "label": "零陵区",
                        "value": "431102",
                        "parent": "431100"
                    },
                    {
                        "label": "冷水滩区",
                        "value": "431103",
                        "parent": "431100"
                    },
                    {
                        "label": "祁阳县",
                        "value": "431121",
                        "parent": "431100"
                    },
                    {
                        "label": "东安县",
                        "value": "431122",
                        "parent": "431100"
                    },
                    {
                        "label": "双牌县",
                        "value": "431123",
                        "parent": "431100"
                    },
                    {
                        "label": "道县",
                        "value": "431124",
                        "parent": "431100"
                    },
                    {
                        "label": "江永县",
                        "value": "431125",
                        "parent": "431100"
                    },
                    {
                        "label": "宁远县",
                        "value": "431126",
                        "parent": "431100"
                    },
                    {
                        "label": "蓝山县",
                        "value": "431127",
                        "parent": "431100"
                    },
                    {
                        "label": "新田县",
                        "value": "431128",
                        "parent": "431100"
                    },
                    {
                        "label": "江华瑶族自治县",
                        "value": "431129",
                        "parent": "431100"
                    }
                ]
            },
            {
                "value": "431200",
                "label": "怀化市",
                "parent": "430000",
                "children": [
                    {
                        "label": "鹤城区",
                        "value": "431202",
                        "parent": "431200"
                    },
                    {
                        "label": "中方县",
                        "value": "431221",
                        "parent": "431200"
                    },
                    {
                        "label": "沅陵县",
                        "value": "431222",
                        "parent": "431200"
                    },
                    {
                        "label": "辰溪县",
                        "value": "431223",
                        "parent": "431200"
                    },
                    {
                        "label": "溆浦县",
                        "value": "431224",
                        "parent": "431200"
                    },
                    {
                        "label": "会同县",
                        "value": "431225",
                        "parent": "431200"
                    },
                    {
                        "label": "麻阳苗族自治县",
                        "value": "431226",
                        "parent": "431200"
                    },
                    {
                        "label": "新晃侗族自治县",
                        "value": "431227",
                        "parent": "431200"
                    },
                    {
                        "label": "芷江侗族自治县",
                        "value": "431228",
                        "parent": "431200"
                    },
                    {
                        "label": "靖州苗族侗族自治县",
                        "value": "431229",
                        "parent": "431200"
                    },
                    {
                        "label": "通道侗族自治县",
                        "value": "431230",
                        "parent": "431200"
                    },
                    {
                        "label": "怀化市洪江管理区",
                        "value": "431271",
                        "parent": "431200"
                    },
                    {
                        "label": "洪江市",
                        "value": "431281",
                        "parent": "431200"
                    }
                ]
            },
            {
                "value": "431300",
                "label": "娄底市",
                "parent": "430000",
                "children": [
                    {
                        "label": "娄星区",
                        "value": "431302",
                        "parent": "431300"
                    },
                    {
                        "label": "双峰县",
                        "value": "431321",
                        "parent": "431300"
                    },
                    {
                        "label": "新化县",
                        "value": "431322",
                        "parent": "431300"
                    },
                    {
                        "label": "冷水江市",
                        "value": "431381",
                        "parent": "431300"
                    },
                    {
                        "label": "涟源市",
                        "value": "431382",
                        "parent": "431300"
                    }
                ]
            },
            {
                "value": "433100",
                "label": "湘西土家族苗族自治州",
                "parent": "430000",
                "children": [
                    {
                        "label": "吉首市",
                        "value": "433101",
                        "parent": "433100"
                    },
                    {
                        "label": "泸溪县",
                        "value": "433122",
                        "parent": "433100"
                    },
                    {
                        "label": "凤凰县",
                        "value": "433123",
                        "parent": "433100"
                    },
                    {
                        "label": "花垣县",
                        "value": "433124",
                        "parent": "433100"
                    },
                    {
                        "label": "保靖县",
                        "value": "433125",
                        "parent": "433100"
                    },
                    {
                        "label": "古丈县",
                        "value": "433126",
                        "parent": "433100"
                    },
                    {
                        "label": "永顺县",
                        "value": "433127",
                        "parent": "433100"
                    },
                    {
                        "label": "龙山县",
                        "value": "433130",
                        "parent": "433100"
                    }
                ]
            }
        ]
    },
    {
        "value": "440000",
        "label": "广东省",
        "children": [
            {
                "value": "440100",
                "label": "广州市",
                "parent": "440000",
                "children": [
                    {
                        "label": "荔湾区",
                        "value": "440103",
                        "parent": "440100"
                    },
                    {
                        "label": "越秀区",
                        "value": "440104",
                        "parent": "440100"
                    },
                    {
                        "label": "海珠区",
                        "value": "440105",
                        "parent": "440100"
                    },
                    {
                        "label": "天河区",
                        "value": "440106",
                        "parent": "440100"
                    },
                    {
                        "label": "白云区",
                        "value": "440111",
                        "parent": "440100"
                    },
                    {
                        "label": "黄埔区",
                        "value": "440112",
                        "parent": "440100"
                    },
                    {
                        "label": "番禺区",
                        "value": "440113",
                        "parent": "440100"
                    },
                    {
                        "label": "花都区",
                        "value": "440114",
                        "parent": "440100"
                    },
                    {
                        "label": "南沙区",
                        "value": "440115",
                        "parent": "440100"
                    },
                    {
                        "label": "从化区",
                        "value": "440117",
                        "parent": "440100"
                    },
                    {
                        "label": "增城区",
                        "value": "440118",
                        "parent": "440100"
                    }
                ]
            },
            {
                "value": "440200",
                "label": "韶关市",
                "parent": "440000",
                "children": [
                    {
                        "label": "武江区",
                        "value": "440203",
                        "parent": "440200"
                    },
                    {
                        "label": "浈江区",
                        "value": "440204",
                        "parent": "440200"
                    },
                    {
                        "label": "曲江区",
                        "value": "440205",
                        "parent": "440200"
                    },
                    {
                        "label": "始兴县",
                        "value": "440222",
                        "parent": "440200"
                    },
                    {
                        "label": "仁化县",
                        "value": "440224",
                        "parent": "440200"
                    },
                    {
                        "label": "翁源县",
                        "value": "440229",
                        "parent": "440200"
                    },
                    {
                        "label": "乳源瑶族自治县",
                        "value": "440232",
                        "parent": "440200"
                    },
                    {
                        "label": "新丰县",
                        "value": "440233",
                        "parent": "440200"
                    },
                    {
                        "label": "乐昌市",
                        "value": "440281",
                        "parent": "440200"
                    },
                    {
                        "label": "南雄市",
                        "value": "440282",
                        "parent": "440200"
                    }
                ]
            },
            {
                "value": "440300",
                "label": "深圳市",
                "parent": "440000",
                "children": [
                    {
                        "label": "罗湖区",
                        "value": "440303",
                        "parent": "440300"
                    },
                    {
                        "label": "福田区",
                        "value": "440304",
                        "parent": "440300"
                    },
                    {
                        "label": "南山区",
                        "value": "440305",
                        "parent": "440300"
                    },
                    {
                        "label": "宝安区",
                        "value": "440306",
                        "parent": "440300"
                    },
                    {
                        "label": "龙岗区",
                        "value": "440307",
                        "parent": "440300"
                    },
                    {
                        "label": "盐田区",
                        "value": "440308",
                        "parent": "440300"
                    },
                    {
                        "label": "龙华区",
                        "value": "440309",
                        "parent": "440300"
                    },
                    {
                        "label": "坪山区",
                        "value": "440310",
                        "parent": "440300"
                    },
                    {
                        "label": "光明区",
                        "value": "440311",
                        "parent": "440300"
                    }
                ]
            },
            {
                "value": "440400",
                "label": "珠海市",
                "parent": "440000",
                "children": [
                    {
                        "label": "香洲区",
                        "value": "440402",
                        "parent": "440400"
                    },
                    {
                        "label": "斗门区",
                        "value": "440403",
                        "parent": "440400"
                    },
                    {
                        "label": "金湾区",
                        "value": "440404",
                        "parent": "440400"
                    }
                ]
            },
            {
                "value": "440500",
                "label": "汕头市",
                "parent": "440000",
                "children": [
                    {
                        "label": "龙湖区",
                        "value": "440507",
                        "parent": "440500"
                    },
                    {
                        "label": "金平区",
                        "value": "440511",
                        "parent": "440500"
                    },
                    {
                        "label": "濠江区",
                        "value": "440512",
                        "parent": "440500"
                    },
                    {
                        "label": "潮阳区",
                        "value": "440513",
                        "parent": "440500"
                    },
                    {
                        "label": "潮南区",
                        "value": "440514",
                        "parent": "440500"
                    },
                    {
                        "label": "澄海区",
                        "value": "440515",
                        "parent": "440500"
                    },
                    {
                        "label": "南澳县",
                        "value": "440523",
                        "parent": "440500"
                    }
                ]
            },
            {
                "value": "440600",
                "label": "佛山市",
                "parent": "440000",
                "children": [
                    {
                        "label": "禅城区",
                        "value": "440604",
                        "parent": "440600"
                    },
                    {
                        "label": "南海区",
                        "value": "440605",
                        "parent": "440600"
                    },
                    {
                        "label": "顺德区",
                        "value": "440606",
                        "parent": "440600"
                    },
                    {
                        "label": "三水区",
                        "value": "440607",
                        "parent": "440600"
                    },
                    {
                        "label": "高明区",
                        "value": "440608",
                        "parent": "440600"
                    }
                ]
            },
            {
                "value": "440700",
                "label": "江门市",
                "parent": "440000",
                "children": [
                    {
                        "label": "蓬江区",
                        "value": "440703",
                        "parent": "440700"
                    },
                    {
                        "label": "江海区",
                        "value": "440704",
                        "parent": "440700"
                    },
                    {
                        "label": "新会区",
                        "value": "440705",
                        "parent": "440700"
                    },
                    {
                        "label": "台山市",
                        "value": "440781",
                        "parent": "440700"
                    },
                    {
                        "label": "开平市",
                        "value": "440783",
                        "parent": "440700"
                    },
                    {
                        "label": "鹤山市",
                        "value": "440784",
                        "parent": "440700"
                    },
                    {
                        "label": "恩平市",
                        "value": "440785",
                        "parent": "440700"
                    }
                ]
            },
            {
                "value": "440800",
                "label": "湛江市",
                "parent": "440000",
                "children": [
                    {
                        "label": "赤坎区",
                        "value": "440802",
                        "parent": "440800"
                    },
                    {
                        "label": "霞山区",
                        "value": "440803",
                        "parent": "440800"
                    },
                    {
                        "label": "坡头区",
                        "value": "440804",
                        "parent": "440800"
                    },
                    {
                        "label": "麻章区",
                        "value": "440811",
                        "parent": "440800"
                    },
                    {
                        "label": "遂溪县",
                        "value": "440823",
                        "parent": "440800"
                    },
                    {
                        "label": "徐闻县",
                        "value": "440825",
                        "parent": "440800"
                    },
                    {
                        "label": "廉江市",
                        "value": "440881",
                        "parent": "440800"
                    },
                    {
                        "label": "雷州市",
                        "value": "440882",
                        "parent": "440800"
                    },
                    {
                        "label": "吴川市",
                        "value": "440883",
                        "parent": "440800"
                    },
                    {
                        "label": "经济技术开发区",
                        "value": "440890",
                        "parent": "440800"
                    }
                ]
            },
            {
                "value": "440900",
                "label": "茂名市",
                "parent": "440000",
                "children": [
                    {
                        "label": "茂南区",
                        "value": "440902",
                        "parent": "440900"
                    },
                    {
                        "label": "电白区",
                        "value": "440904",
                        "parent": "440900"
                    },
                    {
                        "label": "高州市",
                        "value": "440981",
                        "parent": "440900"
                    },
                    {
                        "label": "化州市",
                        "value": "440982",
                        "parent": "440900"
                    },
                    {
                        "label": "信宜市",
                        "value": "440983",
                        "parent": "440900"
                    }
                ]
            },
            {
                "value": "441200",
                "label": "肇庆市",
                "parent": "440000",
                "children": [
                    {
                        "label": "端州区",
                        "value": "441202",
                        "parent": "441200"
                    },
                    {
                        "label": "鼎湖区",
                        "value": "441203",
                        "parent": "441200"
                    },
                    {
                        "label": "高要区",
                        "value": "441204",
                        "parent": "441200"
                    },
                    {
                        "label": "广宁县",
                        "value": "441223",
                        "parent": "441200"
                    },
                    {
                        "label": "怀集县",
                        "value": "441224",
                        "parent": "441200"
                    },
                    {
                        "label": "封开县",
                        "value": "441225",
                        "parent": "441200"
                    },
                    {
                        "label": "德庆县",
                        "value": "441226",
                        "parent": "441200"
                    },
                    {
                        "label": "四会市",
                        "value": "441284",
                        "parent": "441200"
                    }
                ]
            },
            {
                "value": "441300",
                "label": "惠州市",
                "parent": "440000",
                "children": [
                    {
                        "label": "惠城区",
                        "value": "441302",
                        "parent": "441300"
                    },
                    {
                        "label": "惠阳区",
                        "value": "441303",
                        "parent": "441300"
                    },
                    {
                        "label": "博罗县",
                        "value": "441322",
                        "parent": "441300"
                    },
                    {
                        "label": "惠东县",
                        "value": "441323",
                        "parent": "441300"
                    },
                    {
                        "label": "龙门县",
                        "value": "441324",
                        "parent": "441300"
                    }
                ]
            },
            {
                "value": "441400",
                "label": "梅州市",
                "parent": "440000",
                "children": [
                    {
                        "label": "梅江区",
                        "value": "441402",
                        "parent": "441400"
                    },
                    {
                        "label": "梅县区",
                        "value": "441403",
                        "parent": "441400"
                    },
                    {
                        "label": "大埔县",
                        "value": "441422",
                        "parent": "441400"
                    },
                    {
                        "label": "丰顺县",
                        "value": "441423",
                        "parent": "441400"
                    },
                    {
                        "label": "五华县",
                        "value": "441424",
                        "parent": "441400"
                    },
                    {
                        "label": "平远县",
                        "value": "441426",
                        "parent": "441400"
                    },
                    {
                        "label": "蕉岭县",
                        "value": "441427",
                        "parent": "441400"
                    },
                    {
                        "label": "兴宁市",
                        "value": "441481",
                        "parent": "441400"
                    }
                ]
            },
            {
                "value": "441500",
                "label": "汕尾市",
                "parent": "440000",
                "children": [
                    {
                        "label": "城区",
                        "value": "441502",
                        "parent": "441500"
                    },
                    {
                        "label": "海丰县",
                        "value": "441521",
                        "parent": "441500"
                    },
                    {
                        "label": "陆河县",
                        "value": "441523",
                        "parent": "441500"
                    },
                    {
                        "label": "陆丰市",
                        "value": "441581",
                        "parent": "441500"
                    }
                ]
            },
            {
                "value": "441600",
                "label": "河源市",
                "parent": "440000",
                "children": [
                    {
                        "label": "源城区",
                        "value": "441602",
                        "parent": "441600"
                    },
                    {
                        "label": "紫金县",
                        "value": "441621",
                        "parent": "441600"
                    },
                    {
                        "label": "龙川县",
                        "value": "441622",
                        "parent": "441600"
                    },
                    {
                        "label": "连平县",
                        "value": "441623",
                        "parent": "441600"
                    },
                    {
                        "label": "和平县",
                        "value": "441624",
                        "parent": "441600"
                    },
                    {
                        "label": "东源县",
                        "value": "441625",
                        "parent": "441600"
                    }
                ]
            },
            {
                "value": "441700",
                "label": "阳江市",
                "parent": "440000",
                "children": [
                    {
                        "label": "江城区",
                        "value": "441702",
                        "parent": "441700"
                    },
                    {
                        "label": "阳东区",
                        "value": "441704",
                        "parent": "441700"
                    },
                    {
                        "label": "阳西县",
                        "value": "441721",
                        "parent": "441700"
                    },
                    {
                        "label": "阳春市",
                        "value": "441781",
                        "parent": "441700"
                    }
                ]
            },
            {
                "value": "441800",
                "label": "清远市",
                "parent": "440000",
                "children": [
                    {
                        "label": "清城区",
                        "value": "441802",
                        "parent": "441800"
                    },
                    {
                        "label": "清新区",
                        "value": "441803",
                        "parent": "441800"
                    },
                    {
                        "label": "佛冈县",
                        "value": "441821",
                        "parent": "441800"
                    },
                    {
                        "label": "阳山县",
                        "value": "441823",
                        "parent": "441800"
                    },
                    {
                        "label": "连山壮族瑶族自治县",
                        "value": "441825",
                        "parent": "441800"
                    },
                    {
                        "label": "连南瑶族自治县",
                        "value": "441826",
                        "parent": "441800"
                    },
                    {
                        "label": "英德市",
                        "value": "441881",
                        "parent": "441800"
                    },
                    {
                        "label": "连州市",
                        "value": "441882",
                        "parent": "441800"
                    }
                ]
            },
            {
                "value": "441900",
                "label": "东莞市",
                "parent": "440000",
                "children": [
                    {
                        "label": "中堂镇",
                        "value": "441901",
                        "parent": "441900"
                    },
                    {
                        "label": "南城街道",
                        "value": "441903",
                        "parent": "441900"
                    },
                    {
                        "label": "长安镇",
                        "value": "441904",
                        "parent": "441900"
                    },
                    {
                        "label": "东坑镇",
                        "value": "441905",
                        "parent": "441900"
                    },
                    {
                        "label": "樟木头镇",
                        "value": "441906",
                        "parent": "441900"
                    },
                    {
                        "label": "莞城街道",
                        "value": "441907",
                        "parent": "441900"
                    },
                    {
                        "label": "石龙镇",
                        "value": "441908",
                        "parent": "441900"
                    },
                    {
                        "label": "桥头镇",
                        "value": "441909",
                        "parent": "441900"
                    },
                    {
                        "label": "万江街道",
                        "value": "441910",
                        "parent": "441900"
                    },
                    {
                        "label": "麻涌镇",
                        "value": "441911",
                        "parent": "441900"
                    },
                    {
                        "label": "虎门镇",
                        "value": "441912",
                        "parent": "441900"
                    },
                    {
                        "label": "谢岗镇",
                        "value": "441913",
                        "parent": "441900"
                    },
                    {
                        "label": "石碣镇",
                        "value": "441914",
                        "parent": "441900"
                    },
                    {
                        "label": "茶山镇",
                        "value": "441915",
                        "parent": "441900"
                    },
                    {
                        "label": "东城街道",
                        "value": "441916",
                        "parent": "441900"
                    },
                    {
                        "label": "洪梅镇",
                        "value": "441917",
                        "parent": "441900"
                    },
                    {
                        "label": "道滘镇",
                        "value": "441918",
                        "parent": "441900"
                    },
                    {
                        "label": "高埗镇",
                        "value": "441919",
                        "parent": "441900"
                    },
                    {
                        "label": "企石镇",
                        "value": "441920",
                        "parent": "441900"
                    },
                    {
                        "label": "凤岗镇",
                        "value": "441921",
                        "parent": "441900"
                    },
                    {
                        "label": "大岭山镇",
                        "value": "441922",
                        "parent": "441900"
                    },
                    {
                        "label": "松山湖",
                        "value": "441923",
                        "parent": "441900"
                    },
                    {
                        "label": "清溪镇",
                        "value": "441924",
                        "parent": "441900"
                    },
                    {
                        "label": "望牛墩镇",
                        "value": "441925",
                        "parent": "441900"
                    },
                    {
                        "label": "厚街镇",
                        "value": "441926",
                        "parent": "441900"
                    },
                    {
                        "label": "常平镇",
                        "value": "441927",
                        "parent": "441900"
                    },
                    {
                        "label": "寮步镇",
                        "value": "441928",
                        "parent": "441900"
                    },
                    {
                        "label": "石排镇",
                        "value": "441929",
                        "parent": "441900"
                    },
                    {
                        "label": "横沥镇",
                        "value": "441930",
                        "parent": "441900"
                    },
                    {
                        "label": "塘厦镇",
                        "value": "441931",
                        "parent": "441900"
                    },
                    {
                        "label": "黄江镇",
                        "value": "441932",
                        "parent": "441900"
                    },
                    {
                        "label": "大朗镇",
                        "value": "441933",
                        "parent": "441900"
                    },
                    {
                        "label": "东莞港",
                        "value": "441934",
                        "parent": "441900"
                    },
                    {
                        "label": "东莞生态园",
                        "value": "441935",
                        "parent": "441900"
                    },
                    {
                        "label": "沙田镇",
                        "value": "441990",
                        "parent": "441900"
                    }
                ]
            },
            {
                "value": "442000",
                "label": "中山市",
                "parent": "440000",
                "children": [
                    {
                        "label": "南头镇",
                        "value": "442001",
                        "parent": "442000"
                    },
                    {
                        "label": "神湾镇",
                        "value": "442002",
                        "parent": "442000"
                    },
                    {
                        "label": "东凤镇",
                        "value": "442003",
                        "parent": "442000"
                    },
                    {
                        "label": "五桂山街道",
                        "value": "442004",
                        "parent": "442000"
                    },
                    {
                        "label": "黄圃镇",
                        "value": "442005",
                        "parent": "442000"
                    },
                    {
                        "label": "小榄镇",
                        "value": "442006",
                        "parent": "442000"
                    },
                    {
                        "label": "石岐街道",
                        "value": "442007",
                        "parent": "442000"
                    },
                    {
                        "label": "横栏镇",
                        "value": "442008",
                        "parent": "442000"
                    },
                    {
                        "label": "三角镇",
                        "value": "442009",
                        "parent": "442000"
                    },
                    {
                        "label": "三乡镇",
                        "value": "442010",
                        "parent": "442000"
                    },
                    {
                        "label": "港口镇",
                        "value": "442011",
                        "parent": "442000"
                    },
                    {
                        "label": "沙溪镇",
                        "value": "442012",
                        "parent": "442000"
                    },
                    {
                        "label": "板芙镇",
                        "value": "442013",
                        "parent": "442000"
                    },
                    {
                        "label": "东升镇",
                        "value": "442015",
                        "parent": "442000"
                    },
                    {
                        "label": "阜沙镇",
                        "value": "442016",
                        "parent": "442000"
                    },
                    {
                        "label": "民众镇",
                        "value": "442017",
                        "parent": "442000"
                    },
                    {
                        "label": "东区街道",
                        "value": "442018",
                        "parent": "442000"
                    },
                    {
                        "label": "火炬开发区街道办事处",
                        "value": "442019",
                        "parent": "442000"
                    },
                    {
                        "label": "西区街道",
                        "value": "442020",
                        "parent": "442000"
                    },
                    {
                        "label": "南区街道",
                        "value": "442021",
                        "parent": "442000"
                    },
                    {
                        "label": "古镇镇",
                        "value": "442022",
                        "parent": "442000"
                    },
                    {
                        "label": "坦洲镇",
                        "value": "442023",
                        "parent": "442000"
                    },
                    {
                        "label": "大涌镇",
                        "value": "442024",
                        "parent": "442000"
                    },
                    {
                        "label": "南朗镇",
                        "value": "442025",
                        "parent": "442000"
                    }
                ]
            },
            {
                "value": "442101",
                "label": "东沙群岛",
                "parent": "440000",
                "children": []
            },
            {
                "value": "445100",
                "label": "潮州市",
                "parent": "440000",
                "children": [
                    {
                        "label": "湘桥区",
                        "value": "445102",
                        "parent": "445100"
                    },
                    {
                        "label": "潮安区",
                        "value": "445103",
                        "parent": "445100"
                    },
                    {
                        "label": "饶平县",
                        "value": "445122",
                        "parent": "445100"
                    }
                ]
            },
            {
                "value": "445200",
                "label": "揭阳市",
                "parent": "440000",
                "children": [
                    {
                        "label": "榕城区",
                        "value": "445202",
                        "parent": "445200"
                    },
                    {
                        "label": "揭东区",
                        "value": "445203",
                        "parent": "445200"
                    },
                    {
                        "label": "揭西县",
                        "value": "445222",
                        "parent": "445200"
                    },
                    {
                        "label": "惠来县",
                        "value": "445224",
                        "parent": "445200"
                    },
                    {
                        "label": "普宁市",
                        "value": "445281",
                        "parent": "445200"
                    }
                ]
            },
            {
                "value": "445300",
                "label": "云浮市",
                "parent": "440000",
                "children": [
                    {
                        "label": "云城区",
                        "value": "445302",
                        "parent": "445300"
                    },
                    {
                        "label": "云安区",
                        "value": "445303",
                        "parent": "445300"
                    },
                    {
                        "label": "新兴县",
                        "value": "445321",
                        "parent": "445300"
                    },
                    {
                        "label": "郁南县",
                        "value": "445322",
                        "parent": "445300"
                    },
                    {
                        "label": "罗定市",
                        "value": "445381",
                        "parent": "445300"
                    }
                ]
            }
        ]
    },
    {
        "value": "450000",
        "label": "广西壮族自治区",
        "children": [
            {
                "value": "450100",
                "label": "南宁市",
                "parent": "450000",
                "children": [
                    {
                        "label": "兴宁区",
                        "value": "450102",
                        "parent": "450100"
                    },
                    {
                        "label": "青秀区",
                        "value": "450103",
                        "parent": "450100"
                    },
                    {
                        "label": "江南区",
                        "value": "450105",
                        "parent": "450100"
                    },
                    {
                        "label": "西乡塘区",
                        "value": "450107",
                        "parent": "450100"
                    },
                    {
                        "label": "良庆区",
                        "value": "450108",
                        "parent": "450100"
                    },
                    {
                        "label": "邕宁区",
                        "value": "450109",
                        "parent": "450100"
                    },
                    {
                        "label": "武鸣区",
                        "value": "450110",
                        "parent": "450100"
                    },
                    {
                        "label": "隆安县",
                        "value": "450123",
                        "parent": "450100"
                    },
                    {
                        "label": "马山县",
                        "value": "450124",
                        "parent": "450100"
                    },
                    {
                        "label": "上林县",
                        "value": "450125",
                        "parent": "450100"
                    },
                    {
                        "label": "宾阳县",
                        "value": "450126",
                        "parent": "450100"
                    },
                    {
                        "label": "横县",
                        "value": "450127",
                        "parent": "450100"
                    }
                ]
            },
            {
                "value": "450200",
                "label": "柳州市",
                "parent": "450000",
                "children": [
                    {
                        "label": "城中区",
                        "value": "450202",
                        "parent": "450200"
                    },
                    {
                        "label": "鱼峰区",
                        "value": "450203",
                        "parent": "450200"
                    },
                    {
                        "label": "柳南区",
                        "value": "450204",
                        "parent": "450200"
                    },
                    {
                        "label": "柳北区",
                        "value": "450205",
                        "parent": "450200"
                    },
                    {
                        "label": "柳江区",
                        "value": "450206",
                        "parent": "450200"
                    },
                    {
                        "label": "柳城县",
                        "value": "450222",
                        "parent": "450200"
                    },
                    {
                        "label": "鹿寨县",
                        "value": "450223",
                        "parent": "450200"
                    },
                    {
                        "label": "融安县",
                        "value": "450224",
                        "parent": "450200"
                    },
                    {
                        "label": "融水苗族自治县",
                        "value": "450225",
                        "parent": "450200"
                    },
                    {
                        "label": "三江侗族自治县",
                        "value": "450226",
                        "parent": "450200"
                    }
                ]
            },
            {
                "value": "450300",
                "label": "桂林市",
                "parent": "450000",
                "children": [
                    {
                        "label": "秀峰区",
                        "value": "450302",
                        "parent": "450300"
                    },
                    {
                        "label": "叠彩区",
                        "value": "450303",
                        "parent": "450300"
                    },
                    {
                        "label": "象山区",
                        "value": "450304",
                        "parent": "450300"
                    },
                    {
                        "label": "七星区",
                        "value": "450305",
                        "parent": "450300"
                    },
                    {
                        "label": "雁山区",
                        "value": "450311",
                        "parent": "450300"
                    },
                    {
                        "label": "临桂区",
                        "value": "450312",
                        "parent": "450300"
                    },
                    {
                        "label": "阳朔县",
                        "value": "450321",
                        "parent": "450300"
                    },
                    {
                        "label": "灵川县",
                        "value": "450323",
                        "parent": "450300"
                    },
                    {
                        "label": "全州县",
                        "value": "450324",
                        "parent": "450300"
                    },
                    {
                        "label": "兴安县",
                        "value": "450325",
                        "parent": "450300"
                    },
                    {
                        "label": "永福县",
                        "value": "450326",
                        "parent": "450300"
                    },
                    {
                        "label": "灌阳县",
                        "value": "450327",
                        "parent": "450300"
                    },
                    {
                        "label": "龙胜各族自治县",
                        "value": "450328",
                        "parent": "450300"
                    },
                    {
                        "label": "资源县",
                        "value": "450329",
                        "parent": "450300"
                    },
                    {
                        "label": "平乐县",
                        "value": "450330",
                        "parent": "450300"
                    },
                    {
                        "label": "恭城瑶族自治县",
                        "value": "450332",
                        "parent": "450300"
                    },
                    {
                        "label": "荔浦市",
                        "value": "450381",
                        "parent": "450300"
                    }
                ]
            },
            {
                "value": "450400",
                "label": "梧州市",
                "parent": "450000",
                "children": [
                    {
                        "label": "万秀区",
                        "value": "450403",
                        "parent": "450400"
                    },
                    {
                        "label": "长洲区",
                        "value": "450405",
                        "parent": "450400"
                    },
                    {
                        "label": "龙圩区",
                        "value": "450406",
                        "parent": "450400"
                    },
                    {
                        "label": "苍梧县",
                        "value": "450421",
                        "parent": "450400"
                    },
                    {
                        "label": "藤县",
                        "value": "450422",
                        "parent": "450400"
                    },
                    {
                        "label": "蒙山县",
                        "value": "450423",
                        "parent": "450400"
                    },
                    {
                        "label": "岑溪市",
                        "value": "450481",
                        "parent": "450400"
                    }
                ]
            },
            {
                "value": "450500",
                "label": "北海市",
                "parent": "450000",
                "children": [
                    {
                        "label": "海城区",
                        "value": "450502",
                        "parent": "450500"
                    },
                    {
                        "label": "银海区",
                        "value": "450503",
                        "parent": "450500"
                    },
                    {
                        "label": "铁山港区",
                        "value": "450512",
                        "parent": "450500"
                    },
                    {
                        "label": "合浦县",
                        "value": "450521",
                        "parent": "450500"
                    }
                ]
            },
            {
                "value": "450600",
                "label": "防城港市",
                "parent": "450000",
                "children": [
                    {
                        "label": "港口区",
                        "value": "450602",
                        "parent": "450600"
                    },
                    {
                        "label": "防城区",
                        "value": "450603",
                        "parent": "450600"
                    },
                    {
                        "label": "上思县",
                        "value": "450621",
                        "parent": "450600"
                    },
                    {
                        "label": "东兴市",
                        "value": "450681",
                        "parent": "450600"
                    }
                ]
            },
            {
                "value": "450700",
                "label": "钦州市",
                "parent": "450000",
                "children": [
                    {
                        "label": "钦南区",
                        "value": "450702",
                        "parent": "450700"
                    },
                    {
                        "label": "钦北区",
                        "value": "450703",
                        "parent": "450700"
                    },
                    {
                        "label": "灵山县",
                        "value": "450721",
                        "parent": "450700"
                    },
                    {
                        "label": "浦北县",
                        "value": "450722",
                        "parent": "450700"
                    }
                ]
            },
            {
                "value": "450800",
                "label": "贵港市",
                "parent": "450000",
                "children": [
                    {
                        "label": "港北区",
                        "value": "450802",
                        "parent": "450800"
                    },
                    {
                        "label": "港南区",
                        "value": "450803",
                        "parent": "450800"
                    },
                    {
                        "label": "覃塘区",
                        "value": "450804",
                        "parent": "450800"
                    },
                    {
                        "label": "平南县",
                        "value": "450821",
                        "parent": "450800"
                    },
                    {
                        "label": "桂平市",
                        "value": "450881",
                        "parent": "450800"
                    }
                ]
            },
            {
                "value": "450900",
                "label": "玉林市",
                "parent": "450000",
                "children": [
                    {
                        "label": "玉州区",
                        "value": "450902",
                        "parent": "450900"
                    },
                    {
                        "label": "福绵区",
                        "value": "450903",
                        "parent": "450900"
                    },
                    {
                        "label": "容县",
                        "value": "450921",
                        "parent": "450900"
                    },
                    {
                        "label": "陆川县",
                        "value": "450922",
                        "parent": "450900"
                    },
                    {
                        "label": "博白县",
                        "value": "450923",
                        "parent": "450900"
                    },
                    {
                        "label": "兴业县",
                        "value": "450924",
                        "parent": "450900"
                    },
                    {
                        "label": "北流市",
                        "value": "450981",
                        "parent": "450900"
                    }
                ]
            },
            {
                "value": "451000",
                "label": "百色市",
                "parent": "450000",
                "children": [
                    {
                        "label": "右江区",
                        "value": "451002",
                        "parent": "451000"
                    },
                    {
                        "label": "田阳区",
                        "value": "451003",
                        "parent": "451000"
                    },
                    {
                        "label": "田东县",
                        "value": "451022",
                        "parent": "451000"
                    },
                    {
                        "label": "德保县",
                        "value": "451024",
                        "parent": "451000"
                    },
                    {
                        "label": "那坡县",
                        "value": "451026",
                        "parent": "451000"
                    },
                    {
                        "label": "凌云县",
                        "value": "451027",
                        "parent": "451000"
                    },
                    {
                        "label": "乐业县",
                        "value": "451028",
                        "parent": "451000"
                    },
                    {
                        "label": "田林县",
                        "value": "451029",
                        "parent": "451000"
                    },
                    {
                        "label": "西林县",
                        "value": "451030",
                        "parent": "451000"
                    },
                    {
                        "label": "隆林各族自治县",
                        "value": "451031",
                        "parent": "451000"
                    },
                    {
                        "label": "靖西市",
                        "value": "451081",
                        "parent": "451000"
                    },
                    {
                        "label": "平果市",
                        "value": "451082",
                        "parent": "451000"
                    }
                ]
            },
            {
                "value": "451100",
                "label": "贺州市",
                "parent": "450000",
                "children": [
                    {
                        "label": "八步区",
                        "value": "451102",
                        "parent": "451100"
                    },
                    {
                        "label": "平桂区",
                        "value": "451103",
                        "parent": "451100"
                    },
                    {
                        "label": "昭平县",
                        "value": "451121",
                        "parent": "451100"
                    },
                    {
                        "label": "钟山县",
                        "value": "451122",
                        "parent": "451100"
                    },
                    {
                        "label": "富川瑶族自治县",
                        "value": "451123",
                        "parent": "451100"
                    }
                ]
            },
            {
                "value": "451200",
                "label": "河池市",
                "parent": "450000",
                "children": [
                    {
                        "label": "金城江区",
                        "value": "451202",
                        "parent": "451200"
                    },
                    {
                        "label": "宜州区",
                        "value": "451203",
                        "parent": "451200"
                    },
                    {
                        "label": "南丹县",
                        "value": "451221",
                        "parent": "451200"
                    },
                    {
                        "label": "天峨县",
                        "value": "451222",
                        "parent": "451200"
                    },
                    {
                        "label": "凤山县",
                        "value": "451223",
                        "parent": "451200"
                    },
                    {
                        "label": "东兰县",
                        "value": "451224",
                        "parent": "451200"
                    },
                    {
                        "label": "罗城仫佬族自治县",
                        "value": "451225",
                        "parent": "451200"
                    },
                    {
                        "label": "环江毛南族自治县",
                        "value": "451226",
                        "parent": "451200"
                    },
                    {
                        "label": "巴马瑶族自治县",
                        "value": "451227",
                        "parent": "451200"
                    },
                    {
                        "label": "都安瑶族自治县",
                        "value": "451228",
                        "parent": "451200"
                    },
                    {
                        "label": "大化瑶族自治县",
                        "value": "451229",
                        "parent": "451200"
                    }
                ]
            },
            {
                "value": "451300",
                "label": "来宾市",
                "parent": "450000",
                "children": [
                    {
                        "label": "兴宾区",
                        "value": "451302",
                        "parent": "451300"
                    },
                    {
                        "label": "忻城县",
                        "value": "451321",
                        "parent": "451300"
                    },
                    {
                        "label": "象州县",
                        "value": "451322",
                        "parent": "451300"
                    },
                    {
                        "label": "武宣县",
                        "value": "451323",
                        "parent": "451300"
                    },
                    {
                        "label": "金秀瑶族自治县",
                        "value": "451324",
                        "parent": "451300"
                    },
                    {
                        "label": "合山市",
                        "value": "451381",
                        "parent": "451300"
                    }
                ]
            },
            {
                "value": "451400",
                "label": "崇左市",
                "parent": "450000",
                "children": [
                    {
                        "label": "江州区",
                        "value": "451402",
                        "parent": "451400"
                    },
                    {
                        "label": "扶绥县",
                        "value": "451421",
                        "parent": "451400"
                    },
                    {
                        "label": "宁明县",
                        "value": "451422",
                        "parent": "451400"
                    },
                    {
                        "label": "龙州县",
                        "value": "451423",
                        "parent": "451400"
                    },
                    {
                        "label": "大新县",
                        "value": "451424",
                        "parent": "451400"
                    },
                    {
                        "label": "天等县",
                        "value": "451425",
                        "parent": "451400"
                    },
                    {
                        "label": "凭祥市",
                        "value": "451481",
                        "parent": "451400"
                    }
                ]
            }
        ]
    },
    {
        "value": "460000",
        "label": "海南省",
        "children": [
            {
                "value": "460100",
                "label": "海口市",
                "parent": "460000",
                "children": [
                    {
                        "label": "秀英区",
                        "value": "460105",
                        "parent": "460100"
                    },
                    {
                        "label": "龙华区",
                        "value": "460106",
                        "parent": "460100"
                    },
                    {
                        "label": "琼山区",
                        "value": "460107",
                        "parent": "460100"
                    },
                    {
                        "label": "美兰区",
                        "value": "460108",
                        "parent": "460100"
                    }
                ]
            },
            {
                "value": "460200",
                "label": "三亚市",
                "parent": "460000",
                "children": [
                    {
                        "label": "海棠区",
                        "value": "460202",
                        "parent": "460200"
                    },
                    {
                        "label": "吉阳区",
                        "value": "460203",
                        "parent": "460200"
                    },
                    {
                        "label": "天涯区",
                        "value": "460204",
                        "parent": "460200"
                    },
                    {
                        "label": "崖州区",
                        "value": "460205",
                        "parent": "460200"
                    }
                ]
            },
            {
                "value": "460300",
                "label": "三沙市",
                "parent": "460000",
                "children": [
                    {
                        "label": "西沙区",
                        "value": "460321",
                        "parent": "460300"
                    },
                    {
                        "label": "南沙区",
                        "value": "460322",
                        "parent": "460300"
                    }
                ]
            }
        ]
    },
    {
        "value": "500000",
        "label": "重庆",
        "children": [
            {
                "value": "500100",
                "label": "重庆市",
                "parent": "500000",
                "children": [
                    {
                        "label": "万州区",
                        "value": "500101",
                        "parent": "500100"
                    },
                    {
                        "label": "涪陵区",
                        "value": "500102",
                        "parent": "500100"
                    },
                    {
                        "label": "渝中区",
                        "value": "500103",
                        "parent": "500100"
                    },
                    {
                        "label": "大渡口区",
                        "value": "500104",
                        "parent": "500100"
                    },
                    {
                        "label": "江北区",
                        "value": "500105",
                        "parent": "500100"
                    },
                    {
                        "label": "沙坪坝区",
                        "value": "500106",
                        "parent": "500100"
                    },
                    {
                        "label": "九龙坡区",
                        "value": "500107",
                        "parent": "500100"
                    },
                    {
                        "label": "南岸区",
                        "value": "500108",
                        "parent": "500100"
                    },
                    {
                        "label": "北碚区",
                        "value": "500109",
                        "parent": "500100"
                    },
                    {
                        "label": "綦江区",
                        "value": "500110",
                        "parent": "500100"
                    },
                    {
                        "label": "大足区",
                        "value": "500111",
                        "parent": "500100"
                    },
                    {
                        "label": "渝北区",
                        "value": "500112",
                        "parent": "500100"
                    },
                    {
                        "label": "巴南区",
                        "value": "500113",
                        "parent": "500100"
                    },
                    {
                        "label": "黔江区",
                        "value": "500114",
                        "parent": "500100"
                    },
                    {
                        "label": "长寿区",
                        "value": "500115",
                        "parent": "500100"
                    },
                    {
                        "label": "江津区",
                        "value": "500116",
                        "parent": "500100"
                    },
                    {
                        "label": "合川区",
                        "value": "500117",
                        "parent": "500100"
                    },
                    {
                        "label": "永川区",
                        "value": "500118",
                        "parent": "500100"
                    },
                    {
                        "label": "南川区",
                        "value": "500119",
                        "parent": "500100"
                    },
                    {
                        "label": "璧山区",
                        "value": "500120",
                        "parent": "500100"
                    },
                    {
                        "label": "铜梁区",
                        "value": "500151",
                        "parent": "500100"
                    },
                    {
                        "label": "潼南区",
                        "value": "500152",
                        "parent": "500100"
                    },
                    {
                        "label": "荣昌区",
                        "value": "500153",
                        "parent": "500100"
                    },
                    {
                        "label": "开州区",
                        "value": "500154",
                        "parent": "500100"
                    },
                    {
                        "label": "梁平区",
                        "value": "500155",
                        "parent": "500100"
                    },
                    {
                        "label": "武隆区",
                        "value": "500156",
                        "parent": "500100"
                    }
                ]
            }
        ]
    },
    {
        "value": "510000",
        "label": "四川省",
        "children": [
            {
                "value": "510100",
                "label": "成都市",
                "parent": "510000",
                "children": [
                    {
                        "label": "锦江区",
                        "value": "510104",
                        "parent": "510100"
                    },
                    {
                        "label": "青羊区",
                        "value": "510105",
                        "parent": "510100"
                    },
                    {
                        "label": "金牛区",
                        "value": "510106",
                        "parent": "510100"
                    },
                    {
                        "label": "武侯区",
                        "value": "510107",
                        "parent": "510100"
                    },
                    {
                        "label": "成华区",
                        "value": "510108",
                        "parent": "510100"
                    },
                    {
                        "label": "龙泉驿区",
                        "value": "510112",
                        "parent": "510100"
                    },
                    {
                        "label": "青白江区",
                        "value": "510113",
                        "parent": "510100"
                    },
                    {
                        "label": "新都区",
                        "value": "510114",
                        "parent": "510100"
                    },
                    {
                        "label": "温江区",
                        "value": "510115",
                        "parent": "510100"
                    },
                    {
                        "label": "双流区",
                        "value": "510116",
                        "parent": "510100"
                    },
                    {
                        "label": "郫都区",
                        "value": "510117",
                        "parent": "510100"
                    },
                    {
                        "label": "金堂县",
                        "value": "510121",
                        "parent": "510100"
                    },
                    {
                        "label": "大邑县",
                        "value": "510129",
                        "parent": "510100"
                    },
                    {
                        "label": "蒲江县",
                        "value": "510131",
                        "parent": "510100"
                    },
                    {
                        "label": "新津县",
                        "value": "510132",
                        "parent": "510100"
                    },
                    {
                        "label": "都江堰市",
                        "value": "510181",
                        "parent": "510100"
                    },
                    {
                        "label": "彭州市",
                        "value": "510182",
                        "parent": "510100"
                    },
                    {
                        "label": "邛崃市",
                        "value": "510183",
                        "parent": "510100"
                    },
                    {
                        "label": "崇州市",
                        "value": "510184",
                        "parent": "510100"
                    },
                    {
                        "label": "简阳市",
                        "value": "510185",
                        "parent": "510100"
                    }
                ]
            },
            {
                "value": "510300",
                "label": "自贡市",
                "parent": "510000",
                "children": [
                    {
                        "label": "自流井区",
                        "value": "510302",
                        "parent": "510300"
                    },
                    {
                        "label": "贡井区",
                        "value": "510303",
                        "parent": "510300"
                    },
                    {
                        "label": "大安区",
                        "value": "510304",
                        "parent": "510300"
                    },
                    {
                        "label": "沿滩区",
                        "value": "510311",
                        "parent": "510300"
                    },
                    {
                        "label": "荣县",
                        "value": "510321",
                        "parent": "510300"
                    },
                    {
                        "label": "富顺县",
                        "value": "510322",
                        "parent": "510300"
                    }
                ]
            },
            {
                "value": "510400",
                "label": "攀枝花市",
                "parent": "510000",
                "children": [
                    {
                        "label": "东区",
                        "value": "510402",
                        "parent": "510400"
                    },
                    {
                        "label": "西区",
                        "value": "510403",
                        "parent": "510400"
                    },
                    {
                        "label": "仁和区",
                        "value": "510411",
                        "parent": "510400"
                    },
                    {
                        "label": "米易县",
                        "value": "510421",
                        "parent": "510400"
                    },
                    {
                        "label": "盐边县",
                        "value": "510422",
                        "parent": "510400"
                    }
                ]
            },
            {
                "value": "510500",
                "label": "泸州市",
                "parent": "510000",
                "children": [
                    {
                        "label": "江阳区",
                        "value": "510502",
                        "parent": "510500"
                    },
                    {
                        "label": "纳溪区",
                        "value": "510503",
                        "parent": "510500"
                    },
                    {
                        "label": "龙马潭区",
                        "value": "510504",
                        "parent": "510500"
                    },
                    {
                        "label": "泸县",
                        "value": "510521",
                        "parent": "510500"
                    },
                    {
                        "label": "合江县",
                        "value": "510522",
                        "parent": "510500"
                    },
                    {
                        "label": "叙永县",
                        "value": "510524",
                        "parent": "510500"
                    },
                    {
                        "label": "古蔺县",
                        "value": "510525",
                        "parent": "510500"
                    }
                ]
            },
            {
                "value": "510600",
                "label": "德阳市",
                "parent": "510000",
                "children": [
                    {
                        "label": "旌阳区",
                        "value": "510603",
                        "parent": "510600"
                    },
                    {
                        "label": "罗江区",
                        "value": "510604",
                        "parent": "510600"
                    },
                    {
                        "label": "中江县",
                        "value": "510623",
                        "parent": "510600"
                    },
                    {
                        "label": "广汉市",
                        "value": "510681",
                        "parent": "510600"
                    },
                    {
                        "label": "什邡市",
                        "value": "510682",
                        "parent": "510600"
                    },
                    {
                        "label": "绵竹市",
                        "value": "510683",
                        "parent": "510600"
                    }
                ]
            },
            {
                "value": "510700",
                "label": "绵阳市",
                "parent": "510000",
                "children": [
                    {
                        "label": "涪城区",
                        "value": "510703",
                        "parent": "510700"
                    },
                    {
                        "label": "游仙区",
                        "value": "510704",
                        "parent": "510700"
                    },
                    {
                        "label": "安州区",
                        "value": "510705",
                        "parent": "510700"
                    },
                    {
                        "label": "三台县",
                        "value": "510722",
                        "parent": "510700"
                    },
                    {
                        "label": "盐亭县",
                        "value": "510723",
                        "parent": "510700"
                    },
                    {
                        "label": "梓潼县",
                        "value": "510725",
                        "parent": "510700"
                    },
                    {
                        "label": "北川羌族自治县",
                        "value": "510726",
                        "parent": "510700"
                    },
                    {
                        "label": "平武县",
                        "value": "510727",
                        "parent": "510700"
                    },
                    {
                        "label": "江油市",
                        "value": "510781",
                        "parent": "510700"
                    },
                    {
                        "label": "高新区",
                        "value": "510791",
                        "parent": "510700"
                    }
                ]
            },
            {
                "value": "510800",
                "label": "广元市",
                "parent": "510000",
                "children": [
                    {
                        "label": "利州区",
                        "value": "510802",
                        "parent": "510800"
                    },
                    {
                        "label": "昭化区",
                        "value": "510811",
                        "parent": "510800"
                    },
                    {
                        "label": "朝天区",
                        "value": "510812",
                        "parent": "510800"
                    },
                    {
                        "label": "旺苍县",
                        "value": "510821",
                        "parent": "510800"
                    },
                    {
                        "label": "青川县",
                        "value": "510822",
                        "parent": "510800"
                    },
                    {
                        "label": "剑阁县",
                        "value": "510823",
                        "parent": "510800"
                    },
                    {
                        "label": "苍溪县",
                        "value": "510824",
                        "parent": "510800"
                    }
                ]
            },
            {
                "value": "510900",
                "label": "遂宁市",
                "parent": "510000",
                "children": [
                    {
                        "label": "船山区",
                        "value": "510903",
                        "parent": "510900"
                    },
                    {
                        "label": "安居区",
                        "value": "510904",
                        "parent": "510900"
                    },
                    {
                        "label": "蓬溪县",
                        "value": "510921",
                        "parent": "510900"
                    },
                    {
                        "label": "大英县",
                        "value": "510923",
                        "parent": "510900"
                    },
                    {
                        "label": "射洪市",
                        "value": "510981",
                        "parent": "510900"
                    }
                ]
            },
            {
                "value": "511000",
                "label": "内江市",
                "parent": "510000",
                "children": [
                    {
                        "label": "市中区",
                        "value": "511002",
                        "parent": "511000"
                    },
                    {
                        "label": "东兴区",
                        "value": "511011",
                        "parent": "511000"
                    },
                    {
                        "label": "威远县",
                        "value": "511024",
                        "parent": "511000"
                    },
                    {
                        "label": "资中县",
                        "value": "511025",
                        "parent": "511000"
                    },
                    {
                        "label": "隆昌市",
                        "value": "511083",
                        "parent": "511000"
                    }
                ]
            },
            {
                "value": "511100",
                "label": "乐山市",
                "parent": "510000",
                "children": [
                    {
                        "label": "市中区",
                        "value": "511102",
                        "parent": "511100"
                    },
                    {
                        "label": "沙湾区",
                        "value": "511111",
                        "parent": "511100"
                    },
                    {
                        "label": "五通桥区",
                        "value": "511112",
                        "parent": "511100"
                    },
                    {
                        "label": "金口河区",
                        "value": "511113",
                        "parent": "511100"
                    },
                    {
                        "label": "犍为县",
                        "value": "511123",
                        "parent": "511100"
                    },
                    {
                        "label": "井研县",
                        "value": "511124",
                        "parent": "511100"
                    },
                    {
                        "label": "夹江县",
                        "value": "511126",
                        "parent": "511100"
                    },
                    {
                        "label": "沐川县",
                        "value": "511129",
                        "parent": "511100"
                    },
                    {
                        "label": "峨边彝族自治县",
                        "value": "511132",
                        "parent": "511100"
                    },
                    {
                        "label": "马边彝族自治县",
                        "value": "511133",
                        "parent": "511100"
                    },
                    {
                        "label": "峨眉山市",
                        "value": "511181",
                        "parent": "511100"
                    }
                ]
            },
            {
                "value": "511300",
                "label": "南充市",
                "parent": "510000",
                "children": [
                    {
                        "label": "顺庆区",
                        "value": "511302",
                        "parent": "511300"
                    },
                    {
                        "label": "高坪区",
                        "value": "511303",
                        "parent": "511300"
                    },
                    {
                        "label": "嘉陵区",
                        "value": "511304",
                        "parent": "511300"
                    },
                    {
                        "label": "南部县",
                        "value": "511321",
                        "parent": "511300"
                    },
                    {
                        "label": "营山县",
                        "value": "511322",
                        "parent": "511300"
                    },
                    {
                        "label": "蓬安县",
                        "value": "511323",
                        "parent": "511300"
                    },
                    {
                        "label": "仪陇县",
                        "value": "511324",
                        "parent": "511300"
                    },
                    {
                        "label": "西充县",
                        "value": "511325",
                        "parent": "511300"
                    },
                    {
                        "label": "阆中市",
                        "value": "511381",
                        "parent": "511300"
                    }
                ]
            },
            {
                "value": "511400",
                "label": "眉山市",
                "parent": "510000",
                "children": [
                    {
                        "label": "东坡区",
                        "value": "511402",
                        "parent": "511400"
                    },
                    {
                        "label": "彭山区",
                        "value": "511403",
                        "parent": "511400"
                    },
                    {
                        "label": "仁寿县",
                        "value": "511421",
                        "parent": "511400"
                    },
                    {
                        "label": "洪雅县",
                        "value": "511423",
                        "parent": "511400"
                    },
                    {
                        "label": "丹棱县",
                        "value": "511424",
                        "parent": "511400"
                    },
                    {
                        "label": "青神县",
                        "value": "511425",
                        "parent": "511400"
                    }
                ]
            },
            {
                "value": "511500",
                "label": "宜宾市",
                "parent": "510000",
                "children": [
                    {
                        "label": "翠屏区",
                        "value": "511502",
                        "parent": "511500"
                    },
                    {
                        "label": "南溪区",
                        "value": "511503",
                        "parent": "511500"
                    },
                    {
                        "label": "叙州区",
                        "value": "511504",
                        "parent": "511500"
                    },
                    {
                        "label": "江安县",
                        "value": "511523",
                        "parent": "511500"
                    },
                    {
                        "label": "长宁县",
                        "value": "511524",
                        "parent": "511500"
                    },
                    {
                        "label": "高县",
                        "value": "511525",
                        "parent": "511500"
                    },
                    {
                        "label": "珙县",
                        "value": "511526",
                        "parent": "511500"
                    },
                    {
                        "label": "筠连县",
                        "value": "511527",
                        "parent": "511500"
                    },
                    {
                        "label": "兴文县",
                        "value": "511528",
                        "parent": "511500"
                    },
                    {
                        "label": "屏山县",
                        "value": "511529",
                        "parent": "511500"
                    }
                ]
            },
            {
                "value": "511600",
                "label": "广安市",
                "parent": "510000",
                "children": [
                    {
                        "label": "广安区",
                        "value": "511602",
                        "parent": "511600"
                    },
                    {
                        "label": "前锋区",
                        "value": "511603",
                        "parent": "511600"
                    },
                    {
                        "label": "岳池县",
                        "value": "511621",
                        "parent": "511600"
                    },
                    {
                        "label": "武胜县",
                        "value": "511622",
                        "parent": "511600"
                    },
                    {
                        "label": "邻水县",
                        "value": "511623",
                        "parent": "511600"
                    },
                    {
                        "label": "华蓥市",
                        "value": "511681",
                        "parent": "511600"
                    }
                ]
            },
            {
                "value": "511700",
                "label": "达州市",
                "parent": "510000",
                "children": [
                    {
                        "label": "通川区",
                        "value": "511702",
                        "parent": "511700"
                    },
                    {
                        "label": "达川区",
                        "value": "511703",
                        "parent": "511700"
                    },
                    {
                        "label": "宣汉县",
                        "value": "511722",
                        "parent": "511700"
                    },
                    {
                        "label": "开江县",
                        "value": "511723",
                        "parent": "511700"
                    },
                    {
                        "label": "大竹县",
                        "value": "511724",
                        "parent": "511700"
                    },
                    {
                        "label": "渠县",
                        "value": "511725",
                        "parent": "511700"
                    },
                    {
                        "label": "万源市",
                        "value": "511781",
                        "parent": "511700"
                    }
                ]
            },
            {
                "value": "511800",
                "label": "雅安市",
                "parent": "510000",
                "children": [
                    {
                        "label": "雨城区",
                        "value": "511802",
                        "parent": "511800"
                    },
                    {
                        "label": "名山区",
                        "value": "511803",
                        "parent": "511800"
                    },
                    {
                        "label": "荥经县",
                        "value": "511822",
                        "parent": "511800"
                    },
                    {
                        "label": "汉源县",
                        "value": "511823",
                        "parent": "511800"
                    },
                    {
                        "label": "石棉县",
                        "value": "511824",
                        "parent": "511800"
                    },
                    {
                        "label": "天全县",
                        "value": "511825",
                        "parent": "511800"
                    },
                    {
                        "label": "芦山县",
                        "value": "511826",
                        "parent": "511800"
                    },
                    {
                        "label": "宝兴县",
                        "value": "511827",
                        "parent": "511800"
                    }
                ]
            },
            {
                "value": "511900",
                "label": "巴中市",
                "parent": "510000",
                "children": [
                    {
                        "label": "巴州区",
                        "value": "511902",
                        "parent": "511900"
                    },
                    {
                        "label": "恩阳区",
                        "value": "511903",
                        "parent": "511900"
                    },
                    {
                        "label": "通江县",
                        "value": "511921",
                        "parent": "511900"
                    },
                    {
                        "label": "南江县",
                        "value": "511922",
                        "parent": "511900"
                    },
                    {
                        "label": "平昌县",
                        "value": "511923",
                        "parent": "511900"
                    },
                    {
                        "label": "巴中经济开发区",
                        "value": "511971",
                        "parent": "511900"
                    }
                ]
            },
            {
                "value": "512000",
                "label": "资阳市",
                "parent": "510000",
                "children": [
                    {
                        "label": "雁江区",
                        "value": "512002",
                        "parent": "512000"
                    },
                    {
                        "label": "安岳县",
                        "value": "512021",
                        "parent": "512000"
                    },
                    {
                        "label": "乐至县",
                        "value": "512022",
                        "parent": "512000"
                    }
                ]
            },
            {
                "value": "513200",
                "label": "阿坝藏族羌族自治州",
                "parent": "510000",
                "children": [
                    {
                        "label": "马尔康市",
                        "value": "513201",
                        "parent": "513200"
                    },
                    {
                        "label": "汶川县",
                        "value": "513221",
                        "parent": "513200"
                    },
                    {
                        "label": "理县",
                        "value": "513222",
                        "parent": "513200"
                    },
                    {
                        "label": "茂县",
                        "value": "513223",
                        "parent": "513200"
                    },
                    {
                        "label": "松潘县",
                        "value": "513224",
                        "parent": "513200"
                    },
                    {
                        "label": "九寨沟县",
                        "value": "513225",
                        "parent": "513200"
                    },
                    {
                        "label": "金川县",
                        "value": "513226",
                        "parent": "513200"
                    },
                    {
                        "label": "小金县",
                        "value": "513227",
                        "parent": "513200"
                    },
                    {
                        "label": "黑水县",
                        "value": "513228",
                        "parent": "513200"
                    },
                    {
                        "label": "壤塘县",
                        "value": "513230",
                        "parent": "513200"
                    },
                    {
                        "label": "阿坝县",
                        "value": "513231",
                        "parent": "513200"
                    },
                    {
                        "label": "若尔盖县",
                        "value": "513232",
                        "parent": "513200"
                    },
                    {
                        "label": "红原县",
                        "value": "513233",
                        "parent": "513200"
                    }
                ]
            },
            {
                "value": "513300",
                "label": "甘孜藏族自治州",
                "parent": "510000",
                "children": [
                    {
                        "label": "康定市",
                        "value": "513301",
                        "parent": "513300"
                    },
                    {
                        "label": "泸定县",
                        "value": "513322",
                        "parent": "513300"
                    },
                    {
                        "label": "丹巴县",
                        "value": "513323",
                        "parent": "513300"
                    },
                    {
                        "label": "九龙县",
                        "value": "513324",
                        "parent": "513300"
                    },
                    {
                        "label": "雅江县",
                        "value": "513325",
                        "parent": "513300"
                    },
                    {
                        "label": "道孚县",
                        "value": "513326",
                        "parent": "513300"
                    },
                    {
                        "label": "炉霍县",
                        "value": "513327",
                        "parent": "513300"
                    },
                    {
                        "label": "甘孜县",
                        "value": "513328",
                        "parent": "513300"
                    },
                    {
                        "label": "新龙县",
                        "value": "513329",
                        "parent": "513300"
                    },
                    {
                        "label": "德格县",
                        "value": "513330",
                        "parent": "513300"
                    },
                    {
                        "label": "白玉县",
                        "value": "513331",
                        "parent": "513300"
                    },
                    {
                        "label": "石渠县",
                        "value": "513332",
                        "parent": "513300"
                    },
                    {
                        "label": "色达县",
                        "value": "513333",
                        "parent": "513300"
                    },
                    {
                        "label": "理塘县",
                        "value": "513334",
                        "parent": "513300"
                    },
                    {
                        "label": "巴塘县",
                        "value": "513335",
                        "parent": "513300"
                    },
                    {
                        "label": "乡城县",
                        "value": "513336",
                        "parent": "513300"
                    },
                    {
                        "label": "稻城县",
                        "value": "513337",
                        "parent": "513300"
                    },
                    {
                        "label": "得荣县",
                        "value": "513338",
                        "parent": "513300"
                    }
                ]
            },
            {
                "value": "513400",
                "label": "凉山彝族自治州",
                "parent": "510000",
                "children": [
                    {
                        "label": "西昌市",
                        "value": "513401",
                        "parent": "513400"
                    },
                    {
                        "label": "木里藏族自治县",
                        "value": "513422",
                        "parent": "513400"
                    },
                    {
                        "label": "盐源县",
                        "value": "513423",
                        "parent": "513400"
                    },
                    {
                        "label": "德昌县",
                        "value": "513424",
                        "parent": "513400"
                    },
                    {
                        "label": "会理县",
                        "value": "513425",
                        "parent": "513400"
                    },
                    {
                        "label": "会东县",
                        "value": "513426",
                        "parent": "513400"
                    },
                    {
                        "label": "宁南县",
                        "value": "513427",
                        "parent": "513400"
                    },
                    {
                        "label": "普格县",
                        "value": "513428",
                        "parent": "513400"
                    },
                    {
                        "label": "布拖县",
                        "value": "513429",
                        "parent": "513400"
                    },
                    {
                        "label": "金阳县",
                        "value": "513430",
                        "parent": "513400"
                    },
                    {
                        "label": "昭觉县",
                        "value": "513431",
                        "parent": "513400"
                    },
                    {
                        "label": "喜德县",
                        "value": "513432",
                        "parent": "513400"
                    },
                    {
                        "label": "冕宁县",
                        "value": "513433",
                        "parent": "513400"
                    },
                    {
                        "label": "越西县",
                        "value": "513434",
                        "parent": "513400"
                    },
                    {
                        "label": "甘洛县",
                        "value": "513435",
                        "parent": "513400"
                    },
                    {
                        "label": "美姑县",
                        "value": "513436",
                        "parent": "513400"
                    },
                    {
                        "label": "雷波县",
                        "value": "513437",
                        "parent": "513400"
                    }
                ]
            }
        ]
    },
    {
        "value": "520000",
        "label": "贵州省",
        "children": [
            {
                "value": "520100",
                "label": "贵阳市",
                "parent": "520000",
                "children": [
                    {
                        "label": "南明区",
                        "value": "520102",
                        "parent": "520100"
                    },
                    {
                        "label": "云岩区",
                        "value": "520103",
                        "parent": "520100"
                    },
                    {
                        "label": "花溪区",
                        "value": "520111",
                        "parent": "520100"
                    },
                    {
                        "label": "乌当区",
                        "value": "520112",
                        "parent": "520100"
                    },
                    {
                        "label": "白云区",
                        "value": "520113",
                        "parent": "520100"
                    },
                    {
                        "label": "观山湖区",
                        "value": "520115",
                        "parent": "520100"
                    },
                    {
                        "label": "开阳县",
                        "value": "520121",
                        "parent": "520100"
                    },
                    {
                        "label": "息烽县",
                        "value": "520122",
                        "parent": "520100"
                    },
                    {
                        "label": "修文县",
                        "value": "520123",
                        "parent": "520100"
                    },
                    {
                        "label": "清镇市",
                        "value": "520181",
                        "parent": "520100"
                    }
                ]
            },
            {
                "value": "520200",
                "label": "六盘水市",
                "parent": "520000",
                "children": [
                    {
                        "label": "钟山区",
                        "value": "520201",
                        "parent": "520200"
                    },
                    {
                        "label": "六枝特区",
                        "value": "520203",
                        "parent": "520200"
                    },
                    {
                        "label": "水城县",
                        "value": "520221",
                        "parent": "520200"
                    },
                    {
                        "label": "盘州市",
                        "value": "520281",
                        "parent": "520200"
                    }
                ]
            },
            {
                "value": "520300",
                "label": "遵义市",
                "parent": "520000",
                "children": [
                    {
                        "label": "红花岗区",
                        "value": "520302",
                        "parent": "520300"
                    },
                    {
                        "label": "汇川区",
                        "value": "520303",
                        "parent": "520300"
                    },
                    {
                        "label": "播州区",
                        "value": "520304",
                        "parent": "520300"
                    },
                    {
                        "label": "桐梓县",
                        "value": "520322",
                        "parent": "520300"
                    },
                    {
                        "label": "绥阳县",
                        "value": "520323",
                        "parent": "520300"
                    },
                    {
                        "label": "正安县",
                        "value": "520324",
                        "parent": "520300"
                    },
                    {
                        "label": "道真仡佬族苗族自治县",
                        "value": "520325",
                        "parent": "520300"
                    },
                    {
                        "label": "务川仡佬族苗族自治县",
                        "value": "520326",
                        "parent": "520300"
                    },
                    {
                        "label": "凤冈县",
                        "value": "520327",
                        "parent": "520300"
                    },
                    {
                        "label": "湄潭县",
                        "value": "520328",
                        "parent": "520300"
                    },
                    {
                        "label": "余庆县",
                        "value": "520329",
                        "parent": "520300"
                    },
                    {
                        "label": "习水县",
                        "value": "520330",
                        "parent": "520300"
                    },
                    {
                        "label": "赤水市",
                        "value": "520381",
                        "parent": "520300"
                    },
                    {
                        "label": "仁怀市",
                        "value": "520382",
                        "parent": "520300"
                    }
                ]
            },
            {
                "value": "520400",
                "label": "安顺市",
                "parent": "520000",
                "children": [
                    {
                        "label": "西秀区",
                        "value": "520402",
                        "parent": "520400"
                    },
                    {
                        "label": "平坝区",
                        "value": "520403",
                        "parent": "520400"
                    },
                    {
                        "label": "普定县",
                        "value": "520422",
                        "parent": "520400"
                    },
                    {
                        "label": "镇宁布依族苗族自治县",
                        "value": "520423",
                        "parent": "520400"
                    },
                    {
                        "label": "关岭布依族苗族自治县",
                        "value": "520424",
                        "parent": "520400"
                    },
                    {
                        "label": "紫云苗族布依族自治县",
                        "value": "520425",
                        "parent": "520400"
                    }
                ]
            },
            {
                "value": "522200",
                "label": "铜仁市",
                "parent": "520000",
                "children": []
            },
            {
                "value": "522300",
                "label": "黔西南布依族苗族自治州",
                "parent": "520000",
                "children": [
                    {
                        "label": "兴义市",
                        "value": "522301",
                        "parent": "522300"
                    },
                    {
                        "label": "兴仁市",
                        "value": "522302",
                        "parent": "522300"
                    },
                    {
                        "label": "普安县",
                        "value": "522323",
                        "parent": "522300"
                    },
                    {
                        "label": "晴隆县",
                        "value": "522324",
                        "parent": "522300"
                    },
                    {
                        "label": "贞丰县",
                        "value": "522325",
                        "parent": "522300"
                    },
                    {
                        "label": "望谟县",
                        "value": "522326",
                        "parent": "522300"
                    },
                    {
                        "label": "册亨县",
                        "value": "522327",
                        "parent": "522300"
                    },
                    {
                        "label": "安龙县",
                        "value": "522328",
                        "parent": "522300"
                    }
                ]
            },
            {
                "value": "522400",
                "label": "毕节市",
                "parent": "520000",
                "children": []
            },
            {
                "value": "522600",
                "label": "黔东南苗族侗族自治州",
                "parent": "520000",
                "children": [
                    {
                        "label": "凯里市",
                        "value": "522601",
                        "parent": "522600"
                    },
                    {
                        "label": "黄平县",
                        "value": "522622",
                        "parent": "522600"
                    },
                    {
                        "label": "施秉县",
                        "value": "522623",
                        "parent": "522600"
                    },
                    {
                        "label": "三穗县",
                        "value": "522624",
                        "parent": "522600"
                    },
                    {
                        "label": "镇远县",
                        "value": "522625",
                        "parent": "522600"
                    },
                    {
                        "label": "岑巩县",
                        "value": "522626",
                        "parent": "522600"
                    },
                    {
                        "label": "天柱县",
                        "value": "522627",
                        "parent": "522600"
                    },
                    {
                        "label": "锦屏县",
                        "value": "522628",
                        "parent": "522600"
                    },
                    {
                        "label": "剑河县",
                        "value": "522629",
                        "parent": "522600"
                    },
                    {
                        "label": "台江县",
                        "value": "522630",
                        "parent": "522600"
                    },
                    {
                        "label": "黎平县",
                        "value": "522631",
                        "parent": "522600"
                    },
                    {
                        "label": "榕江县",
                        "value": "522632",
                        "parent": "522600"
                    },
                    {
                        "label": "从江县",
                        "value": "522633",
                        "parent": "522600"
                    },
                    {
                        "label": "雷山县",
                        "value": "522634",
                        "parent": "522600"
                    },
                    {
                        "label": "麻江县",
                        "value": "522635",
                        "parent": "522600"
                    },
                    {
                        "label": "丹寨县",
                        "value": "522636",
                        "parent": "522600"
                    }
                ]
            },
            {
                "value": "522700",
                "label": "黔南布依族苗族自治州",
                "parent": "520000",
                "children": [
                    {
                        "label": "都匀市",
                        "value": "522701",
                        "parent": "522700"
                    },
                    {
                        "label": "福泉市",
                        "value": "522702",
                        "parent": "522700"
                    },
                    {
                        "label": "荔波县",
                        "value": "522722",
                        "parent": "522700"
                    },
                    {
                        "label": "贵定县",
                        "value": "522723",
                        "parent": "522700"
                    },
                    {
                        "label": "瓮安县",
                        "value": "522725",
                        "parent": "522700"
                    },
                    {
                        "label": "独山县",
                        "value": "522726",
                        "parent": "522700"
                    },
                    {
                        "label": "平塘县",
                        "value": "522727",
                        "parent": "522700"
                    },
                    {
                        "label": "罗甸县",
                        "value": "522728",
                        "parent": "522700"
                    },
                    {
                        "label": "长顺县",
                        "value": "522729",
                        "parent": "522700"
                    },
                    {
                        "label": "龙里县",
                        "value": "522730",
                        "parent": "522700"
                    },
                    {
                        "label": "惠水县",
                        "value": "522731",
                        "parent": "522700"
                    },
                    {
                        "label": "三都水族自治县",
                        "value": "522732",
                        "parent": "522700"
                    }
                ]
            }
        ]
    },
    {
        "value": "530000",
        "label": "云南省",
        "children": [
            {
                "value": "530100",
                "label": "昆明市",
                "parent": "530000",
                "children": [
                    {
                        "label": "五华区",
                        "value": "530102",
                        "parent": "530100"
                    },
                    {
                        "label": "盘龙区",
                        "value": "530103",
                        "parent": "530100"
                    },
                    {
                        "label": "官渡区",
                        "value": "530111",
                        "parent": "530100"
                    },
                    {
                        "label": "西山区",
                        "value": "530112",
                        "parent": "530100"
                    },
                    {
                        "label": "东川区",
                        "value": "530113",
                        "parent": "530100"
                    },
                    {
                        "label": "呈贡区",
                        "value": "530114",
                        "parent": "530100"
                    },
                    {
                        "label": "晋宁区",
                        "value": "530115",
                        "parent": "530100"
                    },
                    {
                        "label": "富民县",
                        "value": "530124",
                        "parent": "530100"
                    },
                    {
                        "label": "宜良县",
                        "value": "530125",
                        "parent": "530100"
                    },
                    {
                        "label": "石林彝族自治县",
                        "value": "530126",
                        "parent": "530100"
                    },
                    {
                        "label": "嵩明县",
                        "value": "530127",
                        "parent": "530100"
                    },
                    {
                        "label": "禄劝彝族苗族自治县",
                        "value": "530128",
                        "parent": "530100"
                    },
                    {
                        "label": "寻甸回族彝族自治县",
                        "value": "530129",
                        "parent": "530100"
                    },
                    {
                        "label": "安宁市",
                        "value": "530181",
                        "parent": "530100"
                    }
                ]
            },
            {
                "value": "530300",
                "label": "曲靖市",
                "parent": "530000",
                "children": [
                    {
                        "label": "麒麟区",
                        "value": "530302",
                        "parent": "530300"
                    },
                    {
                        "label": "沾益区",
                        "value": "530303",
                        "parent": "530300"
                    },
                    {
                        "label": "马龙区",
                        "value": "530304",
                        "parent": "530300"
                    },
                    {
                        "label": "陆良县",
                        "value": "530322",
                        "parent": "530300"
                    },
                    {
                        "label": "师宗县",
                        "value": "530323",
                        "parent": "530300"
                    },
                    {
                        "label": "罗平县",
                        "value": "530324",
                        "parent": "530300"
                    },
                    {
                        "label": "富源县",
                        "value": "530325",
                        "parent": "530300"
                    },
                    {
                        "label": "会泽县",
                        "value": "530326",
                        "parent": "530300"
                    },
                    {
                        "label": "宣威市",
                        "value": "530381",
                        "parent": "530300"
                    }
                ]
            },
            {
                "value": "530400",
                "label": "玉溪市",
                "parent": "530000",
                "children": [
                    {
                        "label": "红塔区",
                        "value": "530402",
                        "parent": "530400"
                    },
                    {
                        "label": "江川区",
                        "value": "530403",
                        "parent": "530400"
                    },
                    {
                        "label": "通海县",
                        "value": "530423",
                        "parent": "530400"
                    },
                    {
                        "label": "华宁县",
                        "value": "530424",
                        "parent": "530400"
                    },
                    {
                        "label": "易门县",
                        "value": "530425",
                        "parent": "530400"
                    },
                    {
                        "label": "峨山彝族自治县",
                        "value": "530426",
                        "parent": "530400"
                    },
                    {
                        "label": "新平彝族傣族自治县",
                        "value": "530427",
                        "parent": "530400"
                    },
                    {
                        "label": "元江哈尼族彝族傣族自治县",
                        "value": "530428",
                        "parent": "530400"
                    },
                    {
                        "label": "澄江市",
                        "value": "530481",
                        "parent": "530400"
                    }
                ]
            },
            {
                "value": "530500",
                "label": "保山市",
                "parent": "530000",
                "children": [
                    {
                        "label": "隆阳区",
                        "value": "530502",
                        "parent": "530500"
                    },
                    {
                        "label": "施甸县",
                        "value": "530521",
                        "parent": "530500"
                    },
                    {
                        "label": "龙陵县",
                        "value": "530523",
                        "parent": "530500"
                    },
                    {
                        "label": "昌宁县",
                        "value": "530524",
                        "parent": "530500"
                    },
                    {
                        "label": "腾冲市",
                        "value": "530581",
                        "parent": "530500"
                    }
                ]
            },
            {
                "value": "530600",
                "label": "昭通市",
                "parent": "530000",
                "children": [
                    {
                        "label": "昭阳区",
                        "value": "530602",
                        "parent": "530600"
                    },
                    {
                        "label": "鲁甸县",
                        "value": "530621",
                        "parent": "530600"
                    },
                    {
                        "label": "巧家县",
                        "value": "530622",
                        "parent": "530600"
                    },
                    {
                        "label": "盐津县",
                        "value": "530623",
                        "parent": "530600"
                    },
                    {
                        "label": "大关县",
                        "value": "530624",
                        "parent": "530600"
                    },
                    {
                        "label": "永善县",
                        "value": "530625",
                        "parent": "530600"
                    },
                    {
                        "label": "绥江县",
                        "value": "530626",
                        "parent": "530600"
                    },
                    {
                        "label": "镇雄县",
                        "value": "530627",
                        "parent": "530600"
                    },
                    {
                        "label": "彝良县",
                        "value": "530628",
                        "parent": "530600"
                    },
                    {
                        "label": "威信县",
                        "value": "530629",
                        "parent": "530600"
                    },
                    {
                        "label": "水富市",
                        "value": "530681",
                        "parent": "530600"
                    }
                ]
            },
            {
                "value": "530700",
                "label": "丽江市",
                "parent": "530000",
                "children": [
                    {
                        "label": "古城区",
                        "value": "530702",
                        "parent": "530700"
                    },
                    {
                        "label": "玉龙纳西族自治县",
                        "value": "530721",
                        "parent": "530700"
                    },
                    {
                        "label": "永胜县",
                        "value": "530722",
                        "parent": "530700"
                    },
                    {
                        "label": "华坪县",
                        "value": "530723",
                        "parent": "530700"
                    },
                    {
                        "label": "宁蒗彝族自治县",
                        "value": "530724",
                        "parent": "530700"
                    }
                ]
            },
            {
                "value": "530800",
                "label": "普洱市",
                "parent": "530000",
                "children": [
                    {
                        "label": "思茅区",
                        "value": "530802",
                        "parent": "530800"
                    },
                    {
                        "label": "宁洱哈尼族彝族自治县",
                        "value": "530821",
                        "parent": "530800"
                    },
                    {
                        "label": "墨江哈尼族自治县",
                        "value": "530822",
                        "parent": "530800"
                    },
                    {
                        "label": "景东彝族自治县",
                        "value": "530823",
                        "parent": "530800"
                    },
                    {
                        "label": "景谷傣族彝族自治县",
                        "value": "530824",
                        "parent": "530800"
                    },
                    {
                        "label": "镇沅彝族哈尼族拉祜族自治县",
                        "value": "530825",
                        "parent": "530800"
                    },
                    {
                        "label": "江城哈尼族彝族自治县",
                        "value": "530826",
                        "parent": "530800"
                    },
                    {
                        "label": "孟连傣族拉祜族佤族自治县",
                        "value": "530827",
                        "parent": "530800"
                    },
                    {
                        "label": "澜沧拉祜族自治县",
                        "value": "530828",
                        "parent": "530800"
                    },
                    {
                        "label": "西盟佤族自治县",
                        "value": "530829",
                        "parent": "530800"
                    }
                ]
            },
            {
                "value": "530900",
                "label": "临沧市",
                "parent": "530000",
                "children": [
                    {
                        "label": "临翔区",
                        "value": "530902",
                        "parent": "530900"
                    },
                    {
                        "label": "凤庆县",
                        "value": "530921",
                        "parent": "530900"
                    },
                    {
                        "label": "云县",
                        "value": "530922",
                        "parent": "530900"
                    },
                    {
                        "label": "永德县",
                        "value": "530923",
                        "parent": "530900"
                    },
                    {
                        "label": "镇康县",
                        "value": "530924",
                        "parent": "530900"
                    },
                    {
                        "label": "双江拉祜族佤族布朗族傣族自治县",
                        "value": "530925",
                        "parent": "530900"
                    },
                    {
                        "label": "耿马傣族佤族自治县",
                        "value": "530926",
                        "parent": "530900"
                    },
                    {
                        "label": "沧源佤族自治县",
                        "value": "530927",
                        "parent": "530900"
                    }
                ]
            },
            {
                "value": "532300",
                "label": "楚雄彝族自治州",
                "parent": "530000",
                "children": [
                    {
                        "label": "楚雄市",
                        "value": "532301",
                        "parent": "532300"
                    },
                    {
                        "label": "双柏县",
                        "value": "532322",
                        "parent": "532300"
                    },
                    {
                        "label": "牟定县",
                        "value": "532323",
                        "parent": "532300"
                    },
                    {
                        "label": "南华县",
                        "value": "532324",
                        "parent": "532300"
                    },
                    {
                        "label": "姚安县",
                        "value": "532325",
                        "parent": "532300"
                    },
                    {
                        "label": "大姚县",
                        "value": "532326",
                        "parent": "532300"
                    },
                    {
                        "label": "永仁县",
                        "value": "532327",
                        "parent": "532300"
                    },
                    {
                        "label": "元谋县",
                        "value": "532328",
                        "parent": "532300"
                    },
                    {
                        "label": "武定县",
                        "value": "532329",
                        "parent": "532300"
                    },
                    {
                        "label": "禄丰县",
                        "value": "532331",
                        "parent": "532300"
                    }
                ]
            },
            {
                "value": "532500",
                "label": "红河哈尼族彝族自治州",
                "parent": "530000",
                "children": [
                    {
                        "label": "个旧市",
                        "value": "532501",
                        "parent": "532500"
                    },
                    {
                        "label": "开远市",
                        "value": "532502",
                        "parent": "532500"
                    },
                    {
                        "label": "蒙自市",
                        "value": "532503",
                        "parent": "532500"
                    },
                    {
                        "label": "弥勒市",
                        "value": "532504",
                        "parent": "532500"
                    },
                    {
                        "label": "屏边苗族自治县",
                        "value": "532523",
                        "parent": "532500"
                    },
                    {
                        "label": "建水县",
                        "value": "532524",
                        "parent": "532500"
                    },
                    {
                        "label": "石屏县",
                        "value": "532525",
                        "parent": "532500"
                    },
                    {
                        "label": "泸西县",
                        "value": "532527",
                        "parent": "532500"
                    },
                    {
                        "label": "元阳县",
                        "value": "532528",
                        "parent": "532500"
                    },
                    {
                        "label": "红河县",
                        "value": "532529",
                        "parent": "532500"
                    },
                    {
                        "label": "金平苗族瑶族傣族自治县",
                        "value": "532530",
                        "parent": "532500"
                    },
                    {
                        "label": "绿春县",
                        "value": "532531",
                        "parent": "532500"
                    },
                    {
                        "label": "河口瑶族自治县",
                        "value": "532532",
                        "parent": "532500"
                    }
                ]
            },
            {
                "value": "532600",
                "label": "文山壮族苗族自治州",
                "parent": "530000",
                "children": [
                    {
                        "label": "文山市",
                        "value": "532601",
                        "parent": "532600"
                    },
                    {
                        "label": "砚山县",
                        "value": "532622",
                        "parent": "532600"
                    },
                    {
                        "label": "西畴县",
                        "value": "532623",
                        "parent": "532600"
                    },
                    {
                        "label": "麻栗坡县",
                        "value": "532624",
                        "parent": "532600"
                    },
                    {
                        "label": "马关县",
                        "value": "532625",
                        "parent": "532600"
                    },
                    {
                        "label": "丘北县",
                        "value": "532626",
                        "parent": "532600"
                    },
                    {
                        "label": "广南县",
                        "value": "532627",
                        "parent": "532600"
                    },
                    {
                        "label": "富宁县",
                        "value": "532628",
                        "parent": "532600"
                    }
                ]
            },
            {
                "value": "532800",
                "label": "西双版纳傣族自治州",
                "parent": "530000",
                "children": [
                    {
                        "label": "景洪市",
                        "value": "532801",
                        "parent": "532800"
                    },
                    {
                        "label": "勐海县",
                        "value": "532822",
                        "parent": "532800"
                    },
                    {
                        "label": "勐腊县",
                        "value": "532823",
                        "parent": "532800"
                    }
                ]
            },
            {
                "value": "532900",
                "label": "大理白族自治州",
                "parent": "530000",
                "children": [
                    {
                        "label": "大理市",
                        "value": "532901",
                        "parent": "532900"
                    },
                    {
                        "label": "漾濞彝族自治县",
                        "value": "532922",
                        "parent": "532900"
                    },
                    {
                        "label": "祥云县",
                        "value": "532923",
                        "parent": "532900"
                    },
                    {
                        "label": "宾川县",
                        "value": "532924",
                        "parent": "532900"
                    },
                    {
                        "label": "弥渡县",
                        "value": "532925",
                        "parent": "532900"
                    },
                    {
                        "label": "南涧彝族自治县",
                        "value": "532926",
                        "parent": "532900"
                    },
                    {
                        "label": "巍山彝族回族自治县",
                        "value": "532927",
                        "parent": "532900"
                    },
                    {
                        "label": "永平县",
                        "value": "532928",
                        "parent": "532900"
                    },
                    {
                        "label": "云龙县",
                        "value": "532929",
                        "parent": "532900"
                    },
                    {
                        "label": "洱源县",
                        "value": "532930",
                        "parent": "532900"
                    },
                    {
                        "label": "剑川县",
                        "value": "532931",
                        "parent": "532900"
                    },
                    {
                        "label": "鹤庆县",
                        "value": "532932",
                        "parent": "532900"
                    }
                ]
            },
            {
                "value": "533100",
                "label": "德宏傣族景颇族自治州",
                "parent": "530000",
                "children": [
                    {
                        "label": "瑞丽市",
                        "value": "533102",
                        "parent": "533100"
                    },
                    {
                        "label": "芒市",
                        "value": "533103",
                        "parent": "533100"
                    },
                    {
                        "label": "梁河县",
                        "value": "533122",
                        "parent": "533100"
                    },
                    {
                        "label": "盈江县",
                        "value": "533123",
                        "parent": "533100"
                    },
                    {
                        "label": "陇川县",
                        "value": "533124",
                        "parent": "533100"
                    }
                ]
            },
            {
                "value": "533300",
                "label": "怒江傈僳族自治州",
                "parent": "530000",
                "children": [
                    {
                        "label": "泸水市",
                        "value": "533301",
                        "parent": "533300"
                    },
                    {
                        "label": "福贡县",
                        "value": "533323",
                        "parent": "533300"
                    },
                    {
                        "label": "贡山独龙族怒族自治县",
                        "value": "533324",
                        "parent": "533300"
                    },
                    {
                        "label": "兰坪白族普米族自治县",
                        "value": "533325",
                        "parent": "533300"
                    }
                ]
            },
            {
                "value": "533400",
                "label": "迪庆藏族自治州",
                "parent": "530000",
                "children": [
                    {
                        "label": "香格里拉市",
                        "value": "533401",
                        "parent": "533400"
                    },
                    {
                        "label": "德钦县",
                        "value": "533422",
                        "parent": "533400"
                    },
                    {
                        "label": "维西傈僳族自治县",
                        "value": "533423",
                        "parent": "533400"
                    }
                ]
            }
        ]
    },
    {
        "value": "540000",
        "label": "西藏自治区",
        "children": [
            {
                "value": "540100",
                "label": "拉萨市",
                "parent": "540000",
                "children": [
                    {
                        "label": "城关区",
                        "value": "540102",
                        "parent": "540100"
                    },
                    {
                        "label": "堆龙德庆区",
                        "value": "540103",
                        "parent": "540100"
                    },
                    {
                        "label": "达孜区",
                        "value": "540104",
                        "parent": "540100"
                    },
                    {
                        "label": "林周县",
                        "value": "540121",
                        "parent": "540100"
                    },
                    {
                        "label": "当雄县",
                        "value": "540122",
                        "parent": "540100"
                    },
                    {
                        "label": "尼木县",
                        "value": "540123",
                        "parent": "540100"
                    },
                    {
                        "label": "曲水县",
                        "value": "540124",
                        "parent": "540100"
                    },
                    {
                        "label": "墨竹工卡县",
                        "value": "540127",
                        "parent": "540100"
                    }
                ]
            },
            {
                "value": "542100",
                "label": "昌都市",
                "parent": "540000",
                "children": []
            },
            {
                "value": "542200",
                "label": "山南地区",
                "parent": "540000",
                "children": []
            },
            {
                "value": "542300",
                "label": "日喀则市",
                "parent": "540000",
                "children": []
            },
            {
                "value": "542400",
                "label": "那曲地区",
                "parent": "540000",
                "children": []
            },
            {
                "value": "542500",
                "label": "阿里地区",
                "parent": "540000",
                "children": [
                    {
                        "label": "普兰县",
                        "value": "542521",
                        "parent": "542500"
                    },
                    {
                        "label": "札达县",
                        "value": "542522",
                        "parent": "542500"
                    },
                    {
                        "label": "噶尔县",
                        "value": "542523",
                        "parent": "542500"
                    },
                    {
                        "label": "日土县",
                        "value": "542524",
                        "parent": "542500"
                    },
                    {
                        "label": "革吉县",
                        "value": "542525",
                        "parent": "542500"
                    },
                    {
                        "label": "改则县",
                        "value": "542526",
                        "parent": "542500"
                    },
                    {
                        "label": "措勤县",
                        "value": "542527",
                        "parent": "542500"
                    }
                ]
            },
            {
                "value": "542600",
                "label": "林芝市",
                "parent": "540000",
                "children": []
            }
        ]
    },
    {
        "value": "610000",
        "label": "陕西省",
        "children": [
            {
                "value": "610100",
                "label": "西安市",
                "parent": "610000",
                "children": [
                    {
                        "label": "新城区",
                        "value": "610102",
                        "parent": "610100"
                    },
                    {
                        "label": "碑林区",
                        "value": "610103",
                        "parent": "610100"
                    },
                    {
                        "label": "莲湖区",
                        "value": "610104",
                        "parent": "610100"
                    },
                    {
                        "label": "灞桥区",
                        "value": "610111",
                        "parent": "610100"
                    },
                    {
                        "label": "未央区",
                        "value": "610112",
                        "parent": "610100"
                    },
                    {
                        "label": "雁塔区",
                        "value": "610113",
                        "parent": "610100"
                    },
                    {
                        "label": "阎良区",
                        "value": "610114",
                        "parent": "610100"
                    },
                    {
                        "label": "临潼区",
                        "value": "610115",
                        "parent": "610100"
                    },
                    {
                        "label": "长安区",
                        "value": "610116",
                        "parent": "610100"
                    },
                    {
                        "label": "高陵区",
                        "value": "610117",
                        "parent": "610100"
                    },
                    {
                        "label": "鄠邑区",
                        "value": "610118",
                        "parent": "610100"
                    },
                    {
                        "label": "蓝田县",
                        "value": "610122",
                        "parent": "610100"
                    },
                    {
                        "label": "周至县",
                        "value": "610124",
                        "parent": "610100"
                    }
                ]
            },
            {
                "value": "610200",
                "label": "铜川市",
                "parent": "610000",
                "children": [
                    {
                        "label": "王益区",
                        "value": "610202",
                        "parent": "610200"
                    },
                    {
                        "label": "印台区",
                        "value": "610203",
                        "parent": "610200"
                    },
                    {
                        "label": "耀州区",
                        "value": "610204",
                        "parent": "610200"
                    },
                    {
                        "label": "宜君县",
                        "value": "610222",
                        "parent": "610200"
                    }
                ]
            },
            {
                "value": "610300",
                "label": "宝鸡市",
                "parent": "610000",
                "children": [
                    {
                        "label": "渭滨区",
                        "value": "610302",
                        "parent": "610300"
                    },
                    {
                        "label": "金台区",
                        "value": "610303",
                        "parent": "610300"
                    },
                    {
                        "label": "陈仓区",
                        "value": "610304",
                        "parent": "610300"
                    },
                    {
                        "label": "凤翔县",
                        "value": "610322",
                        "parent": "610300"
                    },
                    {
                        "label": "岐山县",
                        "value": "610323",
                        "parent": "610300"
                    },
                    {
                        "label": "扶风县",
                        "value": "610324",
                        "parent": "610300"
                    },
                    {
                        "label": "眉县",
                        "value": "610326",
                        "parent": "610300"
                    },
                    {
                        "label": "陇县",
                        "value": "610327",
                        "parent": "610300"
                    },
                    {
                        "label": "千阳县",
                        "value": "610328",
                        "parent": "610300"
                    },
                    {
                        "label": "麟游县",
                        "value": "610329",
                        "parent": "610300"
                    },
                    {
                        "label": "凤县",
                        "value": "610330",
                        "parent": "610300"
                    },
                    {
                        "label": "太白县",
                        "value": "610331",
                        "parent": "610300"
                    }
                ]
            },
            {
                "value": "610400",
                "label": "咸阳市",
                "parent": "610000",
                "children": [
                    {
                        "label": "秦都区",
                        "value": "610402",
                        "parent": "610400"
                    },
                    {
                        "label": "杨陵区",
                        "value": "610403",
                        "parent": "610400"
                    },
                    {
                        "label": "渭城区",
                        "value": "610404",
                        "parent": "610400"
                    },
                    {
                        "label": "三原县",
                        "value": "610422",
                        "parent": "610400"
                    },
                    {
                        "label": "泾阳县",
                        "value": "610423",
                        "parent": "610400"
                    },
                    {
                        "label": "乾县",
                        "value": "610424",
                        "parent": "610400"
                    },
                    {
                        "label": "礼泉县",
                        "value": "610425",
                        "parent": "610400"
                    },
                    {
                        "label": "永寿县",
                        "value": "610426",
                        "parent": "610400"
                    },
                    {
                        "label": "长武县",
                        "value": "610428",
                        "parent": "610400"
                    },
                    {
                        "label": "旬邑县",
                        "value": "610429",
                        "parent": "610400"
                    },
                    {
                        "label": "淳化县",
                        "value": "610430",
                        "parent": "610400"
                    },
                    {
                        "label": "武功县",
                        "value": "610431",
                        "parent": "610400"
                    },
                    {
                        "label": "兴平市",
                        "value": "610481",
                        "parent": "610400"
                    },
                    {
                        "label": "彬州市",
                        "value": "610482",
                        "parent": "610400"
                    }
                ]
            },
            {
                "value": "610500",
                "label": "渭南市",
                "parent": "610000",
                "children": [
                    {
                        "label": "临渭区",
                        "value": "610502",
                        "parent": "610500"
                    },
                    {
                        "label": "华州区",
                        "value": "610503",
                        "parent": "610500"
                    },
                    {
                        "label": "潼关县",
                        "value": "610522",
                        "parent": "610500"
                    },
                    {
                        "label": "大荔县",
                        "value": "610523",
                        "parent": "610500"
                    },
                    {
                        "label": "合阳县",
                        "value": "610524",
                        "parent": "610500"
                    },
                    {
                        "label": "澄城县",
                        "value": "610525",
                        "parent": "610500"
                    },
                    {
                        "label": "蒲城县",
                        "value": "610526",
                        "parent": "610500"
                    },
                    {
                        "label": "白水县",
                        "value": "610527",
                        "parent": "610500"
                    },
                    {
                        "label": "富平县",
                        "value": "610528",
                        "parent": "610500"
                    },
                    {
                        "label": "韩城市",
                        "value": "610581",
                        "parent": "610500"
                    },
                    {
                        "label": "华阴市",
                        "value": "610582",
                        "parent": "610500"
                    }
                ]
            },
            {
                "value": "610600",
                "label": "延安市",
                "parent": "610000",
                "children": [
                    {
                        "label": "宝塔区",
                        "value": "610602",
                        "parent": "610600"
                    },
                    {
                        "label": "安塞区",
                        "value": "610603",
                        "parent": "610600"
                    },
                    {
                        "label": "延长县",
                        "value": "610621",
                        "parent": "610600"
                    },
                    {
                        "label": "延川县",
                        "value": "610622",
                        "parent": "610600"
                    },
                    {
                        "label": "志丹县",
                        "value": "610625",
                        "parent": "610600"
                    },
                    {
                        "label": "吴起县",
                        "value": "610626",
                        "parent": "610600"
                    },
                    {
                        "label": "甘泉县",
                        "value": "610627",
                        "parent": "610600"
                    },
                    {
                        "label": "富县",
                        "value": "610628",
                        "parent": "610600"
                    },
                    {
                        "label": "洛川县",
                        "value": "610629",
                        "parent": "610600"
                    },
                    {
                        "label": "宜川县",
                        "value": "610630",
                        "parent": "610600"
                    },
                    {
                        "label": "黄龙县",
                        "value": "610631",
                        "parent": "610600"
                    },
                    {
                        "label": "黄陵县",
                        "value": "610632",
                        "parent": "610600"
                    },
                    {
                        "label": "子长市",
                        "value": "610681",
                        "parent": "610600"
                    }
                ]
            },
            {
                "value": "610700",
                "label": "汉中市",
                "parent": "610000",
                "children": [
                    {
                        "label": "汉台区",
                        "value": "610702",
                        "parent": "610700"
                    },
                    {
                        "label": "南郑区",
                        "value": "610703",
                        "parent": "610700"
                    },
                    {
                        "label": "城固县",
                        "value": "610722",
                        "parent": "610700"
                    },
                    {
                        "label": "洋县",
                        "value": "610723",
                        "parent": "610700"
                    },
                    {
                        "label": "西乡县",
                        "value": "610724",
                        "parent": "610700"
                    },
                    {
                        "label": "勉县",
                        "value": "610725",
                        "parent": "610700"
                    },
                    {
                        "label": "宁强县",
                        "value": "610726",
                        "parent": "610700"
                    },
                    {
                        "label": "略阳县",
                        "value": "610727",
                        "parent": "610700"
                    },
                    {
                        "label": "镇巴县",
                        "value": "610728",
                        "parent": "610700"
                    },
                    {
                        "label": "留坝县",
                        "value": "610729",
                        "parent": "610700"
                    },
                    {
                        "label": "佛坪县",
                        "value": "610730",
                        "parent": "610700"
                    }
                ]
            },
            {
                "value": "610800",
                "label": "榆林市",
                "parent": "610000",
                "children": [
                    {
                        "label": "榆阳区",
                        "value": "610802",
                        "parent": "610800"
                    },
                    {
                        "label": "横山区",
                        "value": "610803",
                        "parent": "610800"
                    },
                    {
                        "label": "府谷县",
                        "value": "610822",
                        "parent": "610800"
                    },
                    {
                        "label": "靖边县",
                        "value": "610824",
                        "parent": "610800"
                    },
                    {
                        "label": "定边县",
                        "value": "610825",
                        "parent": "610800"
                    },
                    {
                        "label": "绥德县",
                        "value": "610826",
                        "parent": "610800"
                    },
                    {
                        "label": "米脂县",
                        "value": "610827",
                        "parent": "610800"
                    },
                    {
                        "label": "佳县",
                        "value": "610828",
                        "parent": "610800"
                    },
                    {
                        "label": "吴堡县",
                        "value": "610829",
                        "parent": "610800"
                    },
                    {
                        "label": "清涧县",
                        "value": "610830",
                        "parent": "610800"
                    },
                    {
                        "label": "子洲县",
                        "value": "610831",
                        "parent": "610800"
                    },
                    {
                        "label": "神木市",
                        "value": "610881",
                        "parent": "610800"
                    }
                ]
            },
            {
                "value": "610900",
                "label": "安康市",
                "parent": "610000",
                "children": [
                    {
                        "label": "汉滨区",
                        "value": "610902",
                        "parent": "610900"
                    },
                    {
                        "label": "汉阴县",
                        "value": "610921",
                        "parent": "610900"
                    },
                    {
                        "label": "石泉县",
                        "value": "610922",
                        "parent": "610900"
                    },
                    {
                        "label": "宁陕县",
                        "value": "610923",
                        "parent": "610900"
                    },
                    {
                        "label": "紫阳县",
                        "value": "610924",
                        "parent": "610900"
                    },
                    {
                        "label": "岚皋县",
                        "value": "610925",
                        "parent": "610900"
                    },
                    {
                        "label": "平利县",
                        "value": "610926",
                        "parent": "610900"
                    },
                    {
                        "label": "镇坪县",
                        "value": "610927",
                        "parent": "610900"
                    },
                    {
                        "label": "旬阳县",
                        "value": "610928",
                        "parent": "610900"
                    },
                    {
                        "label": "白河县",
                        "value": "610929",
                        "parent": "610900"
                    }
                ]
            },
            {
                "value": "611000",
                "label": "商洛市",
                "parent": "610000",
                "children": [
                    {
                        "label": "商州区",
                        "value": "611002",
                        "parent": "611000"
                    },
                    {
                        "label": "洛南县",
                        "value": "611021",
                        "parent": "611000"
                    },
                    {
                        "label": "丹凤县",
                        "value": "611022",
                        "parent": "611000"
                    },
                    {
                        "label": "商南县",
                        "value": "611023",
                        "parent": "611000"
                    },
                    {
                        "label": "山阳县",
                        "value": "611024",
                        "parent": "611000"
                    },
                    {
                        "label": "镇安县",
                        "value": "611025",
                        "parent": "611000"
                    },
                    {
                        "label": "柞水县",
                        "value": "611026",
                        "parent": "611000"
                    }
                ]
            }
        ]
    },
    {
        "value": "620000",
        "label": "甘肃省",
        "children": [
            {
                "value": "620100",
                "label": "兰州市",
                "parent": "620000",
                "children": [
                    {
                        "label": "城关区",
                        "value": "620102",
                        "parent": "620100"
                    },
                    {
                        "label": "七里河区",
                        "value": "620103",
                        "parent": "620100"
                    },
                    {
                        "label": "西固区",
                        "value": "620104",
                        "parent": "620100"
                    },
                    {
                        "label": "安宁区",
                        "value": "620105",
                        "parent": "620100"
                    },
                    {
                        "label": "红古区",
                        "value": "620111",
                        "parent": "620100"
                    },
                    {
                        "label": "永登县",
                        "value": "620121",
                        "parent": "620100"
                    },
                    {
                        "label": "皋兰县",
                        "value": "620122",
                        "parent": "620100"
                    },
                    {
                        "label": "榆中县",
                        "value": "620123",
                        "parent": "620100"
                    },
                    {
                        "label": "兰州新区",
                        "value": "620171",
                        "parent": "620100"
                    }
                ]
            },
            {
                "value": "620200",
                "label": "嘉峪关市",
                "parent": "620000",
                "children": [
                    {
                        "label": "市辖区",
                        "value": "620201",
                        "parent": "620200"
                    },
                    {
                        "label": "雄关区",
                        "value": "620290",
                        "parent": "620200"
                    },
                    {
                        "label": "长城区",
                        "value": "620291",
                        "parent": "620200"
                    },
                    {
                        "label": "镜铁区",
                        "value": "620292",
                        "parent": "620200"
                    },
                    {
                        "label": "新城镇",
                        "value": "620293",
                        "parent": "620200"
                    },
                    {
                        "label": "峪泉镇",
                        "value": "620294",
                        "parent": "620200"
                    },
                    {
                        "label": "文殊镇",
                        "value": "620295",
                        "parent": "620200"
                    }
                ]
            },
            {
                "value": "620300",
                "label": "金昌市",
                "parent": "620000",
                "children": [
                    {
                        "label": "金川区",
                        "value": "620302",
                        "parent": "620300"
                    },
                    {
                        "label": "永昌县",
                        "value": "620321",
                        "parent": "620300"
                    }
                ]
            },
            {
                "value": "620400",
                "label": "白银市",
                "parent": "620000",
                "children": [
                    {
                        "label": "白银区",
                        "value": "620402",
                        "parent": "620400"
                    },
                    {
                        "label": "平川区",
                        "value": "620403",
                        "parent": "620400"
                    },
                    {
                        "label": "靖远县",
                        "value": "620421",
                        "parent": "620400"
                    },
                    {
                        "label": "会宁县",
                        "value": "620422",
                        "parent": "620400"
                    },
                    {
                        "label": "景泰县",
                        "value": "620423",
                        "parent": "620400"
                    }
                ]
            },
            {
                "value": "620500",
                "label": "天水市",
                "parent": "620000",
                "children": [
                    {
                        "label": "秦州区",
                        "value": "620502",
                        "parent": "620500"
                    },
                    {
                        "label": "麦积区",
                        "value": "620503",
                        "parent": "620500"
                    },
                    {
                        "label": "清水县",
                        "value": "620521",
                        "parent": "620500"
                    },
                    {
                        "label": "秦安县",
                        "value": "620522",
                        "parent": "620500"
                    },
                    {
                        "label": "甘谷县",
                        "value": "620523",
                        "parent": "620500"
                    },
                    {
                        "label": "武山县",
                        "value": "620524",
                        "parent": "620500"
                    },
                    {
                        "label": "张家川回族自治县",
                        "value": "620525",
                        "parent": "620500"
                    }
                ]
            },
            {
                "value": "620600",
                "label": "武威市",
                "parent": "620000",
                "children": [
                    {
                        "label": "凉州区",
                        "value": "620602",
                        "parent": "620600"
                    },
                    {
                        "label": "民勤县",
                        "value": "620621",
                        "parent": "620600"
                    },
                    {
                        "label": "古浪县",
                        "value": "620622",
                        "parent": "620600"
                    },
                    {
                        "label": "天祝藏族自治县",
                        "value": "620623",
                        "parent": "620600"
                    }
                ]
            },
            {
                "value": "620700",
                "label": "张掖市",
                "parent": "620000",
                "children": [
                    {
                        "label": "甘州区",
                        "value": "620702",
                        "parent": "620700"
                    },
                    {
                        "label": "肃南裕固族自治县",
                        "value": "620721",
                        "parent": "620700"
                    },
                    {
                        "label": "民乐县",
                        "value": "620722",
                        "parent": "620700"
                    },
                    {
                        "label": "临泽县",
                        "value": "620723",
                        "parent": "620700"
                    },
                    {
                        "label": "高台县",
                        "value": "620724",
                        "parent": "620700"
                    },
                    {
                        "label": "山丹县",
                        "value": "620725",
                        "parent": "620700"
                    }
                ]
            },
            {
                "value": "620800",
                "label": "平凉市",
                "parent": "620000",
                "children": [
                    {
                        "label": "崆峒区",
                        "value": "620802",
                        "parent": "620800"
                    },
                    {
                        "label": "泾川县",
                        "value": "620821",
                        "parent": "620800"
                    },
                    {
                        "label": "灵台县",
                        "value": "620822",
                        "parent": "620800"
                    },
                    {
                        "label": "崇信县",
                        "value": "620823",
                        "parent": "620800"
                    },
                    {
                        "label": "庄浪县",
                        "value": "620825",
                        "parent": "620800"
                    },
                    {
                        "label": "静宁县",
                        "value": "620826",
                        "parent": "620800"
                    },
                    {
                        "label": "华亭市",
                        "value": "620881",
                        "parent": "620800"
                    }
                ]
            },
            {
                "value": "620900",
                "label": "酒泉市",
                "parent": "620000",
                "children": [
                    {
                        "label": "肃州区",
                        "value": "620902",
                        "parent": "620900"
                    },
                    {
                        "label": "金塔县",
                        "value": "620921",
                        "parent": "620900"
                    },
                    {
                        "label": "瓜州县",
                        "value": "620922",
                        "parent": "620900"
                    },
                    {
                        "label": "肃北蒙古族自治县",
                        "value": "620923",
                        "parent": "620900"
                    },
                    {
                        "label": "阿克塞哈萨克族自治县",
                        "value": "620924",
                        "parent": "620900"
                    },
                    {
                        "label": "玉门市",
                        "value": "620981",
                        "parent": "620900"
                    },
                    {
                        "label": "敦煌市",
                        "value": "620982",
                        "parent": "620900"
                    }
                ]
            },
            {
                "value": "621000",
                "label": "庆阳市",
                "parent": "620000",
                "children": [
                    {
                        "label": "西峰区",
                        "value": "621002",
                        "parent": "621000"
                    },
                    {
                        "label": "庆城县",
                        "value": "621021",
                        "parent": "621000"
                    },
                    {
                        "label": "环县",
                        "value": "621022",
                        "parent": "621000"
                    },
                    {
                        "label": "华池县",
                        "value": "621023",
                        "parent": "621000"
                    },
                    {
                        "label": "合水县",
                        "value": "621024",
                        "parent": "621000"
                    },
                    {
                        "label": "正宁县",
                        "value": "621025",
                        "parent": "621000"
                    },
                    {
                        "label": "宁县",
                        "value": "621026",
                        "parent": "621000"
                    },
                    {
                        "label": "镇原县",
                        "value": "621027",
                        "parent": "621000"
                    }
                ]
            },
            {
                "value": "621100",
                "label": "定西市",
                "parent": "620000",
                "children": [
                    {
                        "label": "安定区",
                        "value": "621102",
                        "parent": "621100"
                    },
                    {
                        "label": "通渭县",
                        "value": "621121",
                        "parent": "621100"
                    },
                    {
                        "label": "陇西县",
                        "value": "621122",
                        "parent": "621100"
                    },
                    {
                        "label": "渭源县",
                        "value": "621123",
                        "parent": "621100"
                    },
                    {
                        "label": "临洮县",
                        "value": "621124",
                        "parent": "621100"
                    },
                    {
                        "label": "漳县",
                        "value": "621125",
                        "parent": "621100"
                    },
                    {
                        "label": "岷县",
                        "value": "621126",
                        "parent": "621100"
                    }
                ]
            },
            {
                "value": "621200",
                "label": "陇南市",
                "parent": "620000",
                "children": [
                    {
                        "label": "武都区",
                        "value": "621202",
                        "parent": "621200"
                    },
                    {
                        "label": "成县",
                        "value": "621221",
                        "parent": "621200"
                    },
                    {
                        "label": "文县",
                        "value": "621222",
                        "parent": "621200"
                    },
                    {
                        "label": "宕昌县",
                        "value": "621223",
                        "parent": "621200"
                    },
                    {
                        "label": "康县",
                        "value": "621224",
                        "parent": "621200"
                    },
                    {
                        "label": "西和县",
                        "value": "621225",
                        "parent": "621200"
                    },
                    {
                        "label": "礼县",
                        "value": "621226",
                        "parent": "621200"
                    },
                    {
                        "label": "徽县",
                        "value": "621227",
                        "parent": "621200"
                    },
                    {
                        "label": "两当县",
                        "value": "621228",
                        "parent": "621200"
                    }
                ]
            },
            {
                "value": "622900",
                "label": "临夏回族自治州",
                "parent": "620000",
                "children": [
                    {
                        "label": "临夏市",
                        "value": "622901",
                        "parent": "622900"
                    },
                    {
                        "label": "临夏县",
                        "value": "622921",
                        "parent": "622900"
                    },
                    {
                        "label": "康乐县",
                        "value": "622922",
                        "parent": "622900"
                    },
                    {
                        "label": "永靖县",
                        "value": "622923",
                        "parent": "622900"
                    },
                    {
                        "label": "广河县",
                        "value": "622924",
                        "parent": "622900"
                    },
                    {
                        "label": "和政县",
                        "value": "622925",
                        "parent": "622900"
                    },
                    {
                        "label": "东乡族自治县",
                        "value": "622926",
                        "parent": "622900"
                    },
                    {
                        "label": "积石山保安族东乡族撒拉族自治县",
                        "value": "622927",
                        "parent": "622900"
                    }
                ]
            },
            {
                "value": "623000",
                "label": "甘南藏族自治州",
                "parent": "620000",
                "children": [
                    {
                        "label": "合作市",
                        "value": "623001",
                        "parent": "623000"
                    },
                    {
                        "label": "临潭县",
                        "value": "623021",
                        "parent": "623000"
                    },
                    {
                        "label": "卓尼县",
                        "value": "623022",
                        "parent": "623000"
                    },
                    {
                        "label": "舟曲县",
                        "value": "623023",
                        "parent": "623000"
                    },
                    {
                        "label": "迭部县",
                        "value": "623024",
                        "parent": "623000"
                    },
                    {
                        "label": "玛曲县",
                        "value": "623025",
                        "parent": "623000"
                    },
                    {
                        "label": "碌曲县",
                        "value": "623026",
                        "parent": "623000"
                    },
                    {
                        "label": "夏河县",
                        "value": "623027",
                        "parent": "623000"
                    }
                ]
            }
        ]
    },
    {
        "value": "630000",
        "label": "青海省",
        "children": [
            {
                "value": "630100",
                "label": "西宁市",
                "parent": "630000",
                "children": [
                    {
                        "label": "城东区",
                        "value": "630102",
                        "parent": "630100"
                    },
                    {
                        "label": "城中区",
                        "value": "630103",
                        "parent": "630100"
                    },
                    {
                        "label": "城西区",
                        "value": "630104",
                        "parent": "630100"
                    },
                    {
                        "label": "城北区",
                        "value": "630105",
                        "parent": "630100"
                    },
                    {
                        "label": "湟中区",
                        "value": "630106",
                        "parent": "630100"
                    },
                    {
                        "label": "大通回族土族自治县",
                        "value": "630121",
                        "parent": "630100"
                    },
                    {
                        "label": "湟源县",
                        "value": "630123",
                        "parent": "630100"
                    }
                ]
            },
            {
                "value": "632100",
                "label": "海东市",
                "parent": "630000",
                "children": []
            },
            {
                "value": "632200",
                "label": "海北藏族自治州",
                "parent": "630000",
                "children": [
                    {
                        "label": "门源回族自治县",
                        "value": "632221",
                        "parent": "632200"
                    },
                    {
                        "label": "祁连县",
                        "value": "632222",
                        "parent": "632200"
                    },
                    {
                        "label": "海晏县",
                        "value": "632223",
                        "parent": "632200"
                    },
                    {
                        "label": "刚察县",
                        "value": "632224",
                        "parent": "632200"
                    }
                ]
            },
            {
                "value": "632300",
                "label": "黄南藏族自治州",
                "parent": "630000",
                "children": [
                    {
                        "label": "同仁县",
                        "value": "632321",
                        "parent": "632300"
                    },
                    {
                        "label": "尖扎县",
                        "value": "632322",
                        "parent": "632300"
                    },
                    {
                        "label": "泽库县",
                        "value": "632323",
                        "parent": "632300"
                    },
                    {
                        "label": "河南蒙古族自治县",
                        "value": "632324",
                        "parent": "632300"
                    }
                ]
            },
            {
                "value": "632500",
                "label": "海南藏族自治州",
                "parent": "630000",
                "children": [
                    {
                        "label": "共和县",
                        "value": "632521",
                        "parent": "632500"
                    },
                    {
                        "label": "同德县",
                        "value": "632522",
                        "parent": "632500"
                    },
                    {
                        "label": "贵德县",
                        "value": "632523",
                        "parent": "632500"
                    },
                    {
                        "label": "兴海县",
                        "value": "632524",
                        "parent": "632500"
                    },
                    {
                        "label": "贵南县",
                        "value": "632525",
                        "parent": "632500"
                    }
                ]
            },
            {
                "value": "632600",
                "label": "果洛藏族自治州",
                "parent": "630000",
                "children": [
                    {
                        "label": "玛沁县",
                        "value": "632621",
                        "parent": "632600"
                    },
                    {
                        "label": "班玛县",
                        "value": "632622",
                        "parent": "632600"
                    },
                    {
                        "label": "甘德县",
                        "value": "632623",
                        "parent": "632600"
                    },
                    {
                        "label": "达日县",
                        "value": "632624",
                        "parent": "632600"
                    },
                    {
                        "label": "久治县",
                        "value": "632625",
                        "parent": "632600"
                    },
                    {
                        "label": "玛多县",
                        "value": "632626",
                        "parent": "632600"
                    }
                ]
            },
            {
                "value": "632700",
                "label": "玉树藏族自治州",
                "parent": "630000",
                "children": [
                    {
                        "label": "玉树市",
                        "value": "632701",
                        "parent": "632700"
                    },
                    {
                        "label": "杂多县",
                        "value": "632722",
                        "parent": "632700"
                    },
                    {
                        "label": "称多县",
                        "value": "632723",
                        "parent": "632700"
                    },
                    {
                        "label": "治多县",
                        "value": "632724",
                        "parent": "632700"
                    },
                    {
                        "label": "囊谦县",
                        "value": "632725",
                        "parent": "632700"
                    },
                    {
                        "label": "曲麻莱县",
                        "value": "632726",
                        "parent": "632700"
                    }
                ]
            },
            {
                "value": "632800",
                "label": "海西蒙古族藏族自治州",
                "parent": "630000",
                "children": [
                    {
                        "label": "格尔木市",
                        "value": "632801",
                        "parent": "632800"
                    },
                    {
                        "label": "德令哈市",
                        "value": "632802",
                        "parent": "632800"
                    },
                    {
                        "label": "茫崖市",
                        "value": "632803",
                        "parent": "632800"
                    },
                    {
                        "label": "乌兰县",
                        "value": "632821",
                        "parent": "632800"
                    },
                    {
                        "label": "都兰县",
                        "value": "632822",
                        "parent": "632800"
                    },
                    {
                        "label": "天峻县",
                        "value": "632823",
                        "parent": "632800"
                    },
                    {
                        "label": "大柴旦行政委员会",
                        "value": "632857",
                        "parent": "632800"
                    }
                ]
            }
        ]
    },
    {
        "value": "640000",
        "label": "宁夏回族自治区",
        "children": [
            {
                "value": "640100",
                "label": "银川市",
                "parent": "640000",
                "children": [
                    {
                        "label": "兴庆区",
                        "value": "640104",
                        "parent": "640100"
                    },
                    {
                        "label": "西夏区",
                        "value": "640105",
                        "parent": "640100"
                    },
                    {
                        "label": "金凤区",
                        "value": "640106",
                        "parent": "640100"
                    },
                    {
                        "label": "永宁县",
                        "value": "640121",
                        "parent": "640100"
                    },
                    {
                        "label": "贺兰县",
                        "value": "640122",
                        "parent": "640100"
                    },
                    {
                        "label": "灵武市",
                        "value": "640181",
                        "parent": "640100"
                    }
                ]
            },
            {
                "value": "640200",
                "label": "石嘴山市",
                "parent": "640000",
                "children": [
                    {
                        "label": "大武口区",
                        "value": "640202",
                        "parent": "640200"
                    },
                    {
                        "label": "惠农区",
                        "value": "640205",
                        "parent": "640200"
                    },
                    {
                        "label": "平罗县",
                        "value": "640221",
                        "parent": "640200"
                    }
                ]
            },
            {
                "value": "640300",
                "label": "吴忠市",
                "parent": "640000",
                "children": [
                    {
                        "label": "利通区",
                        "value": "640302",
                        "parent": "640300"
                    },
                    {
                        "label": "红寺堡区",
                        "value": "640303",
                        "parent": "640300"
                    },
                    {
                        "label": "盐池县",
                        "value": "640323",
                        "parent": "640300"
                    },
                    {
                        "label": "同心县",
                        "value": "640324",
                        "parent": "640300"
                    },
                    {
                        "label": "青铜峡市",
                        "value": "640381",
                        "parent": "640300"
                    }
                ]
            },
            {
                "value": "640400",
                "label": "固原市",
                "parent": "640000",
                "children": [
                    {
                        "label": "原州区",
                        "value": "640402",
                        "parent": "640400"
                    },
                    {
                        "label": "西吉县",
                        "value": "640422",
                        "parent": "640400"
                    },
                    {
                        "label": "隆德县",
                        "value": "640423",
                        "parent": "640400"
                    },
                    {
                        "label": "泾源县",
                        "value": "640424",
                        "parent": "640400"
                    },
                    {
                        "label": "彭阳县",
                        "value": "640425",
                        "parent": "640400"
                    }
                ]
            },
            {
                "value": "640500",
                "label": "中卫市",
                "parent": "640000",
                "children": [
                    {
                        "label": "沙坡头区",
                        "value": "640502",
                        "parent": "640500"
                    },
                    {
                        "label": "中宁县",
                        "value": "640521",
                        "parent": "640500"
                    },
                    {
                        "label": "海原县",
                        "value": "640522",
                        "parent": "640500"
                    }
                ]
            }
        ]
    },
    {
        "value": "650000",
        "label": "新疆维吾尔自治区",
        "children": [
            {
                "value": "650100",
                "label": "乌鲁木齐市",
                "parent": "650000",
                "children": [
                    {
                        "label": "天山区",
                        "value": "650102",
                        "parent": "650100"
                    },
                    {
                        "label": "沙依巴克区",
                        "value": "650103",
                        "parent": "650100"
                    },
                    {
                        "label": "新市区",
                        "value": "650104",
                        "parent": "650100"
                    },
                    {
                        "label": "水磨沟区",
                        "value": "650105",
                        "parent": "650100"
                    },
                    {
                        "label": "头屯河区",
                        "value": "650106",
                        "parent": "650100"
                    },
                    {
                        "label": "达坂城区",
                        "value": "650107",
                        "parent": "650100"
                    },
                    {
                        "label": "米东区",
                        "value": "650109",
                        "parent": "650100"
                    },
                    {
                        "label": "乌鲁木齐县",
                        "value": "650121",
                        "parent": "650100"
                    }
                ]
            },
            {
                "value": "650200",
                "label": "克拉玛依市",
                "parent": "650000",
                "children": [
                    {
                        "label": "独山子区",
                        "value": "650202",
                        "parent": "650200"
                    },
                    {
                        "label": "克拉玛依区",
                        "value": "650203",
                        "parent": "650200"
                    },
                    {
                        "label": "白碱滩区",
                        "value": "650204",
                        "parent": "650200"
                    },
                    {
                        "label": "乌尔禾区",
                        "value": "650205",
                        "parent": "650200"
                    }
                ]
            },
            {
                "value": "652100",
                "label": "吐鲁番市",
                "parent": "650000",
                "children": []
            },
            {
                "value": "652200",
                "label": "哈密地区",
                "parent": "650000",
                "children": []
            },
            {
                "value": "652300",
                "label": "昌吉回族自治州",
                "parent": "650000",
                "children": [
                    {
                        "label": "昌吉市",
                        "value": "652301",
                        "parent": "652300"
                    },
                    {
                        "label": "阜康市",
                        "value": "652302",
                        "parent": "652300"
                    },
                    {
                        "label": "呼图壁县",
                        "value": "652323",
                        "parent": "652300"
                    },
                    {
                        "label": "玛纳斯县",
                        "value": "652324",
                        "parent": "652300"
                    },
                    {
                        "label": "奇台县",
                        "value": "652325",
                        "parent": "652300"
                    },
                    {
                        "label": "吉木萨尔县",
                        "value": "652327",
                        "parent": "652300"
                    },
                    {
                        "label": "木垒哈萨克自治县",
                        "value": "652328",
                        "parent": "652300"
                    }
                ]
            },
            {
                "value": "652700",
                "label": "博尔塔拉蒙古自治州",
                "parent": "650000",
                "children": [
                    {
                        "label": "博乐市",
                        "value": "652701",
                        "parent": "652700"
                    },
                    {
                        "label": "阿拉山口市",
                        "value": "652702",
                        "parent": "652700"
                    },
                    {
                        "label": "精河县",
                        "value": "652722",
                        "parent": "652700"
                    },
                    {
                        "label": "温泉县",
                        "value": "652723",
                        "parent": "652700"
                    }
                ]
            },
            {
                "value": "652800",
                "label": "巴音郭楞蒙古自治州",
                "parent": "650000",
                "children": [
                    {
                        "label": "库尔勒市",
                        "value": "652801",
                        "parent": "652800"
                    },
                    {
                        "label": "轮台县",
                        "value": "652822",
                        "parent": "652800"
                    },
                    {
                        "label": "尉犁县",
                        "value": "652823",
                        "parent": "652800"
                    },
                    {
                        "label": "若羌县",
                        "value": "652824",
                        "parent": "652800"
                    },
                    {
                        "label": "且末县",
                        "value": "652825",
                        "parent": "652800"
                    },
                    {
                        "label": "焉耆回族自治县",
                        "value": "652826",
                        "parent": "652800"
                    },
                    {
                        "label": "和静县",
                        "value": "652827",
                        "parent": "652800"
                    },
                    {
                        "label": "和硕县",
                        "value": "652828",
                        "parent": "652800"
                    },
                    {
                        "label": "博湖县",
                        "value": "652829",
                        "parent": "652800"
                    }
                ]
            },
            {
                "value": "652900",
                "label": "阿克苏地区",
                "parent": "650000",
                "children": [
                    {
                        "label": "阿克苏市",
                        "value": "652901",
                        "parent": "652900"
                    },
                    {
                        "label": "库车市",
                        "value": "652902",
                        "parent": "652900"
                    },
                    {
                        "label": "温宿县",
                        "value": "652922",
                        "parent": "652900"
                    },
                    {
                        "label": "沙雅县",
                        "value": "652924",
                        "parent": "652900"
                    },
                    {
                        "label": "新和县",
                        "value": "652925",
                        "parent": "652900"
                    },
                    {
                        "label": "拜城县",
                        "value": "652926",
                        "parent": "652900"
                    },
                    {
                        "label": "乌什县",
                        "value": "652927",
                        "parent": "652900"
                    },
                    {
                        "label": "阿瓦提县",
                        "value": "652928",
                        "parent": "652900"
                    },
                    {
                        "label": "柯坪县",
                        "value": "652929",
                        "parent": "652900"
                    }
                ]
            },
            {
                "value": "653000",
                "label": "克孜勒苏柯尔克孜自治州",
                "parent": "650000",
                "children": [
                    {
                        "label": "阿图什市",
                        "value": "653001",
                        "parent": "653000"
                    },
                    {
                        "label": "阿克陶县",
                        "value": "653022",
                        "parent": "653000"
                    },
                    {
                        "label": "阿合奇县",
                        "value": "653023",
                        "parent": "653000"
                    },
                    {
                        "label": "乌恰县",
                        "value": "653024",
                        "parent": "653000"
                    }
                ]
            },
            {
                "value": "653100",
                "label": "喀什地区",
                "parent": "650000",
                "children": [
                    {
                        "label": "喀什市",
                        "value": "653101",
                        "parent": "653100"
                    },
                    {
                        "label": "疏附县",
                        "value": "653121",
                        "parent": "653100"
                    },
                    {
                        "label": "疏勒县",
                        "value": "653122",
                        "parent": "653100"
                    },
                    {
                        "label": "英吉沙县",
                        "value": "653123",
                        "parent": "653100"
                    },
                    {
                        "label": "泽普县",
                        "value": "653124",
                        "parent": "653100"
                    },
                    {
                        "label": "莎车县",
                        "value": "653125",
                        "parent": "653100"
                    },
                    {
                        "label": "叶城县",
                        "value": "653126",
                        "parent": "653100"
                    },
                    {
                        "label": "麦盖提县",
                        "value": "653127",
                        "parent": "653100"
                    },
                    {
                        "label": "岳普湖县",
                        "value": "653128",
                        "parent": "653100"
                    },
                    {
                        "label": "伽师县",
                        "value": "653129",
                        "parent": "653100"
                    },
                    {
                        "label": "巴楚县",
                        "value": "653130",
                        "parent": "653100"
                    },
                    {
                        "label": "塔什库尔干塔吉克自治县",
                        "value": "653131",
                        "parent": "653100"
                    }
                ]
            },
            {
                "value": "653200",
                "label": "和田地区",
                "parent": "650000",
                "children": [
                    {
                        "label": "和田市",
                        "value": "653201",
                        "parent": "653200"
                    },
                    {
                        "label": "和田县",
                        "value": "653221",
                        "parent": "653200"
                    },
                    {
                        "label": "墨玉县",
                        "value": "653222",
                        "parent": "653200"
                    },
                    {
                        "label": "皮山县",
                        "value": "653223",
                        "parent": "653200"
                    },
                    {
                        "label": "洛浦县",
                        "value": "653224",
                        "parent": "653200"
                    },
                    {
                        "label": "策勒县",
                        "value": "653225",
                        "parent": "653200"
                    },
                    {
                        "label": "于田县",
                        "value": "653226",
                        "parent": "653200"
                    },
                    {
                        "label": "民丰县",
                        "value": "653227",
                        "parent": "653200"
                    }
                ]
            },
            {
                "value": "654000",
                "label": "伊犁哈萨克自治州",
                "parent": "650000",
                "children": [
                    {
                        "label": "伊宁市",
                        "value": "654002",
                        "parent": "654000"
                    },
                    {
                        "label": "奎屯市",
                        "value": "654003",
                        "parent": "654000"
                    },
                    {
                        "label": "霍尔果斯市",
                        "value": "654004",
                        "parent": "654000"
                    },
                    {
                        "label": "伊宁县",
                        "value": "654021",
                        "parent": "654000"
                    },
                    {
                        "label": "察布查尔锡伯自治县",
                        "value": "654022",
                        "parent": "654000"
                    },
                    {
                        "label": "霍城县",
                        "value": "654023",
                        "parent": "654000"
                    },
                    {
                        "label": "巩留县",
                        "value": "654024",
                        "parent": "654000"
                    },
                    {
                        "label": "新源县",
                        "value": "654025",
                        "parent": "654000"
                    },
                    {
                        "label": "昭苏县",
                        "value": "654026",
                        "parent": "654000"
                    },
                    {
                        "label": "特克斯县",
                        "value": "654027",
                        "parent": "654000"
                    },
                    {
                        "label": "尼勒克县",
                        "value": "654028",
                        "parent": "654000"
                    }
                ]
            },
            {
                "value": "654200",
                "label": "塔城地区",
                "parent": "650000",
                "children": [
                    {
                        "label": "塔城市",
                        "value": "654201",
                        "parent": "654200"
                    },
                    {
                        "label": "乌苏市",
                        "value": "654202",
                        "parent": "654200"
                    },
                    {
                        "label": "额敏县",
                        "value": "654221",
                        "parent": "654200"
                    },
                    {
                        "label": "沙湾县",
                        "value": "654223",
                        "parent": "654200"
                    },
                    {
                        "label": "托里县",
                        "value": "654224",
                        "parent": "654200"
                    },
                    {
                        "label": "裕民县",
                        "value": "654225",
                        "parent": "654200"
                    },
                    {
                        "label": "和布克赛尔蒙古自治县",
                        "value": "654226",
                        "parent": "654200"
                    }
                ]
            },
            {
                "value": "654300",
                "label": "阿勒泰地区",
                "parent": "650000",
                "children": [
                    {
                        "label": "阿勒泰市",
                        "value": "654301",
                        "parent": "654300"
                    },
                    {
                        "label": "布尔津县",
                        "value": "654321",
                        "parent": "654300"
                    },
                    {
                        "label": "富蕴县",
                        "value": "654322",
                        "parent": "654300"
                    },
                    {
                        "label": "福海县",
                        "value": "654323",
                        "parent": "654300"
                    },
                    {
                        "label": "哈巴河县",
                        "value": "654324",
                        "parent": "654300"
                    },
                    {
                        "label": "青河县",
                        "value": "654325",
                        "parent": "654300"
                    },
                    {
                        "label": "吉木乃县",
                        "value": "654326",
                        "parent": "654300"
                    }
                ]
            },
            {
                "value": "659000",
                "label": "可克达拉市",
                "parent": "650000",
                "children": [
                    {
                        "label": "石河子市",
                        "value": "659001",
                        "parent": "659000"
                    },
                    {
                        "label": "阿拉尔市",
                        "value": "659002",
                        "parent": "659000"
                    },
                    {
                        "label": "图木舒克市",
                        "value": "659003",
                        "parent": "659000"
                    },
                    {
                        "label": "五家渠市",
                        "value": "659004",
                        "parent": "659000"
                    },
                    {
                        "label": "北屯市",
                        "value": "659005",
                        "parent": "659000"
                    },
                    {
                        "label": "铁门关市",
                        "value": "659006",
                        "parent": "659000"
                    },
                    {
                        "label": "双河市",
                        "value": "659007",
                        "parent": "659000"
                    },
                    {
                        "label": "可克达拉市",
                        "value": "659008",
                        "parent": "659000"
                    },
                    {
                        "label": "昆玉市",
                        "value": "659009",
                        "parent": "659000"
                    },
                    {
                        "label": "胡杨河市",
                        "value": "659010",
                        "parent": "659000"
                    }
                ]
            }
        ]
    },
    {
        "value": "710000",
        "label": "台湾",
        "children": [
            {
                "value": "710100",
                "label": "台北市",
                "parent": "710000",
                "children": [
                    {
                        "label": "中正区",
                        "value": "710101",
                        "parent": "710100"
                    },
                    {
                        "label": "大同区",
                        "value": "710102",
                        "parent": "710100"
                    },
                    {
                        "label": "中山区",
                        "value": "710103",
                        "parent": "710100"
                    },
                    {
                        "label": "松山区",
                        "value": "710104",
                        "parent": "710100"
                    },
                    {
                        "label": "大安区",
                        "value": "710105",
                        "parent": "710100"
                    },
                    {
                        "label": "万华区",
                        "value": "710106",
                        "parent": "710100"
                    },
                    {
                        "label": "信义区",
                        "value": "710107",
                        "parent": "710100"
                    },
                    {
                        "label": "士林区",
                        "value": "710108",
                        "parent": "710100"
                    },
                    {
                        "label": "北投区",
                        "value": "710109",
                        "parent": "710100"
                    },
                    {
                        "label": "内湖区",
                        "value": "710110",
                        "parent": "710100"
                    },
                    {
                        "label": "南港区",
                        "value": "710111",
                        "parent": "710100"
                    },
                    {
                        "label": "文山区",
                        "value": "710112",
                        "parent": "710100"
                    },
                    {
                        "label": "其它区",
                        "value": "710199",
                        "parent": "710100"
                    }
                ]
            },
            {
                "value": "710200",
                "label": "高雄市",
                "parent": "710000",
                "children": [
                    {
                        "label": "新兴区",
                        "value": "710201",
                        "parent": "710200"
                    },
                    {
                        "label": "前金区",
                        "value": "710202",
                        "parent": "710200"
                    },
                    {
                        "label": "芩雅区",
                        "value": "710203",
                        "parent": "710200"
                    },
                    {
                        "label": "盐埕区",
                        "value": "710204",
                        "parent": "710200"
                    },
                    {
                        "label": "鼓山区",
                        "value": "710205",
                        "parent": "710200"
                    },
                    {
                        "label": "旗津区",
                        "value": "710206",
                        "parent": "710200"
                    },
                    {
                        "label": "前镇区",
                        "value": "710207",
                        "parent": "710200"
                    },
                    {
                        "label": "三民区",
                        "value": "710208",
                        "parent": "710200"
                    },
                    {
                        "label": "左营区",
                        "value": "710209",
                        "parent": "710200"
                    },
                    {
                        "label": "楠梓区",
                        "value": "710210",
                        "parent": "710200"
                    },
                    {
                        "label": "小港区",
                        "value": "710211",
                        "parent": "710200"
                    },
                    {
                        "label": "苓雅区",
                        "value": "710241",
                        "parent": "710200"
                    },
                    {
                        "label": "仁武区",
                        "value": "710242",
                        "parent": "710200"
                    },
                    {
                        "label": "大社区",
                        "value": "710243",
                        "parent": "710200"
                    },
                    {
                        "label": "冈山区",
                        "value": "710244",
                        "parent": "710200"
                    },
                    {
                        "label": "路竹区",
                        "value": "710245",
                        "parent": "710200"
                    },
                    {
                        "label": "阿莲区",
                        "value": "710246",
                        "parent": "710200"
                    },
                    {
                        "label": "田寮区",
                        "value": "710247",
                        "parent": "710200"
                    },
                    {
                        "label": "燕巢区",
                        "value": "710248",
                        "parent": "710200"
                    },
                    {
                        "label": "桥头区",
                        "value": "710249",
                        "parent": "710200"
                    },
                    {
                        "label": "梓官区",
                        "value": "710250",
                        "parent": "710200"
                    },
                    {
                        "label": "弥陀区",
                        "value": "710251",
                        "parent": "710200"
                    },
                    {
                        "label": "永安区",
                        "value": "710252",
                        "parent": "710200"
                    },
                    {
                        "label": "湖内区",
                        "value": "710253",
                        "parent": "710200"
                    },
                    {
                        "label": "凤山区",
                        "value": "710254",
                        "parent": "710200"
                    },
                    {
                        "label": "大寮区",
                        "value": "710255",
                        "parent": "710200"
                    },
                    {
                        "label": "林园区",
                        "value": "710256",
                        "parent": "710200"
                    },
                    {
                        "label": "鸟松区",
                        "value": "710257",
                        "parent": "710200"
                    },
                    {
                        "label": "大树区",
                        "value": "710258",
                        "parent": "710200"
                    },
                    {
                        "label": "旗山区",
                        "value": "710259",
                        "parent": "710200"
                    },
                    {
                        "label": "美浓区",
                        "value": "710260",
                        "parent": "710200"
                    },
                    {
                        "label": "六龟区",
                        "value": "710261",
                        "parent": "710200"
                    },
                    {
                        "label": "内门区",
                        "value": "710262",
                        "parent": "710200"
                    },
                    {
                        "label": "杉林区",
                        "value": "710263",
                        "parent": "710200"
                    },
                    {
                        "label": "甲仙区",
                        "value": "710264",
                        "parent": "710200"
                    },
                    {
                        "label": "桃源区",
                        "value": "710265",
                        "parent": "710200"
                    },
                    {
                        "label": "那玛夏区",
                        "value": "710266",
                        "parent": "710200"
                    },
                    {
                        "label": "茂林区",
                        "value": "710267",
                        "parent": "710200"
                    },
                    {
                        "label": "茄萣区",
                        "value": "710268",
                        "parent": "710200"
                    },
                    {
                        "label": "其它区",
                        "value": "710299",
                        "parent": "710200"
                    }
                ]
            },
            {
                "value": "710300",
                "label": "台南市",
                "parent": "710000",
                "children": [
                    {
                        "label": "中西区",
                        "value": "710301",
                        "parent": "710300"
                    },
                    {
                        "label": "东区",
                        "value": "710302",
                        "parent": "710300"
                    },
                    {
                        "label": "南区",
                        "value": "710303",
                        "parent": "710300"
                    },
                    {
                        "label": "北区",
                        "value": "710304",
                        "parent": "710300"
                    },
                    {
                        "label": "安平区",
                        "value": "710305",
                        "parent": "710300"
                    },
                    {
                        "label": "安南区",
                        "value": "710306",
                        "parent": "710300"
                    },
                    {
                        "label": "永康区",
                        "value": "710339",
                        "parent": "710300"
                    },
                    {
                        "label": "归仁区",
                        "value": "710340",
                        "parent": "710300"
                    },
                    {
                        "label": "新化区",
                        "value": "710341",
                        "parent": "710300"
                    },
                    {
                        "label": "左镇区",
                        "value": "710342",
                        "parent": "710300"
                    },
                    {
                        "label": "玉井区",
                        "value": "710343",
                        "parent": "710300"
                    },
                    {
                        "label": "楠西区",
                        "value": "710344",
                        "parent": "710300"
                    },
                    {
                        "label": "南化区",
                        "value": "710345",
                        "parent": "710300"
                    },
                    {
                        "label": "仁德区",
                        "value": "710346",
                        "parent": "710300"
                    },
                    {
                        "label": "关庙区",
                        "value": "710347",
                        "parent": "710300"
                    },
                    {
                        "label": "龙崎区",
                        "value": "710348",
                        "parent": "710300"
                    },
                    {
                        "label": "官田区",
                        "value": "710349",
                        "parent": "710300"
                    },
                    {
                        "label": "麻豆区",
                        "value": "710350",
                        "parent": "710300"
                    },
                    {
                        "label": "佳里区",
                        "value": "710351",
                        "parent": "710300"
                    },
                    {
                        "label": "西港区",
                        "value": "710352",
                        "parent": "710300"
                    },
                    {
                        "label": "七股区",
                        "value": "710353",
                        "parent": "710300"
                    },
                    {
                        "label": "将军区",
                        "value": "710354",
                        "parent": "710300"
                    },
                    {
                        "label": "学甲区",
                        "value": "710355",
                        "parent": "710300"
                    },
                    {
                        "label": "北门区",
                        "value": "710356",
                        "parent": "710300"
                    },
                    {
                        "label": "新营区",
                        "value": "710357",
                        "parent": "710300"
                    },
                    {
                        "label": "后壁区",
                        "value": "710358",
                        "parent": "710300"
                    },
                    {
                        "label": "白河区",
                        "value": "710359",
                        "parent": "710300"
                    },
                    {
                        "label": "东山区",
                        "value": "710360",
                        "parent": "710300"
                    },
                    {
                        "label": "六甲区",
                        "value": "710361",
                        "parent": "710300"
                    },
                    {
                        "label": "下营区",
                        "value": "710362",
                        "parent": "710300"
                    },
                    {
                        "label": "柳营区",
                        "value": "710363",
                        "parent": "710300"
                    },
                    {
                        "label": "盐水区",
                        "value": "710364",
                        "parent": "710300"
                    },
                    {
                        "label": "善化区",
                        "value": "710365",
                        "parent": "710300"
                    },
                    {
                        "label": "大内区",
                        "value": "710366",
                        "parent": "710300"
                    },
                    {
                        "label": "山上区",
                        "value": "710367",
                        "parent": "710300"
                    },
                    {
                        "label": "新市区",
                        "value": "710368",
                        "parent": "710300"
                    },
                    {
                        "label": "安定区",
                        "value": "710369",
                        "parent": "710300"
                    },
                    {
                        "label": "其它区",
                        "value": "710399",
                        "parent": "710300"
                    }
                ]
            },
            {
                "value": "710400",
                "label": "台中市",
                "parent": "710000",
                "children": [
                    {
                        "label": "中区",
                        "value": "710401",
                        "parent": "710400"
                    },
                    {
                        "label": "东区",
                        "value": "710402",
                        "parent": "710400"
                    },
                    {
                        "label": "南区",
                        "value": "710403",
                        "parent": "710400"
                    },
                    {
                        "label": "西区",
                        "value": "710404",
                        "parent": "710400"
                    },
                    {
                        "label": "北区",
                        "value": "710405",
                        "parent": "710400"
                    },
                    {
                        "label": "北屯区",
                        "value": "710406",
                        "parent": "710400"
                    },
                    {
                        "label": "西屯区",
                        "value": "710407",
                        "parent": "710400"
                    },
                    {
                        "label": "南屯区",
                        "value": "710408",
                        "parent": "710400"
                    },
                    {
                        "label": "太平区",
                        "value": "710431",
                        "parent": "710400"
                    },
                    {
                        "label": "大里区",
                        "value": "710432",
                        "parent": "710400"
                    },
                    {
                        "label": "雾峰区",
                        "value": "710433",
                        "parent": "710400"
                    },
                    {
                        "label": "乌日区",
                        "value": "710434",
                        "parent": "710400"
                    },
                    {
                        "label": "丰原区",
                        "value": "710435",
                        "parent": "710400"
                    },
                    {
                        "label": "后里区",
                        "value": "710436",
                        "parent": "710400"
                    },
                    {
                        "label": "石冈区",
                        "value": "710437",
                        "parent": "710400"
                    },
                    {
                        "label": "东势区",
                        "value": "710438",
                        "parent": "710400"
                    },
                    {
                        "label": "和平区",
                        "value": "710439",
                        "parent": "710400"
                    },
                    {
                        "label": "新社区",
                        "value": "710440",
                        "parent": "710400"
                    },
                    {
                        "label": "潭子区",
                        "value": "710441",
                        "parent": "710400"
                    },
                    {
                        "label": "大雅区",
                        "value": "710442",
                        "parent": "710400"
                    },
                    {
                        "label": "神冈区",
                        "value": "710443",
                        "parent": "710400"
                    },
                    {
                        "label": "大肚区",
                        "value": "710444",
                        "parent": "710400"
                    },
                    {
                        "label": "沙鹿区",
                        "value": "710445",
                        "parent": "710400"
                    },
                    {
                        "label": "龙井区",
                        "value": "710446",
                        "parent": "710400"
                    },
                    {
                        "label": "梧栖区",
                        "value": "710447",
                        "parent": "710400"
                    },
                    {
                        "label": "清水区",
                        "value": "710448",
                        "parent": "710400"
                    },
                    {
                        "label": "大甲区",
                        "value": "710449",
                        "parent": "710400"
                    },
                    {
                        "label": "外埔区",
                        "value": "710450",
                        "parent": "710400"
                    },
                    {
                        "label": "大安区",
                        "value": "710451",
                        "parent": "710400"
                    },
                    {
                        "label": "其它区",
                        "value": "710499",
                        "parent": "710400"
                    }
                ]
            },
            {
                "value": "710500",
                "label": "金门县",
                "parent": "710000",
                "children": [
                    {
                        "label": "金沙镇",
                        "value": "710507",
                        "parent": "710500"
                    },
                    {
                        "label": "金湖镇",
                        "value": "710508",
                        "parent": "710500"
                    },
                    {
                        "label": "金宁乡",
                        "value": "710509",
                        "parent": "710500"
                    },
                    {
                        "label": "金城镇",
                        "value": "710510",
                        "parent": "710500"
                    },
                    {
                        "label": "烈屿乡",
                        "value": "710511",
                        "parent": "710500"
                    },
                    {
                        "label": "乌坵乡",
                        "value": "710512",
                        "parent": "710500"
                    }
                ]
            },
            {
                "value": "710600",
                "label": "南投县",
                "parent": "710000",
                "children": [
                    {
                        "label": "南投市",
                        "value": "710614",
                        "parent": "710600"
                    },
                    {
                        "label": "中寮乡",
                        "value": "710615",
                        "parent": "710600"
                    },
                    {
                        "label": "草屯镇",
                        "value": "710616",
                        "parent": "710600"
                    },
                    {
                        "label": "国姓乡",
                        "value": "710617",
                        "parent": "710600"
                    },
                    {
                        "label": "埔里镇",
                        "value": "710618",
                        "parent": "710600"
                    },
                    {
                        "label": "仁爱乡",
                        "value": "710619",
                        "parent": "710600"
                    },
                    {
                        "label": "名间乡",
                        "value": "710620",
                        "parent": "710600"
                    },
                    {
                        "label": "集集镇",
                        "value": "710621",
                        "parent": "710600"
                    },
                    {
                        "label": "水里乡",
                        "value": "710622",
                        "parent": "710600"
                    },
                    {
                        "label": "鱼池乡",
                        "value": "710623",
                        "parent": "710600"
                    },
                    {
                        "label": "信义乡",
                        "value": "710624",
                        "parent": "710600"
                    },
                    {
                        "label": "竹山镇",
                        "value": "710625",
                        "parent": "710600"
                    },
                    {
                        "label": "鹿谷乡",
                        "value": "710626",
                        "parent": "710600"
                    }
                ]
            },
            {
                "value": "710700",
                "label": "基隆市",
                "parent": "710000",
                "children": [
                    {
                        "label": "仁爱区",
                        "value": "710701",
                        "parent": "710700"
                    },
                    {
                        "label": "信义区",
                        "value": "710702",
                        "parent": "710700"
                    },
                    {
                        "label": "中正区",
                        "value": "710703",
                        "parent": "710700"
                    },
                    {
                        "label": "中山区",
                        "value": "710704",
                        "parent": "710700"
                    },
                    {
                        "label": "安乐区",
                        "value": "710705",
                        "parent": "710700"
                    },
                    {
                        "label": "暖暖区",
                        "value": "710706",
                        "parent": "710700"
                    },
                    {
                        "label": "七堵区",
                        "value": "710707",
                        "parent": "710700"
                    },
                    {
                        "label": "其它区",
                        "value": "710799",
                        "parent": "710700"
                    }
                ]
            },
            {
                "value": "710800",
                "label": "新竹市",
                "parent": "710000",
                "children": [
                    {
                        "label": "东区",
                        "value": "710801",
                        "parent": "710800"
                    },
                    {
                        "label": "北区",
                        "value": "710802",
                        "parent": "710800"
                    },
                    {
                        "label": "香山区",
                        "value": "710803",
                        "parent": "710800"
                    },
                    {
                        "label": "其它区",
                        "value": "710899",
                        "parent": "710800"
                    }
                ]
            },
            {
                "value": "710900",
                "label": "嘉义市",
                "parent": "710000",
                "children": [
                    {
                        "label": "东区",
                        "value": "710901",
                        "parent": "710900"
                    },
                    {
                        "label": "西区",
                        "value": "710902",
                        "parent": "710900"
                    },
                    {
                        "label": "其它区",
                        "value": "710999",
                        "parent": "710900"
                    }
                ]
            },
            {
                "value": "711100",
                "label": "新北市",
                "parent": "710000",
                "children": [
                    {
                        "label": "万里区",
                        "value": "711130",
                        "parent": "711100"
                    },
                    {
                        "label": "板桥区",
                        "value": "711132",
                        "parent": "711100"
                    },
                    {
                        "label": "汐止区",
                        "value": "711133",
                        "parent": "711100"
                    },
                    {
                        "label": "深坑区",
                        "value": "711134",
                        "parent": "711100"
                    },
                    {
                        "label": "石碇区",
                        "value": "711135",
                        "parent": "711100"
                    },
                    {
                        "label": "瑞芳区",
                        "value": "711136",
                        "parent": "711100"
                    },
                    {
                        "label": "平溪区",
                        "value": "711137",
                        "parent": "711100"
                    },
                    {
                        "label": "双溪区",
                        "value": "711138",
                        "parent": "711100"
                    },
                    {
                        "label": "贡寮区",
                        "value": "711139",
                        "parent": "711100"
                    },
                    {
                        "label": "新店区",
                        "value": "711140",
                        "parent": "711100"
                    },
                    {
                        "label": "坪林区",
                        "value": "711141",
                        "parent": "711100"
                    },
                    {
                        "label": "乌来区",
                        "value": "711142",
                        "parent": "711100"
                    },
                    {
                        "label": "永和区",
                        "value": "711143",
                        "parent": "711100"
                    },
                    {
                        "label": "中和区",
                        "value": "711144",
                        "parent": "711100"
                    },
                    {
                        "label": "土城区",
                        "value": "711145",
                        "parent": "711100"
                    },
                    {
                        "label": "三峡区",
                        "value": "711146",
                        "parent": "711100"
                    },
                    {
                        "label": "树林区",
                        "value": "711147",
                        "parent": "711100"
                    },
                    {
                        "label": "莺歌区",
                        "value": "711148",
                        "parent": "711100"
                    },
                    {
                        "label": "三重区",
                        "value": "711149",
                        "parent": "711100"
                    },
                    {
                        "label": "新庄区",
                        "value": "711150",
                        "parent": "711100"
                    },
                    {
                        "label": "泰山区",
                        "value": "711151",
                        "parent": "711100"
                    },
                    {
                        "label": "林口区",
                        "value": "711152",
                        "parent": "711100"
                    },
                    {
                        "label": "芦洲区",
                        "value": "711153",
                        "parent": "711100"
                    },
                    {
                        "label": "五股区",
                        "value": "711154",
                        "parent": "711100"
                    },
                    {
                        "label": "八里区",
                        "value": "711155",
                        "parent": "711100"
                    },
                    {
                        "label": "淡水区",
                        "value": "711156",
                        "parent": "711100"
                    },
                    {
                        "label": "三芝区",
                        "value": "711157",
                        "parent": "711100"
                    },
                    {
                        "label": "石门区",
                        "value": "711158",
                        "parent": "711100"
                    }
                ]
            },
            {
                "value": "711200",
                "label": "宜兰县",
                "parent": "710000",
                "children": [
                    {
                        "label": "宜兰市",
                        "value": "711287",
                        "parent": "711200"
                    },
                    {
                        "label": "头城镇",
                        "value": "711288",
                        "parent": "711200"
                    },
                    {
                        "label": "礁溪乡",
                        "value": "711289",
                        "parent": "711200"
                    },
                    {
                        "label": "壮围乡",
                        "value": "711290",
                        "parent": "711200"
                    },
                    {
                        "label": "员山乡",
                        "value": "711291",
                        "parent": "711200"
                    },
                    {
                        "label": "罗东镇",
                        "value": "711292",
                        "parent": "711200"
                    },
                    {
                        "label": "三星乡",
                        "value": "711293",
                        "parent": "711200"
                    },
                    {
                        "label": "大同乡",
                        "value": "711294",
                        "parent": "711200"
                    },
                    {
                        "label": "五结乡",
                        "value": "711295",
                        "parent": "711200"
                    },
                    {
                        "label": "冬山乡",
                        "value": "711296",
                        "parent": "711200"
                    },
                    {
                        "label": "苏澳镇",
                        "value": "711297",
                        "parent": "711200"
                    },
                    {
                        "label": "南澳乡",
                        "value": "711298",
                        "parent": "711200"
                    },
                    {
                        "label": "钓鱼台",
                        "value": "711299",
                        "parent": "711200"
                    }
                ]
            },
            {
                "value": "711300",
                "label": "新竹县",
                "parent": "710000",
                "children": [
                    {
                        "label": "竹北市",
                        "value": "711387",
                        "parent": "711300"
                    },
                    {
                        "label": "湖口乡",
                        "value": "711388",
                        "parent": "711300"
                    },
                    {
                        "label": "新丰乡",
                        "value": "711389",
                        "parent": "711300"
                    },
                    {
                        "label": "新埔镇",
                        "value": "711390",
                        "parent": "711300"
                    },
                    {
                        "label": "关西镇",
                        "value": "711391",
                        "parent": "711300"
                    },
                    {
                        "label": "芎林乡",
                        "value": "711392",
                        "parent": "711300"
                    },
                    {
                        "label": "宝山乡",
                        "value": "711393",
                        "parent": "711300"
                    },
                    {
                        "label": "竹东镇",
                        "value": "711394",
                        "parent": "711300"
                    },
                    {
                        "label": "五峰乡",
                        "value": "711395",
                        "parent": "711300"
                    },
                    {
                        "label": "横山乡",
                        "value": "711396",
                        "parent": "711300"
                    },
                    {
                        "label": "尖石乡",
                        "value": "711397",
                        "parent": "711300"
                    },
                    {
                        "label": "北埔乡",
                        "value": "711398",
                        "parent": "711300"
                    },
                    {
                        "label": "峨眉乡",
                        "value": "711399",
                        "parent": "711300"
                    }
                ]
            },
            {
                "value": "711400",
                "label": "桃园县",
                "parent": "710000",
                "children": [
                    {
                        "label": "中坜区",
                        "value": "711414",
                        "parent": "711400"
                    },
                    {
                        "label": "平镇区",
                        "value": "711415",
                        "parent": "711400"
                    },
                    {
                        "label": "杨梅区",
                        "value": "711417",
                        "parent": "711400"
                    },
                    {
                        "label": "新屋区",
                        "value": "711418",
                        "parent": "711400"
                    },
                    {
                        "label": "观音区",
                        "value": "711419",
                        "parent": "711400"
                    },
                    {
                        "label": "桃园区",
                        "value": "711420",
                        "parent": "711400"
                    },
                    {
                        "label": "龟山区",
                        "value": "711421",
                        "parent": "711400"
                    },
                    {
                        "label": "八德区",
                        "value": "711422",
                        "parent": "711400"
                    },
                    {
                        "label": "大溪区",
                        "value": "711423",
                        "parent": "711400"
                    },
                    {
                        "label": "大园区",
                        "value": "711425",
                        "parent": "711400"
                    },
                    {
                        "label": "芦竹区",
                        "value": "711426",
                        "parent": "711400"
                    },
                    {
                        "label": "中坜市",
                        "value": "711487",
                        "parent": "711400"
                    },
                    {
                        "label": "平镇市",
                        "value": "711488",
                        "parent": "711400"
                    },
                    {
                        "label": "龙潭乡",
                        "value": "711489",
                        "parent": "711400"
                    },
                    {
                        "label": "杨梅市",
                        "value": "711490",
                        "parent": "711400"
                    },
                    {
                        "label": "新屋乡",
                        "value": "711491",
                        "parent": "711400"
                    },
                    {
                        "label": "观音乡",
                        "value": "711492",
                        "parent": "711400"
                    },
                    {
                        "label": "桃园市",
                        "value": "711493",
                        "parent": "711400"
                    },
                    {
                        "label": "龟山乡",
                        "value": "711494",
                        "parent": "711400"
                    },
                    {
                        "label": "八德市",
                        "value": "711495",
                        "parent": "711400"
                    },
                    {
                        "label": "大溪镇",
                        "value": "711496",
                        "parent": "711400"
                    },
                    {
                        "label": "复兴乡",
                        "value": "711497",
                        "parent": "711400"
                    },
                    {
                        "label": "大园乡",
                        "value": "711498",
                        "parent": "711400"
                    },
                    {
                        "label": "芦竹乡",
                        "value": "711499",
                        "parent": "711400"
                    }
                ]
            },
            {
                "value": "711500",
                "label": "苗栗县",
                "parent": "710000",
                "children": [
                    {
                        "label": "头份市",
                        "value": "711520",
                        "parent": "711500"
                    },
                    {
                        "label": "竹南镇",
                        "value": "711582",
                        "parent": "711500"
                    },
                    {
                        "label": "头份镇",
                        "value": "711583",
                        "parent": "711500"
                    },
                    {
                        "label": "三湾乡",
                        "value": "711584",
                        "parent": "711500"
                    },
                    {
                        "label": "南庄乡",
                        "value": "711585",
                        "parent": "711500"
                    },
                    {
                        "label": "狮潭乡",
                        "value": "711586",
                        "parent": "711500"
                    },
                    {
                        "label": "后龙镇",
                        "value": "711587",
                        "parent": "711500"
                    },
                    {
                        "label": "通霄镇",
                        "value": "711588",
                        "parent": "711500"
                    },
                    {
                        "label": "苑里镇",
                        "value": "711589",
                        "parent": "711500"
                    },
                    {
                        "label": "苗栗市",
                        "value": "711590",
                        "parent": "711500"
                    },
                    {
                        "label": "造桥乡",
                        "value": "711591",
                        "parent": "711500"
                    },
                    {
                        "label": "头屋乡",
                        "value": "711592",
                        "parent": "711500"
                    },
                    {
                        "label": "公馆乡",
                        "value": "711593",
                        "parent": "711500"
                    },
                    {
                        "label": "大湖乡",
                        "value": "711594",
                        "parent": "711500"
                    },
                    {
                        "label": "泰安乡",
                        "value": "711595",
                        "parent": "711500"
                    },
                    {
                        "label": "铜锣乡",
                        "value": "711596",
                        "parent": "711500"
                    },
                    {
                        "label": "三义乡",
                        "value": "711597",
                        "parent": "711500"
                    },
                    {
                        "label": "西湖乡",
                        "value": "711598",
                        "parent": "711500"
                    },
                    {
                        "label": "卓兰镇",
                        "value": "711599",
                        "parent": "711500"
                    }
                ]
            },
            {
                "value": "711700",
                "label": "彰化县",
                "parent": "710000",
                "children": [
                    {
                        "label": "员林市",
                        "value": "711736",
                        "parent": "711700"
                    },
                    {
                        "label": "彰化市",
                        "value": "711774",
                        "parent": "711700"
                    },
                    {
                        "label": "芬园乡",
                        "value": "711775",
                        "parent": "711700"
                    },
                    {
                        "label": "花坛乡",
                        "value": "711776",
                        "parent": "711700"
                    },
                    {
                        "label": "秀水乡",
                        "value": "711777",
                        "parent": "711700"
                    },
                    {
                        "label": "鹿港镇",
                        "value": "711778",
                        "parent": "711700"
                    },
                    {
                        "label": "福兴乡",
                        "value": "711779",
                        "parent": "711700"
                    },
                    {
                        "label": "线西乡",
                        "value": "711780",
                        "parent": "711700"
                    },
                    {
                        "label": "和美镇",
                        "value": "711781",
                        "parent": "711700"
                    },
                    {
                        "label": "伸港乡",
                        "value": "711782",
                        "parent": "711700"
                    },
                    {
                        "label": "员林镇",
                        "value": "711783",
                        "parent": "711700"
                    },
                    {
                        "label": "社头乡",
                        "value": "711784",
                        "parent": "711700"
                    },
                    {
                        "label": "永靖乡",
                        "value": "711785",
                        "parent": "711700"
                    },
                    {
                        "label": "埔心乡",
                        "value": "711786",
                        "parent": "711700"
                    },
                    {
                        "label": "溪湖镇",
                        "value": "711787",
                        "parent": "711700"
                    },
                    {
                        "label": "大村乡",
                        "value": "711788",
                        "parent": "711700"
                    },
                    {
                        "label": "埔盐乡",
                        "value": "711789",
                        "parent": "711700"
                    },
                    {
                        "label": "田中镇",
                        "value": "711790",
                        "parent": "711700"
                    },
                    {
                        "label": "北斗镇",
                        "value": "711791",
                        "parent": "711700"
                    },
                    {
                        "label": "田尾乡",
                        "value": "711792",
                        "parent": "711700"
                    },
                    {
                        "label": "埤头乡",
                        "value": "711793",
                        "parent": "711700"
                    },
                    {
                        "label": "溪州乡",
                        "value": "711794",
                        "parent": "711700"
                    },
                    {
                        "label": "竹塘乡",
                        "value": "711795",
                        "parent": "711700"
                    },
                    {
                        "label": "二林镇",
                        "value": "711796",
                        "parent": "711700"
                    },
                    {
                        "label": "大城乡",
                        "value": "711797",
                        "parent": "711700"
                    },
                    {
                        "label": "芳苑乡",
                        "value": "711798",
                        "parent": "711700"
                    },
                    {
                        "label": "二水乡",
                        "value": "711799",
                        "parent": "711700"
                    }
                ]
            },
            {
                "value": "711900",
                "label": "嘉义县",
                "parent": "710000",
                "children": [
                    {
                        "label": "番路乡",
                        "value": "711982",
                        "parent": "711900"
                    },
                    {
                        "label": "梅山乡",
                        "value": "711983",
                        "parent": "711900"
                    },
                    {
                        "label": "竹崎乡",
                        "value": "711984",
                        "parent": "711900"
                    },
                    {
                        "label": "阿里山乡",
                        "value": "711985",
                        "parent": "711900"
                    },
                    {
                        "label": "中埔乡",
                        "value": "711986",
                        "parent": "711900"
                    },
                    {
                        "label": "大埔乡",
                        "value": "711987",
                        "parent": "711900"
                    },
                    {
                        "label": "水上乡",
                        "value": "711988",
                        "parent": "711900"
                    },
                    {
                        "label": "鹿草乡",
                        "value": "711989",
                        "parent": "711900"
                    },
                    {
                        "label": "太保市",
                        "value": "711990",
                        "parent": "711900"
                    },
                    {
                        "label": "朴子市",
                        "value": "711991",
                        "parent": "711900"
                    },
                    {
                        "label": "东石乡",
                        "value": "711992",
                        "parent": "711900"
                    },
                    {
                        "label": "六脚乡",
                        "value": "711993",
                        "parent": "711900"
                    },
                    {
                        "label": "新港乡",
                        "value": "711994",
                        "parent": "711900"
                    },
                    {
                        "label": "民雄乡",
                        "value": "711995",
                        "parent": "711900"
                    },
                    {
                        "label": "大林镇",
                        "value": "711996",
                        "parent": "711900"
                    },
                    {
                        "label": "溪口乡",
                        "value": "711997",
                        "parent": "711900"
                    },
                    {
                        "label": "义竹乡",
                        "value": "711998",
                        "parent": "711900"
                    },
                    {
                        "label": "布袋镇",
                        "value": "711999",
                        "parent": "711900"
                    }
                ]
            },
            {
                "value": "712100",
                "label": "云林县",
                "parent": "710000",
                "children": [
                    {
                        "label": "斗南镇",
                        "value": "712180",
                        "parent": "712100"
                    },
                    {
                        "label": "大埤乡",
                        "value": "712181",
                        "parent": "712100"
                    },
                    {
                        "label": "虎尾镇",
                        "value": "712182",
                        "parent": "712100"
                    },
                    {
                        "label": "土库镇",
                        "value": "712183",
                        "parent": "712100"
                    },
                    {
                        "label": "褒忠乡",
                        "value": "712184",
                        "parent": "712100"
                    },
                    {
                        "label": "东势乡",
                        "value": "712185",
                        "parent": "712100"
                    },
                    {
                        "label": "台西乡",
                        "value": "712186",
                        "parent": "712100"
                    },
                    {
                        "label": "仑背乡",
                        "value": "712187",
                        "parent": "712100"
                    },
                    {
                        "label": "麦寮乡",
                        "value": "712188",
                        "parent": "712100"
                    },
                    {
                        "label": "斗六市",
                        "value": "712189",
                        "parent": "712100"
                    },
                    {
                        "label": "林内乡",
                        "value": "712190",
                        "parent": "712100"
                    },
                    {
                        "label": "古坑乡",
                        "value": "712191",
                        "parent": "712100"
                    },
                    {
                        "label": "莿桐乡",
                        "value": "712192",
                        "parent": "712100"
                    },
                    {
                        "label": "西螺镇",
                        "value": "712193",
                        "parent": "712100"
                    },
                    {
                        "label": "二仑乡",
                        "value": "712194",
                        "parent": "712100"
                    },
                    {
                        "label": "北港镇",
                        "value": "712195",
                        "parent": "712100"
                    },
                    {
                        "label": "水林乡",
                        "value": "712196",
                        "parent": "712100"
                    },
                    {
                        "label": "口湖乡",
                        "value": "712197",
                        "parent": "712100"
                    },
                    {
                        "label": "四湖乡",
                        "value": "712198",
                        "parent": "712100"
                    },
                    {
                        "label": "元长乡",
                        "value": "712199",
                        "parent": "712100"
                    }
                ]
            },
            {
                "value": "712400",
                "label": "屏东县",
                "parent": "710000",
                "children": [
                    {
                        "label": "崁顶乡",
                        "value": "712451",
                        "parent": "712400"
                    },
                    {
                        "label": "屏东市",
                        "value": "712467",
                        "parent": "712400"
                    },
                    {
                        "label": "三地门乡",
                        "value": "712468",
                        "parent": "712400"
                    },
                    {
                        "label": "雾台乡",
                        "value": "712469",
                        "parent": "712400"
                    },
                    {
                        "label": "玛家乡",
                        "value": "712470",
                        "parent": "712400"
                    },
                    {
                        "label": "九如乡",
                        "value": "712471",
                        "parent": "712400"
                    },
                    {
                        "label": "里港乡",
                        "value": "712472",
                        "parent": "712400"
                    },
                    {
                        "label": "高树乡",
                        "value": "712473",
                        "parent": "712400"
                    },
                    {
                        "label": "盐埔乡",
                        "value": "712474",
                        "parent": "712400"
                    },
                    {
                        "label": "长治乡",
                        "value": "712475",
                        "parent": "712400"
                    },
                    {
                        "label": "麟洛乡",
                        "value": "712476",
                        "parent": "712400"
                    },
                    {
                        "label": "竹田乡",
                        "value": "712477",
                        "parent": "712400"
                    },
                    {
                        "label": "内埔乡",
                        "value": "712478",
                        "parent": "712400"
                    },
                    {
                        "label": "万丹乡",
                        "value": "712479",
                        "parent": "712400"
                    },
                    {
                        "label": "潮州镇",
                        "value": "712480",
                        "parent": "712400"
                    },
                    {
                        "label": "泰武乡",
                        "value": "712481",
                        "parent": "712400"
                    },
                    {
                        "label": "来义乡",
                        "value": "712482",
                        "parent": "712400"
                    },
                    {
                        "label": "万峦乡",
                        "value": "712483",
                        "parent": "712400"
                    },
                    {
                        "label": "莰顶乡",
                        "value": "712484",
                        "parent": "712400"
                    },
                    {
                        "label": "新埤乡",
                        "value": "712485",
                        "parent": "712400"
                    },
                    {
                        "label": "南州乡",
                        "value": "712486",
                        "parent": "712400"
                    },
                    {
                        "label": "林边乡",
                        "value": "712487",
                        "parent": "712400"
                    },
                    {
                        "label": "东港镇",
                        "value": "712488",
                        "parent": "712400"
                    },
                    {
                        "label": "琉球乡",
                        "value": "712489",
                        "parent": "712400"
                    },
                    {
                        "label": "佳冬乡",
                        "value": "712490",
                        "parent": "712400"
                    },
                    {
                        "label": "新园乡",
                        "value": "712491",
                        "parent": "712400"
                    },
                    {
                        "label": "枋寮乡",
                        "value": "712492",
                        "parent": "712400"
                    },
                    {
                        "label": "枋山乡",
                        "value": "712493",
                        "parent": "712400"
                    },
                    {
                        "label": "春日乡",
                        "value": "712494",
                        "parent": "712400"
                    },
                    {
                        "label": "狮子乡",
                        "value": "712495",
                        "parent": "712400"
                    },
                    {
                        "label": "车城乡",
                        "value": "712496",
                        "parent": "712400"
                    },
                    {
                        "label": "牡丹乡",
                        "value": "712497",
                        "parent": "712400"
                    },
                    {
                        "label": "恒春镇",
                        "value": "712498",
                        "parent": "712400"
                    },
                    {
                        "label": "满州乡",
                        "value": "712499",
                        "parent": "712400"
                    }
                ]
            },
            {
                "value": "712500",
                "label": "台东县",
                "parent": "710000",
                "children": [
                    {
                        "label": "台东市",
                        "value": "712584",
                        "parent": "712500"
                    },
                    {
                        "label": "绿岛乡",
                        "value": "712585",
                        "parent": "712500"
                    },
                    {
                        "label": "兰屿乡",
                        "value": "712586",
                        "parent": "712500"
                    },
                    {
                        "label": "延平乡",
                        "value": "712587",
                        "parent": "712500"
                    },
                    {
                        "label": "卑南乡",
                        "value": "712588",
                        "parent": "712500"
                    },
                    {
                        "label": "鹿野乡",
                        "value": "712589",
                        "parent": "712500"
                    },
                    {
                        "label": "关山镇",
                        "value": "712590",
                        "parent": "712500"
                    },
                    {
                        "label": "海端乡",
                        "value": "712591",
                        "parent": "712500"
                    },
                    {
                        "label": "池上乡",
                        "value": "712592",
                        "parent": "712500"
                    },
                    {
                        "label": "东河乡",
                        "value": "712593",
                        "parent": "712500"
                    },
                    {
                        "label": "成功镇",
                        "value": "712594",
                        "parent": "712500"
                    },
                    {
                        "label": "长滨乡",
                        "value": "712595",
                        "parent": "712500"
                    },
                    {
                        "label": "金峰乡",
                        "value": "712596",
                        "parent": "712500"
                    },
                    {
                        "label": "大武乡",
                        "value": "712597",
                        "parent": "712500"
                    },
                    {
                        "label": "达仁乡",
                        "value": "712598",
                        "parent": "712500"
                    },
                    {
                        "label": "太麻里乡",
                        "value": "712599",
                        "parent": "712500"
                    }
                ]
            },
            {
                "value": "712600",
                "label": "花莲县",
                "parent": "710000",
                "children": [
                    {
                        "label": "花莲市",
                        "value": "712686",
                        "parent": "712600"
                    },
                    {
                        "label": "新城乡",
                        "value": "712687",
                        "parent": "712600"
                    },
                    {
                        "label": "太鲁阁",
                        "value": "712688",
                        "parent": "712600"
                    },
                    {
                        "label": "秀林乡",
                        "value": "712689",
                        "parent": "712600"
                    },
                    {
                        "label": "吉安乡",
                        "value": "712690",
                        "parent": "712600"
                    },
                    {
                        "label": "寿丰乡",
                        "value": "712691",
                        "parent": "712600"
                    },
                    {
                        "label": "凤林镇",
                        "value": "712692",
                        "parent": "712600"
                    },
                    {
                        "label": "光复乡",
                        "value": "712693",
                        "parent": "712600"
                    },
                    {
                        "label": "丰滨乡",
                        "value": "712694",
                        "parent": "712600"
                    },
                    {
                        "label": "瑞穗乡",
                        "value": "712695",
                        "parent": "712600"
                    },
                    {
                        "label": "万荣乡",
                        "value": "712696",
                        "parent": "712600"
                    },
                    {
                        "label": "玉里镇",
                        "value": "712697",
                        "parent": "712600"
                    },
                    {
                        "label": "卓溪乡",
                        "value": "712698",
                        "parent": "712600"
                    },
                    {
                        "label": "富里乡",
                        "value": "712699",
                        "parent": "712600"
                    }
                ]
            },
            {
                "value": "712700",
                "label": "澎湖县",
                "parent": "710000",
                "children": [
                    {
                        "label": "马公市",
                        "value": "712794",
                        "parent": "712700"
                    },
                    {
                        "label": "西屿乡",
                        "value": "712795",
                        "parent": "712700"
                    },
                    {
                        "label": "望安乡",
                        "value": "712796",
                        "parent": "712700"
                    },
                    {
                        "label": "七美乡",
                        "value": "712797",
                        "parent": "712700"
                    },
                    {
                        "label": "白沙乡",
                        "value": "712798",
                        "parent": "712700"
                    },
                    {
                        "label": "湖西乡",
                        "value": "712799",
                        "parent": "712700"
                    }
                ]
            },
            {
                "value": "712800",
                "label": "连江县",
                "parent": "710000",
                "children": [
                    {
                        "label": "南竿乡",
                        "value": "712896",
                        "parent": "712800"
                    },
                    {
                        "label": "北竿乡",
                        "value": "712897",
                        "parent": "712800"
                    },
                    {
                        "label": "东引乡",
                        "value": "712898",
                        "parent": "712800"
                    },
                    {
                        "label": "莒光乡",
                        "value": "712899",
                        "parent": "712800"
                    }
                ]
            }
        ]
    },
    {
        "value": "810000",
        "label": "香港特别行政区",
        "children": [
            {
                "value": "810100",
                "label": "香港岛",
                "parent": "810000",
                "children": [
                    {
                        "label": "中西区",
                        "value": "810101",
                        "parent": "810100"
                    },
                    {
                        "label": "湾仔区",
                        "value": "810102",
                        "parent": "810100"
                    },
                    {
                        "label": "东区",
                        "value": "810103",
                        "parent": "810100"
                    },
                    {
                        "label": "南区",
                        "value": "810104",
                        "parent": "810100"
                    }
                ]
            },
            {
                "value": "810200",
                "label": "九龙",
                "parent": "810000",
                "children": [
                    {
                        "label": "九龙城区",
                        "value": "810201",
                        "parent": "810200"
                    },
                    {
                        "label": "油尖旺区",
                        "value": "810202",
                        "parent": "810200"
                    },
                    {
                        "label": "深水埗区",
                        "value": "810203",
                        "parent": "810200"
                    },
                    {
                        "label": "黄大仙区",
                        "value": "810204",
                        "parent": "810200"
                    },
                    {
                        "label": "观塘区",
                        "value": "810205",
                        "parent": "810200"
                    }
                ]
            },
            {
                "value": "810300",
                "label": "新界",
                "parent": "810000",
                "children": [
                    {
                        "label": "北区",
                        "value": "810301",
                        "parent": "810300"
                    },
                    {
                        "label": "大埔区",
                        "value": "810302",
                        "parent": "810300"
                    },
                    {
                        "label": "沙田区",
                        "value": "810303",
                        "parent": "810300"
                    },
                    {
                        "label": "西贡区",
                        "value": "810304",
                        "parent": "810300"
                    },
                    {
                        "label": "元朗区",
                        "value": "810305",
                        "parent": "810300"
                    },
                    {
                        "label": "屯门区",
                        "value": "810306",
                        "parent": "810300"
                    },
                    {
                        "label": "荃湾区",
                        "value": "810307",
                        "parent": "810300"
                    },
                    {
                        "label": "葵青区",
                        "value": "810308",
                        "parent": "810300"
                    },
                    {
                        "label": "离岛区",
                        "value": "810309",
                        "parent": "810300"
                    }
                ]
            }
        ]
    },
    {
        "value": "820000",
        "label": "澳门特别行政区",
        "children": [
            {
                "value": "820100",
                "label": "澳门半岛",
                "parent": "820000",
                "children": [
                    {
                        "label": "花地玛堂区",
                        "value": "820102",
                        "parent": "820100"
                    },
                    {
                        "label": "花王堂区",
                        "value": "820103",
                        "parent": "820100"
                    },
                    {
                        "label": "望德堂区",
                        "value": "820104",
                        "parent": "820100"
                    },
                    {
                        "label": "大堂区",
                        "value": "820105",
                        "parent": "820100"
                    },
                    {
                        "label": "风顺堂区",
                        "value": "820106",
                        "parent": "820100"
                    }
                ]
            },
            {
                "value": "820200",
                "label": "离岛",
                "parent": "820000",
                "children": [
                    {
                        "label": "嘉模堂区",
                        "value": "820202",
                        "parent": "820200"
                    },
                    {
                        "label": "路氹填海区",
                        "value": "820203",
                        "parent": "820200"
                    },
                    {
                        "label": "圣方济各堂区",
                        "value": "820204",
                        "parent": "820200"
                    }
                ]
            }
        ]
    },
    {
        "value": "990000",
        "label": "海外",
        "children": [
            {
                "value": "990100",
                "label": "海外",
                "parent": "990000",
                "children": []
            }
        ]
    }
]